import { A as bo, C as Ye, N as Pu, O as ku, T as Ou, a as Lu, i as Nu, j as yo, k as ou, n as Eo, o as yc, r as io, s as Ec, t as uu } from "./base-DpxiM7W9.mjs.js";
import { _ as Du, a as mu, c as Bu, d as zu, f as Hu, g as Wu, h as Uu, i as Gu, l as Yu, m as Xu, n as Zu, p as Ju, r as eu, t as tu, u as vc, v as Qu, y as Vu } from "./recentSearches-PRg0o-NF.mjs.js";
var Ku = [["circle", {
  cx: "12",
  cy: "12",
  r: "10",
  key: "1mglay"
}], ["path", {
  d: "M12 6v6l4 2",
  key: "mmk7yg"
}]], pu = Ec("clock", Ku), qu = [["path", {
  d: "M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5",
  key: "mvr1a0"
}]], ju = Ec("heart", qu), $u = [["path", {
  d: "m21 21-4.34-4.34",
  key: "14j7rj"
}], ["circle", {
  cx: "11",
  cy: "11",
  r: "8",
  key: "4ej97u"
}]], nf = Ec("search", $u), ef = [["path", {
  d: "M16 7h6v6",
  key: "box55l"
}], ["path", {
  d: "m22 7-8.5 8.5-5-5L2 17",
  key: "1t1m79"
}]], tf = Ec("trending-up", ef), Gn = /* @__PURE__ */ Pu(bo());
function lf(h, g) {
  g === void 0 && (g = 0);
  var b = (0, Gn.useRef)(!1), s = (0, Gn.useRef)(), x = (0, Gn.useRef)(h), C = (0, Gn.useCallback)(function() {
    return b.current;
  }, []), S = (0, Gn.useCallback)(function() {
    b.current = !1, s.current && clearTimeout(s.current), s.current = setTimeout(function() {
      b.current = !0, x.current();
    }, g);
  }, [g]), M = (0, Gn.useCallback)(function() {
    b.current = null, s.current && clearTimeout(s.current);
  }, []);
  return (0, Gn.useEffect)(function() {
    x.current = h;
  }, [h]), (0, Gn.useEffect)(function() {
    return S(), M;
  }, [g]), [
    C,
    M,
    S
  ];
}
function rf(h, g, b) {
  g === void 0 && (g = 0), b === void 0 && (b = []);
  var s = lf(h, g), x = s[0], C = s[1], S = s[2];
  return (0, Gn.useEffect)(S, b), [x, C];
}
var af = function(h) {
  return typeof h == "function" ? h : typeof h == "string" ? function(g) {
    return g.key === h;
  } : h ? function() {
    return !0;
  } : function() {
    return !1;
  };
}, ro = function(h, g, b, s) {
  g === void 0 && (g = Hu), b === void 0 && (b = {}), s === void 0 && (s = [h]);
  var x = b.event, C = x === void 0 ? "keydown" : x, S = b.target, M = b.options;
  vc(C, (0, Gn.useMemo)(function() {
    var O = af(h), D = function(N) {
      if (O(N)) return g(N);
    };
    return D;
  }, s), S, M);
};
function fu(h, g) {
  window.dispatchEvent(new CustomEvent(h, g ? { detail: g } : void 0));
}
function ao(h) {
  const g = h.getAttribute("data-event");
  if (!g) return;
  let b;
  const s = h.getAttribute("data-event-detail");
  if (s) try {
    b = JSON.parse(s);
  } catch {
  }
  fu(g, b);
}
function co(h, g) {
  const b = h.indexOf(":");
  if (b === -1) return null;
  const s = h.substring(0, b), x = h.substring(b + 1);
  return {
    eventName: `${s}:${g}`,
    prefix: s,
    id: x
  };
}
function lu(h, g, b) {
  const s = (x) => {
    b && x.detail?.id !== b || (window.removeEventListener(g, s), h());
  };
  window.addEventListener(g, s);
}
window.addEventListener("click", (h) => {
  const g = h.target, b = g.closest("[data-toggle]") || g.closest("[data-close]") || g.closest("[data-event]") || g.closest('a[href^="#"]');
  if (!b) return;
  const s = b.getAttribute("data-toggle"), x = b.getAttribute("data-close"), C = s ? co(s, "toggle") : null, S = x ? co(x, "close") : null;
  let M = null;
  if (b.tagName === "A") {
    const D = b.getAttribute("href");
    D?.startsWith("#") && (M = co(D.substring(1), "open"));
  }
  const O = C || S || M;
  if (O?.eventName && !b.id && (b.id = `target-${Math.random().toString(36).substring(2, 15)}`, h.preventDefault()), b.hasAttribute("data-event")) {
    const D = b.getAttribute("data-event-after"), N = b.getAttribute("data-event-after-id");
    if (D) lu(() => ao(b), D, N || O?.id);
    else if (C || M) {
      const W = C || M;
      lu(() => ao(b), `${W.prefix}:opened`, W.id);
    } else ao(b);
  }
  O && fu(O.eventName, {
    id: O.id,
    triggerId: b.id
  });
}, !0);
var su = "_sh_gclid_history", uo = "_gcl_ls", cf = "_sh_gbraid", of = "_sh_wbraid", uf = 90;
function ff() {
  try {
    const h = window.localStorage.getItem(su);
    return h ? JSON.parse(h) : [];
  } catch {
    return [];
  }
}
function sf(h) {
  window.localStorage.setItem(su, JSON.stringify(h));
}
function hf(h) {
  const g = Date.now();
  return h.filter((b) => b.expire > g);
}
function fo() {
  try {
    const h = window.localStorage.getItem(uo);
    if (!h) return;
    const g = JSON.parse(h);
    if (!g.gclid?.value?.value) return;
    const b = g.gclid.value.value, s = g.gclid.value.creationTimeMs, x = g.gclid.expires;
    if (x <= Date.now()) return;
    const C = hf(ff());
    C.some((S) => S.gclid === b) || (C.push({
      gclid: b,
      created: s,
      expire: x
    }), sf(C));
  } catch (h) {
    console.error("Error tracking gclid:", h);
  }
}
function iu(h, g, b) {
  try {
    window.localStorage.setItem(h, JSON.stringify({
      value: g,
      expire: b
    }));
  } catch (s) {
    console.error("Error saving braid:", s);
  }
}
function df() {
  try {
    const h = new URLSearchParams(window.location.search), g = h.get("gbraid"), b = h.get("wbraid"), s = Date.now() + uf * 24 * 60 * 60 * 1e3;
    g && iu(cf, g, s), b && iu(of, b, s);
  } catch (h) {
    console.error("Error capturing braid from URL:", h);
  }
}
function gf() {
  const h = window.localStorage.setItem.bind(window.localStorage);
  window.localStorage.setItem = (g, b) => {
    h(g, b), g === uo && fo();
  }, window.addEventListener("storage", (g) => {
    g.key === uo && g.newValue && fo();
  });
}
function vf() {
  gf(), fo(), df();
}
vf();
window.addEventListener("class:toggle", (h) => {
  const { id: g, triggerId: b } = h.detail;
  if (!g || !b) return;
  const s = document.getElementById(b);
  if (!s) return;
  const { class: x, self: C } = s.dataset, S = document.getElementById(g);
  S && (x && S.classList.toggle(x), C && s.classList.toggle(C), s.getAttribute("aria-expanded") !== null && s.setAttribute("aria-expanded", s.getAttribute("aria-expanded") === "true" ? "false" : "true"));
});
function To(h) {
  return typeof h == "number";
}
function so(h) {
  return typeof h == "string";
}
function Tc(h) {
  return typeof h == "boolean";
}
function ru(h) {
  return Object.prototype.toString.call(h) === "[object Object]";
}
function ne(h) {
  return Math.abs(h);
}
function xo(h) {
  return Math.sign(h);
}
function Ca(h, g) {
  return ne(h - g);
}
function bf(h, g) {
  return h === 0 || g === 0 || ne(h) <= ne(g) ? 0 : ne(Ca(ne(h), ne(g)) / h);
}
function yf(h) {
  return Math.round(h * 100) / 100;
}
function Ra(h) {
  return Sa(h).map(Number);
}
function Mt(h) {
  return h[Fa(h)];
}
function Fa(h) {
  return Math.max(0, h.length - 1);
}
function wo(h, g) {
  return g === Fa(h);
}
function au(h, g = 0) {
  return Array.from(Array(h), (b, s) => g + s);
}
function Sa(h) {
  return Object.keys(h);
}
function hu(h, g) {
  return [h, g].reduce((b, s) => (Sa(s).forEach((x) => {
    const C = b[x], S = s[x];
    b[x] = ru(C) && ru(S) ? hu(C, S) : S;
  }), b), {});
}
function ho(h, g) {
  return typeof g.MouseEvent < "u" && h instanceof g.MouseEvent;
}
function Ef(h, g) {
  const b = {
    start: s,
    center: x,
    end: C
  };
  function s() {
    return 0;
  }
  function x(M) {
    return C(M) / 2;
  }
  function C(M) {
    return g - M;
  }
  function S(M, O) {
    return so(h) ? b[h](M) : h(g, M, O);
  }
  return { measure: S };
}
function Ma() {
  let h = [];
  function g(x, C, S, M = { passive: !0 }) {
    let O;
    if ("addEventListener" in x)
      x.addEventListener(C, S, M), O = () => x.removeEventListener(C, S, M);
    else {
      const D = x;
      D.addListener(S), O = () => D.removeListener(S);
    }
    return h.push(O), s;
  }
  function b() {
    h = h.filter((x) => x());
  }
  const s = {
    add: g,
    clear: b
  };
  return s;
}
function Tf(h, g, b, s) {
  const x = Ma(), C = 1e3 / 60;
  let S = null, M = 0, O = 0;
  function D() {
    x.add(h, "visibilitychange", () => {
      h.hidden && B();
    });
  }
  function N() {
    U(), x.clear();
  }
  function W(Y) {
    if (!O) return;
    S || (S = Y, b(), b());
    const J = Y - S;
    for (S = Y, M += J; M >= C; )
      b(), M -= C;
    s(M / C), O && (O = g.requestAnimationFrame(W));
  }
  function z() {
    O || (O = g.requestAnimationFrame(W));
  }
  function U() {
    g.cancelAnimationFrame(O), S = null, M = 0, O = 0;
  }
  function B() {
    S = null, M = 0;
  }
  return {
    init: D,
    destroy: N,
    start: z,
    stop: U,
    update: b,
    render: s
  };
}
function xf(h, g) {
  const b = g === "rtl", s = h === "y", x = s ? "y" : "x", C = s ? "x" : "y", S = !s && b ? -1 : 1, M = N(), O = W();
  function D(U) {
    const { height: B, width: Y } = U;
    return s ? B : Y;
  }
  function N() {
    return s ? "top" : b ? "right" : "left";
  }
  function W() {
    return s ? "bottom" : b ? "left" : "right";
  }
  function z(U) {
    return U * S;
  }
  return {
    scroll: x,
    cross: C,
    startEdge: M,
    endEdge: O,
    measureSize: D,
    direction: z
  };
}
function ki(h = 0, g = 0) {
  const b = ne(h - g);
  function s(O) {
    return O < h;
  }
  function x(O) {
    return O > g;
  }
  function C(O) {
    return s(O) || x(O);
  }
  function S(O) {
    return C(O) ? s(O) ? h : g : O;
  }
  function M(O) {
    return b ? O - b * Math.ceil((O - g) / b) : O;
  }
  return {
    length: b,
    max: g,
    min: h,
    constrain: S,
    reachedAny: C,
    reachedMax: x,
    reachedMin: s,
    removeOffset: M
  };
}
function du(h, g, b) {
  const { constrain: s } = ki(0, h), x = h + 1;
  let C = S(g);
  function S(z) {
    return b ? ne((x + z) % x) : s(z);
  }
  function M() {
    return C;
  }
  function O(z) {
    return C = S(z), W;
  }
  function D(z) {
    return N().set(M() + z);
  }
  function N() {
    return du(h, M(), b);
  }
  const W = {
    get: M,
    set: O,
    add: D,
    clone: N
  };
  return W;
}
function wf(h, g, b, s, x, C, S, M, O, D, N, W, z, U, B, Y, J, H, $) {
  const { cross: bn, direction: En } = h, hn = [
    "INPUT",
    "SELECT",
    "TEXTAREA"
  ], p = { passive: !1 }, ln = Ma(), on = Ma(), cn = ki(50, 225).constrain(U.measure(20)), nn = {
    mouse: 300,
    touch: 400
  }, An = {
    mouse: 500,
    touch: 600
  }, ae = B ? 43 : 25;
  let _n = !1, Kn = 0, In = 0, On = !1, _ = !1, V = !1, gn = !1;
  function Nn(q) {
    if (!$) return;
    function tn(j) {
      (Tc($) || $(q, j)) && rn(j);
    }
    const Mn = g;
    ln.add(Mn, "dragstart", (j) => j.preventDefault(), p).add(Mn, "touchmove", () => {
    }, p).add(Mn, "touchend", () => {
    }).add(Mn, "touchstart", tn).add(Mn, "mousedown", tn).add(Mn, "touchcancel", Xn).add(Mn, "contextmenu", Xn).add(Mn, "click", tt, !0);
  }
  function G() {
    ln.clear(), on.clear();
  }
  function k() {
    const q = gn ? b : g;
    on.add(q, "touchmove", Yn, p).add(q, "touchend", Xn).add(q, "mousemove", Yn, p).add(q, "mouseup", Xn);
  }
  function ee(q) {
    const tn = q.nodeName || "";
    return hn.includes(tn);
  }
  function ft() {
    return (B ? An : nn)[gn ? "mouse" : "touch"];
  }
  function te(q, tn) {
    const Mn = W.add(xo(q) * -1), j = N.byDistance(q, !B).distance;
    return B || ne(q) < cn ? j : J && tn ? j * 0.5 : N.byIndex(Mn.get(), 0).distance;
  }
  function rn(q) {
    const tn = ho(q, s);
    gn = tn, V = B && tn && !q.buttons && _n, _n = Ca(x.get(), S.get()) >= 2, !(tn && q.button !== 0) && (ee(q.target) || (On = !0, C.pointerDown(q), D.useFriction(0).useDuration(0), x.set(S), k(), Kn = C.readPoint(q), In = C.readPoint(q, bn), z.emit("pointerDown")));
  }
  function Yn(q) {
    if (!ho(q, s) && q.touches.length >= 2) return Xn(q);
    const tn = C.readPoint(q), Mn = C.readPoint(q, bn), j = Ca(tn, Kn), Ne = Ca(Mn, In);
    if (!_ && !gn && (!q.cancelable || (_ = j > Ne, !_)))
      return Xn(q);
    const De = C.pointerMove(q);
    j > Y && (V = !0), D.useFriction(0.3).useDuration(0.75), M.start(), x.add(En(De)), q.preventDefault();
  }
  function Xn(q) {
    const tn = N.byDistance(0, !1).index !== W.get(), Mn = C.pointerUp(q) * ft(), j = te(En(Mn), tn), Ne = bf(Mn, j), De = ae - 10 * Ne, Ft = H + Ne / 50;
    _ = !1, On = !1, on.clear(), D.useDuration(De).useFriction(Ft), O.distance(j, !B), gn = !1, z.emit("pointerUp");
  }
  function tt(q) {
    V && (q.stopPropagation(), q.preventDefault(), V = !1);
  }
  function he() {
    return On;
  }
  return {
    init: Nn,
    destroy: G,
    pointerDown: he
  };
}
function Cf(h, g) {
  let s, x;
  function C(N) {
    return N.timeStamp;
  }
  function S(N, W) {
    const z = `client${(W || h.scroll) === "x" ? "X" : "Y"}`;
    return (ho(N, g) ? N : N.touches[0])[z];
  }
  function M(N) {
    return s = N, x = N, S(N);
  }
  function O(N) {
    const W = S(N) - S(x), z = C(N) - C(s) > 170;
    return x = N, z && (s = N), W;
  }
  function D(N) {
    if (!s || !x) return 0;
    const W = S(x) - S(s), z = C(N) - C(s), U = C(N) - C(x) > 170, B = W / z;
    return z && !U && ne(B) > 0.1 ? B : 0;
  }
  return {
    pointerDown: M,
    pointerMove: O,
    pointerUp: D,
    readPoint: S
  };
}
function Rf() {
  function h(g) {
    const { offsetTop: b, offsetLeft: s, offsetWidth: x, offsetHeight: C } = g;
    return {
      top: b,
      right: s + x,
      bottom: b + C,
      left: s,
      width: x,
      height: C
    };
  }
  return { measure: h };
}
function Sf(h) {
  function g(b) {
    return h * (b / 100);
  }
  return { measure: g };
}
function Mf(h, g, b, s, x, C, S) {
  const M = [h].concat(s);
  let O, D, N = [], W = !1;
  function z(Y) {
    return x.measureSize(S.measure(Y));
  }
  function U(Y) {
    if (!C) return;
    D = z(h), N = s.map(z);
    function J(H) {
      for (const $ of H) {
        if (W) return;
        const bn = $.target === h, En = s.indexOf($.target), hn = bn ? D : N[En];
        if (ne(z(bn ? h : s[En]) - hn) >= 0.5) {
          Y.reInit(), g.emit("resize");
          break;
        }
      }
    }
    O = new ResizeObserver((H) => {
      (Tc(C) || C(Y, H)) && J(H);
    }), b.requestAnimationFrame(() => {
      M.forEach((H) => O.observe(H));
    });
  }
  function B() {
    W = !0, O && O.disconnect();
  }
  return {
    init: U,
    destroy: B
  };
}
function Ff(h, g, b, s, x, C) {
  let S = 0, M = 0, O = x, D = C, N = h.get(), W = 0;
  function z() {
    const p = s.get() - h.get(), ln = !O;
    let on = 0;
    return ln ? (S = 0, b.set(s), h.set(s), on = p) : (b.set(h), S += p / O, S *= D, N += S, h.add(S), on = N - W), M = xo(on), W = N, hn;
  }
  function U() {
    return ne(s.get() - g.get()) < 1e-3;
  }
  function B() {
    return O;
  }
  function Y() {
    return M;
  }
  function J() {
    return S;
  }
  function H() {
    return bn(x);
  }
  function $() {
    return En(C);
  }
  function bn(p) {
    return O = p, hn;
  }
  function En(p) {
    return D = p, hn;
  }
  const hn = {
    direction: Y,
    duration: B,
    velocity: J,
    seek: z,
    settled: U,
    useBaseFriction: $,
    useBaseDuration: H,
    useFriction: En,
    useDuration: bn
  };
  return hn;
}
function If(h, g, b, s, x) {
  const C = x.measure(10), S = x.measure(50), M = ki(0.1, 0.99);
  let O = !1;
  function D() {
    return !(O || !h.reachedAny(b.get()) || !h.reachedAny(g.get()));
  }
  function N(z) {
    if (!D()) return;
    const U = ne(h[h.reachedMin(g.get()) ? "min" : "max"] - g.get()), B = b.get() - g.get(), Y = M.constrain(U / S);
    b.subtract(B * Y), !z && ne(B) < C && (b.set(h.constrain(b.get())), s.useDuration(25).useBaseFriction());
  }
  function W(z) {
    O = !z;
  }
  return {
    shouldConstrain: D,
    constrain: N,
    toggleActive: W
  };
}
function Af(h, g, b, s, x) {
  const C = ki(-g + h, 0), S = W(), M = N(), O = z();
  function D(U, B) {
    return Ca(U, B) <= 1;
  }
  function N() {
    const U = S[0], B = Mt(S);
    return ki(S.lastIndexOf(U), S.indexOf(B) + 1);
  }
  function W() {
    return b.map((U, B) => {
      const { min: Y, max: J } = C, H = C.constrain(U), $ = !B, bn = wo(b, B);
      return $ ? J : bn || D(Y, H) ? Y : D(J, H) ? J : H;
    }).map((U) => parseFloat(U.toFixed(3)));
  }
  function z() {
    if (g <= h + x) return [C.max];
    if (s === "keepSnaps") return S;
    const { min: U, max: B } = M;
    return S.slice(U, B);
  }
  return {
    snapsContained: O,
    scrollContainLimit: M
  };
}
function _f(h, g, b) {
  const s = g[0];
  return { limit: ki(b ? s - h : Mt(g), s) };
}
function Pf(h, g, b, s) {
  const { reachedMin: C, reachedMax: S } = ki(g.min + 0.1, g.max + 0.1);
  function M(D) {
    return D === 1 ? S(b.get()) : D === -1 ? C(b.get()) : !1;
  }
  function O(D) {
    if (!M(D)) return;
    const N = h * (D * -1);
    s.forEach((W) => W.add(N));
  }
  return { loop: O };
}
function kf(h) {
  const { max: g, length: b } = h;
  function s(x) {
    const C = x - g;
    return b ? C / -b : 0;
  }
  return { get: s };
}
function Of(h, g, b, s, x) {
  const { startEdge: C, endEdge: S } = h, { groupSlides: M } = x, O = W().map(g.measure), D = z(), N = U();
  function W() {
    return M(s).map((B) => Mt(B)[S] - B[0][C]).map(ne);
  }
  function z() {
    return s.map((B) => b[C] - B[C]).map((B) => -ne(B));
  }
  function U() {
    return M(D).map((B) => B[0]).map((B, Y) => B + O[Y]);
  }
  return {
    snaps: D,
    snapsAligned: N
  };
}
function Lf(h, g, b, s, x, C) {
  const { groupSlides: S } = x, { min: M, max: O } = s, D = N();
  function N() {
    const W = S(C), z = !h || g === "keepSnaps";
    return b.length === 1 ? [C] : z ? W : W.slice(M, O).map((U, B, Y) => {
      const J = !B, H = wo(Y, B);
      return J ? au(Mt(Y[0]) + 1) : H ? au(Fa(C) - Mt(Y)[0] + 1, Mt(Y)[0]) : U;
    });
  }
  return { slideRegistry: D };
}
function Nf(h, g, b, s, x) {
  const { reachedAny: C, removeOffset: S, constrain: M } = s;
  function O(U) {
    return U.concat().sort((B, Y) => ne(B) - ne(Y))[0];
  }
  function D(U) {
    const B = h ? S(U) : M(U), { index: Y } = g.map((J, H) => ({
      diff: N(J - B, 0),
      index: H
    })).sort((J, H) => ne(J.diff) - ne(H.diff))[0];
    return {
      index: Y,
      distance: B
    };
  }
  function N(U, B) {
    const Y = [
      U,
      U + b,
      U - b
    ];
    if (!h) return U;
    if (!B) return O(Y);
    const J = Y.filter((H) => xo(H) === B);
    return J.length ? O(J) : Mt(Y) - b;
  }
  function W(U, B) {
    return {
      index: U,
      distance: N(g[U] - x.get(), B)
    };
  }
  function z(U, B) {
    const Y = x.get() + U, { index: J, distance: H } = D(Y), $ = !h && C(Y);
    return !B || $ ? {
      index: J,
      distance: U
    } : {
      index: J,
      distance: U + N(g[J] - H, 0)
    };
  }
  return {
    byDistance: z,
    byIndex: W,
    shortcut: N
  };
}
function Df(h, g, b, s, x, C, S) {
  function M(N) {
    const W = N.distance, z = N.index !== g.get();
    C.add(W), W && (s.duration() ? h.start() : (h.update(), h.render(1), h.update())), z && (b.set(g.get()), g.set(N.index), S.emit("select"));
  }
  function O(N, W) {
    M(x.byDistance(N, W));
  }
  function D(N, W) {
    const z = g.clone().set(N);
    M(x.byIndex(z.get(), W));
  }
  return {
    distance: O,
    index: D
  };
}
function mf(h, g, b, s, x, C, S, M) {
  const O = {
    passive: !0,
    capture: !0
  };
  let D = 0;
  function N(z) {
    if (!M) return;
    function U(B) {
      if ((/* @__PURE__ */ new Date()).getTime() - D > 10) return;
      S.emit("slideFocusStart"), h.scrollLeft = 0;
      const Y = b.findIndex((J) => J.includes(B));
      To(Y) && (x.useDuration(0), s.index(Y, 0), S.emit("slideFocus"));
    }
    C.add(document, "keydown", W, !1), g.forEach((B, Y) => {
      C.add(B, "focus", (J) => {
        (Tc(M) || M(z, J)) && U(Y);
      }, O);
    });
  }
  function W(z) {
    z.code === "Tab" && (D = (/* @__PURE__ */ new Date()).getTime());
  }
  return { init: N };
}
function wa(h) {
  let g = h;
  function b() {
    return g;
  }
  function s(M) {
    g = S(M);
  }
  function x(M) {
    g += S(M);
  }
  function C(M) {
    g -= S(M);
  }
  function S(M) {
    return To(M) ? M : M.get();
  }
  return {
    get: b,
    set: s,
    add: x,
    subtract: C
  };
}
function gu(h, g) {
  const b = h.scroll === "x" ? S : M, s = g.style;
  let x = null, C = !1;
  function S(W) {
    return `translate3d(${W}px,0px,0px)`;
  }
  function M(W) {
    return `translate3d(0px,${W}px,0px)`;
  }
  function O(W) {
    if (C) return;
    const z = yf(h.direction(W));
    z !== x && (s.transform = b(z), x = z);
  }
  function D(W) {
    C = !W;
  }
  function N() {
    C || (s.transform = "", g.getAttribute("style") || g.removeAttribute("style"));
  }
  return {
    clear: N,
    to: O,
    toggleActive: D
  };
}
function Bf(h, g, b, s, x, C, S, M, O) {
  const N = Ra(x), W = Ra(x).reverse(), z = H().concat($());
  function U(p, ln) {
    return p.reduce((on, cn) => on - x[cn], ln);
  }
  function B(p, ln) {
    return p.reduce((on, cn) => U(on, ln) > 0 ? on.concat([cn]) : on, []);
  }
  function Y(p) {
    return C.map((ln, on) => ({
      start: ln - s[on] + 0.5 + p,
      end: ln + g - 0.5 + p
    }));
  }
  function J(p, ln, on) {
    const cn = Y(ln);
    return p.map((nn) => {
      const An = on ? 0 : -b, ae = on ? b : 0, _n = on ? "end" : "start", Kn = cn[nn][_n];
      return {
        index: nn,
        loopPoint: Kn,
        slideLocation: wa(-1),
        translate: gu(h, O[nn]),
        target: () => M.get() > Kn ? An : ae
      };
    });
  }
  function H() {
    const p = S[0];
    return J(B(W, p), b, !1);
  }
  function $() {
    return J(B(N, g - S[0] - 1), -b, !0);
  }
  function bn() {
    return z.every(({ index: p }) => U(N.filter((ln) => ln !== p), g) <= 0.1);
  }
  function En() {
    z.forEach((p) => {
      const { target: ln, translate: on, slideLocation: cn } = p, nn = ln();
      nn !== cn.get() && (on.to(nn), cn.set(nn));
    });
  }
  function hn() {
    z.forEach((p) => p.translate.clear());
  }
  return {
    canLoop: bn,
    clear: hn,
    loop: En,
    loopPoints: z
  };
}
function zf(h, g, b) {
  let s, x = !1;
  function C(M) {
    if (!b) return;
    function O(D) {
      for (const N of D) if (N.type === "childList") {
        M.reInit(), g.emit("slidesChanged");
        break;
      }
    }
    s = new MutationObserver((D) => {
      x || (Tc(b) || b(M, D)) && O(D);
    }), s.observe(h, { childList: !0 });
  }
  function S() {
    s && s.disconnect(), x = !0;
  }
  return {
    init: C,
    destroy: S
  };
}
function Hf(h, g, b, s) {
  const x = {};
  let C = null, S = null, M, O = !1;
  function D() {
    M = new IntersectionObserver((U) => {
      O || (U.forEach((B) => {
        const Y = g.indexOf(B.target);
        x[Y] = B;
      }), C = null, S = null, b.emit("slidesInView"));
    }, {
      root: h.parentElement,
      threshold: s
    }), g.forEach((U) => M.observe(U));
  }
  function N() {
    M && M.disconnect(), O = !0;
  }
  function W(U) {
    return Sa(x).reduce((B, Y) => {
      const J = parseInt(Y), { isIntersecting: H } = x[J];
      return (U && H || !U && !H) && B.push(J), B;
    }, []);
  }
  function z(U = !0) {
    if (U && C) return C;
    if (!U && S) return S;
    const B = W(U);
    return U && (C = B), U || (S = B), B;
  }
  return {
    init: D,
    destroy: N,
    get: z
  };
}
function Wf(h, g, b, s, x, C) {
  const { measureSize: S, startEdge: M, endEdge: O } = h, D = b[0] && x, N = B(), W = Y(), z = b.map(S), U = J();
  function B() {
    if (!D) return 0;
    const H = b[0];
    return ne(g[M] - H[M]);
  }
  function Y() {
    if (!D) return 0;
    const H = C.getComputedStyle(Mt(s));
    return parseFloat(H.getPropertyValue(`margin-${O}`));
  }
  function J() {
    return b.map((H, $, bn) => {
      const En = !$, hn = wo(bn, $);
      return En ? z[$] + N : hn ? z[$] + W : bn[$ + 1][M] - H[M];
    }).map(ne);
  }
  return {
    slideSizes: z,
    slideSizesWithGaps: U,
    startGap: N,
    endGap: W
  };
}
function Uf(h, g, b, s, x, C, S, M, O) {
  const { startEdge: D, endEdge: N, direction: W } = h, z = To(b);
  function U(J, H) {
    return Ra(J).filter(($) => $ % H === 0).map(($) => J.slice($, $ + H));
  }
  function B(J) {
    return J.length ? Ra(J).reduce((H, $, bn) => {
      const En = Mt(H) || 0, hn = En === 0, p = $ === Fa(J), ln = x[D] - C[En][D], on = x[D] - C[$][N], cn = !s && hn ? W(S) : 0, nn = ne(on - (!s && p ? W(M) : 0) - (ln + cn));
      return bn && nn > g + O && H.push($), p && H.push(J.length), H;
    }, []).map((H, $, bn) => {
      const En = Math.max(bn[$ - 1] || 0);
      return J.slice(En, H);
    }) : [];
  }
  function Y(J) {
    return z ? U(J, b) : B(J);
  }
  return { groupSlides: Y };
}
function Gf(h, g, b, s, x, C, S) {
  const { align: M, axis: O, direction: D, startIndex: N, loop: W, duration: z, dragFree: U, dragThreshold: B, inViewThreshold: Y, slidesToScroll: J, skipSnaps: H, containScroll: $, watchResize: bn, watchSlides: En, watchDrag: hn, watchFocus: p } = C, ln = 2, on = Rf(), cn = on.measure(g), nn = b.map(on.measure), An = xf(O, D), ae = An.measureSize(cn), _n = Sf(ae), Kn = Ef(M, ae), In = !W && !!$, { slideSizes: On, slideSizesWithGaps: _, startGap: V, endGap: gn } = Wf(An, cn, nn, b, W || !!$, x), Nn = Uf(An, ae, J, W, cn, nn, V, gn, ln), { snaps: G, snapsAligned: k } = Of(An, Kn, cn, nn, Nn), ee = -Mt(G) + Mt(_), { snapsContained: ft, scrollContainLimit: te } = Af(ae, ee, k, $, ln), rn = In ? ft : k, { limit: Yn } = _f(ee, rn, W), Xn = du(Fa(rn), N, W), tt = Xn.clone(), he = Ra(b), q = ({ dragHandler: it, scrollBody: jn, scrollBounds: Vt, options: { loop: It } }) => {
    It || Vt.constrain(it.pointerDown()), jn.seek();
  }, tn = ({ scrollBody: it, translate: jn, location: Vt, offsetLocation: It, previousLocation: At, scrollLooper: yl, slideLooper: _t, dragHandler: Jl, animation: El, eventHandler: Kt, scrollBounds: Ql, options: { loop: Dn } }, le) => {
    const Tl = it.settled(), rt = !Ql.shouldConstrain(), xl = Dn ? Tl : Tl && rt, pt = xl && !Jl.pointerDown();
    pt && El.stop();
    const qt = Vt.get() * le + At.get() * (1 - le);
    It.set(qt), Dn && (yl.loop(it.direction()), _t.loop()), jn.to(It.get()), pt && Kt.emit("settle"), xl || Kt.emit("scroll");
  }, Mn = Tf(s, x, () => q(Zl), (it) => tn(Zl, it)), j = 0.68, Ne = rn[Xn.get()], De = wa(Ne), Ft = wa(Ne), me = wa(Ne), Te = wa(Ne), Zn = Ff(De, me, Ft, Te, z, j), bl = Nf(W, rn, ee, Yn, Te), Me = Df(Mn, Xn, tt, Zn, bl, Te, S), xe = kf(Yn), lt = Ma(), Oi = Hf(g, b, S, Y), { slideRegistry: Tn } = Lf(In, $, rn, te, Nn, he), Fe = mf(h, b, Tn, Me, Zn, lt, S, p), Zl = {
    ownerDocument: s,
    ownerWindow: x,
    eventHandler: S,
    containerRect: cn,
    slideRects: nn,
    animation: Mn,
    axis: An,
    dragHandler: wf(An, h, s, x, Te, Cf(An, x), De, Mn, Me, Zn, bl, Xn, S, _n, U, B, H, j, hn),
    eventStore: lt,
    percentOfView: _n,
    index: Xn,
    indexPrevious: tt,
    limit: Yn,
    location: De,
    offsetLocation: me,
    previousLocation: Ft,
    options: C,
    resizeHandler: Mf(g, S, x, b, An, bn, on),
    scrollBody: Zn,
    scrollBounds: If(Yn, me, Te, Zn, _n),
    scrollLooper: Pf(ee, Yn, me, [
      De,
      me,
      Ft,
      Te
    ]),
    scrollProgress: xe,
    scrollSnapList: rn.map(xe.get),
    scrollSnaps: rn,
    scrollTarget: bl,
    scrollTo: Me,
    slideLooper: Bf(An, ae, ee, On, _, G, rn, me, b),
    slideFocus: Fe,
    slidesHandler: zf(g, S, En),
    slidesInView: Oi,
    slideIndexes: he,
    slideRegistry: Tn,
    slidesToScroll: Nn,
    target: Te,
    translate: gu(An, g)
  };
  return Zl;
}
function Yf() {
  let h = {}, g;
  function b(D) {
    g = D;
  }
  function s(D) {
    return h[D] || [];
  }
  function x(D) {
    return s(D).forEach((N) => N(g, D)), O;
  }
  function C(D, N) {
    return h[D] = s(D).concat([N]), O;
  }
  function S(D, N) {
    return h[D] = s(D).filter((W) => W !== N), O;
  }
  function M() {
    h = {};
  }
  const O = {
    init: b,
    emit: x,
    off: S,
    on: C,
    clear: M
  };
  return O;
}
var Xf = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0
};
function Zf(h) {
  function g(x, C) {
    return hu(x, C || {});
  }
  function b(x) {
    const C = x.breakpoints || {};
    return g(x, Sa(C).filter((S) => h.matchMedia(S).matches).map((S) => C[S]).reduce((S, M) => g(S, M), {}));
  }
  function s(x) {
    return x.map((C) => Sa(C.breakpoints || {})).reduce((C, S) => C.concat(S), []).map(h.matchMedia);
  }
  return {
    mergeOptions: g,
    optionsAtMedia: b,
    optionsMediaQueries: s
  };
}
function Jf(h) {
  let g = [];
  function b(x, C) {
    return g = C.filter(({ options: S }) => h.optionsAtMedia(S).active !== !1), g.forEach((S) => S.init(x, h)), C.reduce((S, M) => Object.assign(S, { [M.name]: M }), {});
  }
  function s() {
    g = g.filter((x) => x.destroy());
  }
  return {
    init: b,
    destroy: s
  };
}
function bc(h, g, b) {
  const s = h.ownerDocument, x = s.defaultView, C = Zf(x), S = Jf(C), M = Ma(), O = Yf(), { mergeOptions: D, optionsAtMedia: N, optionsMediaQueries: W } = C, { on: z, off: U, emit: B } = O, Y = An;
  let J = !1, H, $ = D(Xf, bc.globalOptions), bn = D($), En = [], hn, p, ln;
  function on() {
    const { container: q, slides: tn } = bn;
    p = (so(q) ? h.querySelector(q) : q) || h.children[0];
    const Mn = so(tn) ? p.querySelectorAll(tn) : tn;
    ln = [].slice.call(Mn || p.children);
  }
  function cn(q) {
    const tn = Gf(h, p, ln, s, x, q, O);
    return q.loop && !tn.slideLooper.canLoop() ? cn(Object.assign({}, q, { loop: !1 })) : tn;
  }
  function nn(q, tn) {
    J || ($ = D($, q), bn = N($), En = tn || En, on(), H = cn(bn), W([$, ...En.map(({ options: Mn }) => Mn)]).forEach((Mn) => M.add(Mn, "change", An)), bn.active && (H.translate.to(H.location.get()), H.animation.init(), H.slidesInView.init(), H.slideFocus.init(he), H.eventHandler.init(he), H.resizeHandler.init(he), H.slidesHandler.init(he), H.options.loop && H.slideLooper.loop(), p.offsetParent && ln.length && H.dragHandler.init(he), hn = S.init(he, En)));
  }
  function An(q, tn) {
    const Mn = G();
    ae(), nn(D({ startIndex: Mn }, q), tn), O.emit("reInit");
  }
  function ae() {
    H.dragHandler.destroy(), H.eventStore.clear(), H.translate.clear(), H.slideLooper.clear(), H.resizeHandler.destroy(), H.slidesHandler.destroy(), H.slidesInView.destroy(), H.animation.destroy(), S.destroy(), M.clear();
  }
  function _n() {
    J || (J = !0, M.clear(), ae(), O.emit("destroy"), O.clear());
  }
  function Kn(q, tn, Mn) {
    !bn.active || J || (H.scrollBody.useBaseFriction().useDuration(tn === !0 ? 0 : bn.duration), H.scrollTo.index(q, Mn || 0));
  }
  function In(q) {
    Kn(H.index.add(1).get(), q, -1);
  }
  function On(q) {
    Kn(H.index.add(-1).get(), q, 1);
  }
  function _() {
    return H.index.add(1).get() !== G();
  }
  function V() {
    return H.index.add(-1).get() !== G();
  }
  function gn() {
    return H.scrollSnapList;
  }
  function Nn() {
    return H.scrollProgress.get(H.offsetLocation.get());
  }
  function G() {
    return H.index.get();
  }
  function k() {
    return H.indexPrevious.get();
  }
  function ee() {
    return H.slidesInView.get();
  }
  function ft() {
    return H.slidesInView.get(!1);
  }
  function te() {
    return hn;
  }
  function rn() {
    return H;
  }
  function Yn() {
    return h;
  }
  function Xn() {
    return p;
  }
  function tt() {
    return ln;
  }
  const he = {
    canScrollNext: _,
    canScrollPrev: V,
    containerNode: Xn,
    internalEngine: rn,
    destroy: _n,
    off: U,
    on: z,
    emit: B,
    plugins: te,
    previousScrollSnap: k,
    reInit: Y,
    rootNode: Yn,
    scrollNext: In,
    scrollPrev: On,
    scrollProgress: Nn,
    scrollSnapList: gn,
    scrollTo: Kn,
    selectedScrollSnap: G,
    slideNodes: tt,
    slidesInView: ee,
    slidesNotInView: ft
  };
  return nn(g, b), setTimeout(() => O.emit("init"), 0), he;
}
bc.globalOptions = void 0;
var Qf = {
  active: !0,
  breakpoints: {},
  delay: 4e3,
  jump: !1,
  playOnInit: !0,
  stopOnFocusIn: !0,
  stopOnInteraction: !0,
  stopOnMouseEnter: !1,
  stopOnLastSnap: !1,
  rootNode: null
};
function Vf(h, g) {
  const b = h.scrollSnapList();
  return typeof g == "number" ? b.map(() => g) : g(b, h);
}
function Kf(h, g) {
  const b = h.rootNode();
  return g && g(b) || b;
}
function Co(h = {}) {
  let g, b, s, x, C = null, S = 0, M = !1, O = !1, D = !1, N = !1;
  function W(_n, Kn) {
    b = _n;
    const { mergeOptions: In, optionsAtMedia: On } = Kn;
    if (g = On(In(In(Qf, Co.globalOptions), h)), b.scrollSnapList().length <= 1) return;
    N = g.jump, s = !1, x = Vf(b, g.delay);
    const { eventStore: _, ownerDocument: V } = b.internalEngine(), gn = !!b.internalEngine().options.watchDrag, Nn = Kf(b, g.rootNode);
    _.add(V, "visibilitychange", H), gn && b.on("pointerDown", bn), gn && !g.stopOnInteraction && b.on("pointerUp", En), g.stopOnMouseEnter && _.add(Nn, "mouseenter", hn), g.stopOnMouseEnter && !g.stopOnInteraction && _.add(Nn, "mouseleave", p), g.stopOnFocusIn && b.on("slideFocusStart", J), g.stopOnFocusIn && !g.stopOnInteraction && _.add(b.containerNode(), "focusout", Y), g.playOnInit && Y();
  }
  function z() {
    b.off("pointerDown", bn).off("pointerUp", En).off("slideFocusStart", J), J(), s = !0, M = !1;
  }
  function U() {
    const { ownerWindow: _n } = b.internalEngine();
    _n.clearTimeout(S), S = _n.setTimeout(An, x[b.selectedScrollSnap()]), C = (/* @__PURE__ */ new Date()).getTime(), b.emit("autoplay:timerset");
  }
  function B() {
    const { ownerWindow: _n } = b.internalEngine();
    _n.clearTimeout(S), S = 0, C = null, b.emit("autoplay:timerstopped");
  }
  function Y() {
    if (!s) {
      if ($()) {
        D = !0;
        return;
      }
      M || b.emit("autoplay:play"), U(), M = !0;
    }
  }
  function J() {
    s || (M && b.emit("autoplay:stop"), B(), M = !1);
  }
  function H() {
    if ($())
      return D = M, J();
    D && Y();
  }
  function $() {
    const { ownerDocument: _n } = b.internalEngine();
    return _n.visibilityState === "hidden";
  }
  function bn() {
    O || J();
  }
  function En() {
    O || Y();
  }
  function hn() {
    O = !0, J();
  }
  function p() {
    O = !1, Y();
  }
  function ln(_n) {
    typeof _n < "u" && (N = _n), Y();
  }
  function on() {
    M && J();
  }
  function cn() {
    M && Y();
  }
  function nn() {
    return M;
  }
  function An() {
    const { index: _n } = b.internalEngine(), Kn = _n.clone().add(1).get(), In = b.scrollSnapList().length - 1, On = g.stopOnLastSnap && Kn === In;
    if (b.canScrollNext() ? b.scrollNext(N) : b.scrollTo(0, N), b.emit("autoplay:select"), On) return J();
    Y();
  }
  function ae() {
    return C ? x[b.selectedScrollSnap()] - ((/* @__PURE__ */ new Date()).getTime() - C) : null;
  }
  return {
    name: "autoplay",
    options: h,
    init: W,
    destroy: z,
    play: ln,
    stop: on,
    reset: cn,
    isPlaying: nn,
    timeUntilNext: ae
  };
}
Co.globalOptions = void 0;
var pf = class extends uu {
  constructor(...h) {
    super(...h), io(this, "emblaMain", null), io(this, "emblaThumbs", null), io(this, "cleanupFns", []);
  }
  async connectedCallback() {
    super.connectedCallback(), this.init();
  }
  disconnectedCallback() {
    this.cleanupFns.forEach((h) => {
      h();
    }), this.cleanupFns = [], this.emblaMain?.destroy(), this.emblaThumbs?.destroy(), this.emblaMain = null, this.emblaThumbs = null;
  }
  async init() {
    const h = this.querySelector(":scope > hy-carousel-viewport");
    if (!h) {
      console.warn("hy-carousel: Missing hy-carousel-viewport element");
      return;
    }
    const g = this.getJson("options") || {}, b = {
      align: "start",
      slidesToScroll: "auto",
      containScroll: "trimSnaps",
      dragFree: this.dataset.dragFree ? this.dataset.dragFree === "true" : !1,
      loop: this.dataset.loop === "true",
      axis: this.dataset.axis || "x",
      ...g
    }, s = [], x = Number(this.dataset.autoplay);
    x > 0 && s.push(Co({
      delay: x,
      stopOnMouseEnter: !0
    })), this.emblaMain = bc(h, b, s), this.initScrollToListener(), this.initMagnifyListener(b);
    const C = this.querySelector("hy-carousel-paging"), S = this.querySelector("hy-carousel-dots");
    C ? this.initPageIndicator(C) : S && this.initThumbnails(S);
    const M = this.querySelector("hy-carousel-controls");
    M ? this.initControls(M) : this.dataset.controls !== "false" && this.initDefaultControls(), this.initSlideSelection();
  }
  initScrollToListener() {
    if (!this.emblaMain) return;
    const h = this.id;
    if (!h) return;
    const g = (b) => {
      const s = b;
      s.detail?.id === h && this.emblaMain?.scrollTo(s.detail.index);
    };
    window.addEventListener("carousel:scrollto", g), this.cleanupFns.push(() => {
      window.removeEventListener("carousel:scrollto", g);
    });
  }
  initMagnifyListener(h) {
    if (!this.emblaMain) return;
    const g = (b) => {
      const s = b.detail?.zoomed, x = this.emblaMain?.selectedScrollSnap() ?? 0;
      this.emblaMain?.reInit({
        ...h,
        watchDrag: !s,
        startIndex: x
      });
    };
    this.addEventListener("magnify:zoom", g), this.cleanupFns.push(() => {
      this.removeEventListener("magnify:zoom", g);
    });
  }
  initThumbnails(h) {
    if (!this.emblaMain) return;
    const g = h.querySelector("hy-carousel-viewport");
    if (!g) {
      this.initDefaultDots(h);
      return;
    }
    const b = h.querySelectorAll("[data-dot]");
    if (!b.length) return;
    const s = h.dataset.toggleEvent || "click";
    b.forEach((C, S) => {
      const M = () => this.emblaMain?.scrollTo(S);
      s === "click" ? (C.addEventListener("click", M), this.cleanupFns.push(() => C.removeEventListener("click", M))) : s === "hover" && (C.addEventListener("mouseenter", M), this.cleanupFns.push(() => C.removeEventListener("mouseenter", M)));
    }), this.emblaThumbs = bc(g, {
      containScroll: "keepSnaps",
      dragFree: !0,
      axis: window.matchMedia("(min-width: 768px)").matches ? h.dataset.mdAxis || h.dataset.axis || "x" : h.dataset.axis || "x"
    });
    const x = () => {
      if (!this.emblaMain) return;
      const C = this.emblaMain.selectedScrollSnap();
      this.emblaThumbs?.scrollTo(C), b.forEach((S, M) => {
        const O = M === C;
        S.setAttribute("data-selected", String(O)), S.setAttribute("aria-current", String(O));
      });
    };
    this.emblaMain.on("select", x), this.emblaMain.on("reInit", x), x(), this.cleanupFns.push(() => {
      this.emblaMain?.off("select", x), this.emblaMain?.off("reInit", x);
    });
  }
  initDefaultDots(h) {
    if (!this.emblaMain) return;
    let g = null, b = 0;
    const s = () => {
      if (!this.emblaMain) return;
      const M = this.emblaMain.scrollSnapList();
      M.length === b && g || (g?.remove(), b = M.length, g = document.createElement("div"), g.className = "dots", M.forEach((O, D) => {
        const N = document.createElement("button");
        N.type = "button", N.className = "dot", N.innerHTML = `<span class="sr-only">Go to slide ${D + 1}</span>`, N.addEventListener("click", () => this.emblaMain?.scrollTo(D)), g.appendChild(N);
      }), h.appendChild(g), x());
    }, x = () => {
      if (!this.emblaMain || !g) return;
      const M = this.emblaMain.selectedScrollSnap();
      g.querySelectorAll(".dot").forEach((O, D) => {
        const N = D === M;
        O.setAttribute("data-selected", String(N)), O.setAttribute("aria-current", String(N)), O.setAttribute("aria-label", `Go to slide ${D + 1}`);
      });
    }, C = () => {
      s(), x();
    }, S = new ResizeObserver(() => {
      this.emblaMain?.reInit();
    });
    S.observe(this), s(), this.emblaMain.on("select", x), this.emblaMain.on("reInit", C), this.cleanupFns.push(() => {
      this.emblaMain?.off("select", x), this.emblaMain?.off("reInit", C), S.disconnect(), g?.remove();
    });
  }
  initPageIndicator(h) {
    if (!this.emblaMain) return;
    const g = () => {
      if (!this.emblaMain) return;
      const b = this.emblaMain.scrollSnapList().length;
      if (b <= 1) {
        h.style.display = "none";
        return;
      }
      h.style.display = "";
      const s = this.emblaMain.selectedScrollSnap() + 1;
      h.textContent = `${h.dataset.textPrefix || ""} ${s} of ${b}`.trim();
    };
    this.emblaMain.on("select", g), this.emblaMain.on("reInit", g), g(), this.cleanupFns.push(() => {
      this.emblaMain?.off("select", g), this.emblaMain?.off("reInit", g);
    });
  }
  initControls(h) {
    if (!this.emblaMain) return;
    const g = h.querySelector("[data-prev]"), b = h.querySelector("[data-next]");
    if (g) {
      const x = () => this.emblaMain?.scrollPrev();
      g.addEventListener("click", x), this.cleanupFns.push(() => g.removeEventListener("click", x));
    }
    if (b) {
      const x = () => this.emblaMain?.scrollNext();
      b.addEventListener("click", x), this.cleanupFns.push(() => b.removeEventListener("click", x));
    }
    const s = () => {
      this.emblaMain && (g && (g.disabled = !this.emblaMain.canScrollPrev()), b && (b.disabled = !this.emblaMain.canScrollNext()));
    };
    this.emblaMain.on("select", s), this.emblaMain.on("reInit", s), s(), this.cleanupFns.push(() => {
      this.emblaMain?.off("select", s), this.emblaMain?.off("reInit", s);
    });
  }
  initDefaultControls() {
    if (!this.emblaMain) return;
    const h = document.createElement("hy-carousel-controls"), g = document.createElement("button");
    g.type = "button", g.setAttribute("data-prev", ""), g.className = "prev", g.innerHTML = '<span class="sr-only">Previous</span>', g.addEventListener("click", () => this.emblaMain?.scrollPrev());
    const b = document.createElement("button");
    b.type = "button", b.setAttribute("data-next", ""), b.className = "next", b.innerHTML = '<span class="sr-only">Next</span>', b.addEventListener("click", () => this.emblaMain?.scrollNext()), h.appendChild(g), h.appendChild(b), this.appendChild(h);
    const s = () => {
      this.emblaMain && (g.disabled = !this.emblaMain.canScrollPrev(), b.disabled = !this.emblaMain.canScrollNext());
    };
    this.emblaMain.on("select", s), this.emblaMain.on("reInit", s), s(), this.cleanupFns.push(() => {
      this.emblaMain?.off("select", s), this.emblaMain?.off("reInit", s), h.remove();
    });
  }
  initSlideSelection() {
    if (!this.emblaMain) return;
    const h = this.querySelectorAll(":scope > hy-carousel-viewport [data-slide]"), g = () => {
      if (!this.emblaMain) return;
      const b = this.emblaMain.selectedScrollSnap();
      h.forEach((s, x) => {
        s.setAttribute("data-selected", String(x === b)), s.setAttribute("aria-current", String(x === b));
      });
    };
    this.emblaMain.on("select", g), this.emblaMain.on("reInit", g), g(), this.cleanupFns.push(() => {
      this.emblaMain?.off("select", g), this.emblaMain?.off("reInit", g);
    });
  }
  pause() {
    this.emblaMain?.plugins()?.autoplay?.stop();
  }
  play() {
    this.emblaMain?.plugins()?.autoplay?.play();
  }
};
customElements.get("hy-carousel") || customElements.define("hy-carousel", pf);
var K = Ou();
function qf({ ...h }) {
  return /* @__PURE__ */ (0, K.jsx)(Qu, {
    "data-slot": "dialog",
    ...h
  });
}
function jf({ ...h }) {
  return /* @__PURE__ */ (0, K.jsx)(Du, {
    "data-slot": "dialog-portal",
    ...h
  });
}
function $f({ className: h, ...g }) {
  return /* @__PURE__ */ (0, K.jsx)(Wu, {
    "data-slot": "dialog-overlay",
    className: Ye("data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50", h),
    ...g
  });
}
function ns({ className: h, children: g, showCloseButton: b = !0, ...s }) {
  return /* @__PURE__ */ (0, K.jsxs)(jf, {
    "data-slot": "dialog-portal",
    children: [/* @__PURE__ */ (0, K.jsx)($f, {}), /* @__PURE__ */ (0, K.jsxs)(Xu, {
      "data-slot": "dialog-content",
      className: Ye("bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-1/2 left-1/2 z-50 grid w-full max-w-[calc(100%-2rem)] -translate-x-1/2 -translate-y-1/2 gap-4 rounded-lg border p-6 shadow-lg duration-200 outline-none sm:max-w-lg", h),
      ...s,
      children: [g, b && /* @__PURE__ */ (0, K.jsxs)(Ju, {
        "data-slot": "dialog-close",
        className: "ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute top-4 right-4 rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg]:h-6 [&_svg]:w-6",
        children: [/* @__PURE__ */ (0, K.jsx)(yc, {}), /* @__PURE__ */ (0, K.jsx)("span", {
          className: "sr-only",
          children: "Close"
        })]
      })]
    })]
  });
}
function es({ className: h, ...g }) {
  return /* @__PURE__ */ (0, K.jsx)("div", {
    "data-slot": "dialog-header",
    className: h,
    ...g
  });
}
function ts({ className: h, ...g }) {
  return /* @__PURE__ */ (0, K.jsx)(Vu, {
    "data-slot": "dialog-title",
    className: Ye("text-lg leading-none font-semibold", h),
    ...g
  });
}
function ls({ className: h, ...g }) {
  return /* @__PURE__ */ (0, K.jsx)(Uu, {
    "data-slot": "dialog-description",
    className: Ye("text-muted-foreground text-sm", h),
    ...g
  });
}
var xc = ku(), wr = "hy-modal", go = `${wr}:show`, vo = `${wr}:hide`, vu = `${wr}:toggle`, is = `${wr}:opened`, rs = `${wr}:closed`;
function as({ id: h, title: g, showCloseButton: b = !0, className: s = {}, extendCss: x = {}, children: C, ariaDescription: S }) {
  const [M, O] = (0, Gn.useState)(!1), D = (z) => {
    const U = z ? is : rs, B = () => {
      window.dispatchEvent(new CustomEvent(U, {
        bubbles: !0,
        composed: !0,
        detail: {
          id: h,
          open: z
        }
      }));
    };
    z ? requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setTimeout(B, 0);
      });
    }) : B();
  }, N = (z) => {
    const U = z;
    if (U.detail?.id === h) {
      let B;
      U.type === go ? B = !0 : U.type === vo ? B = !1 : B = U.detail.open ?? !M, O(B), D(B);
    }
  };
  vc(vu, N), vc(go, N), vc(vo, N);
  const W = (z) => {
    O(z), D(z);
  };
  return /* @__PURE__ */ (0, K.jsx)(qf, {
    open: M,
    onOpenChange: W,
    children: /* @__PURE__ */ (0, K.jsxs)(ns, {
      showCloseButton: b,
      className: s.content ?? Ye("bg-background sm:max-w-5xl mx-4", x.content),
      ...!S && { "aria-describedby": void 0 },
      children: [/* @__PURE__ */ (0, K.jsxs)(es, {
        className: s.header,
        children: [g && /* @__PURE__ */ (0, K.jsx)(ts, {
          className: s.title ?? Ye("text-lg font-semibold text-primary", x.title),
          dangerouslySetInnerHTML: { __html: g }
        }), S && /* @__PURE__ */ (0, K.jsx)(ls, {
          className: "sr-only",
          children: S
        })]
      }), C]
    })
  });
}
var cs = class extends HTMLElement {
  connectedCallback() {
    const h = this.id || `${wr}-${Math.random().toString(36).substr(2, 9)}`;
    this.id || (this.id = h);
    const { showCloseButton: g = "true", classContent: b, classHeader: s, classTitle: x, classBody: C, classClose: S, extendContent: M, extendTitle: O, extendBody: D, extendClose: N, ariaDescription: W } = this.dataset;
    let z = this.dataset.title;
    z || (z = this.querySelector("hy-modal-header")?.innerHTML);
    const U = {
      content: b,
      header: s,
      title: x,
      body: C,
      close: S
    }, B = {
      content: M,
      title: O,
      body: D,
      close: N
    }, Y = Array.from(this.childNodes).map((J) => J.cloneNode(!0));
    (0, xc.createRoot)(this).render(/* @__PURE__ */ (0, K.jsx)(as, {
      id: h,
      title: z,
      showCloseButton: g !== "false",
      className: U,
      extendCss: B,
      ariaDescription: W,
      children: /* @__PURE__ */ (0, K.jsx)("div", {
        className: U.body,
        ref: (J) => {
          J && (J.innerHTML = "", Y.forEach((H) => {
            H.tagName !== "hy-MODAL-HEADER" && J.appendChild(H.cloneNode(!0));
          }));
        }
      })
    }));
  }
  toggle(h) {
    let g = vu;
    h ? g = go : g = vo, window.dispatchEvent(new CustomEvent(g, { detail: {
      id: this.id,
      open: h
    } }));
  }
  show() {
    this.toggle(!0);
  }
  hide() {
    this.toggle(!1);
  }
};
customElements.get("hy-modal") || customElements.define("hy-modal", cs);
var os = ({ children: h, href: g, onRemove: b, onClick: s, className: x = {} }) => /* @__PURE__ */ (0, K.jsxs)("div", {
  role: "option",
  tabIndex: 0,
  className: Ye("p-1 flex items-center", x.option),
  onKeyDown: (C) => {
    (C.key === "Enter" || C.key === " ") && (C.preventDefault(), C.currentTarget.querySelector("a, button")?.click());
  },
  children: [g ? /* @__PURE__ */ (0, K.jsx)("a", {
    href: g,
    className: Ye("hover:underline flex-1 text-left", x.button),
    children: h
  }) : /* @__PURE__ */ (0, K.jsx)("button", {
    type: "button",
    className: Ye("flex-1 text-left", x.button),
    onClick: s,
    children: h
  }), b && /* @__PURE__ */ (0, K.jsx)("button", {
    type: "button",
    className: "text-muted-800 hover:text-black rounded-full p-1 hover:bg-gray-400 font-medium",
    "aria-label": "Remove recent search",
    onClick: () => b(),
    children: /* @__PURE__ */ (0, K.jsx)(yc, { className: "size-4" })
  })]
}), gc = ({ icon: h, title: g, onClear: b, clearText: s, items: x, className: C = {} }) => /* @__PURE__ */ (0, K.jsxs)("div", {
  className: Ye("py-3 mx-4", C.root),
  children: [g && /* @__PURE__ */ (0, K.jsxs)("div", {
    className: "flex items-center gap-2 pb-2",
    children: [
      h && /* @__PURE__ */ (0, K.jsx)(h, { className: Ye("fill-muted-500 size-4", C.icon) }),
      /* @__PURE__ */ (0, K.jsx)("span", {
        className: "font-medium flex-1",
        children: g
      }),
      b && /* @__PURE__ */ (0, K.jsx)("button", {
        type: "button",
        className: "text-xs text-muted-500 underline hover:no-underline",
        "aria-label": "Clear search history",
        onClick: () => b(),
        children: s
      })
    ]
  }), /* @__PURE__ */ (0, K.jsx)("div", {
    role: "listbox",
    className: Ye("flex flex-col gap-1", C.body),
    children: x.map((S, M) => /* @__PURE__ */ (0, K.jsx)(os, { ...S }, M))
  })]
}), us = ({ name: h, images: g }) => /* @__PURE__ */ (0, K.jsxs)("div", {
  role: "option",
  tabIndex: 0,
  className: "text-foreground text-base flex gap-4 items-center md:gap-2 cursor-pointer",
  children: [g && g.length > 0 ? /* @__PURE__ */ (0, K.jsx)(Nu, {
    alt: h,
    src: g[0],
    width: 80,
    height: 80,
    fetchPriority: "auto",
    className: "min-w-20 aspect-square object-contain"
  }) : null, /* @__PURE__ */ (0, K.jsx)("span", {
    className: "line-clamp-2 text-sm",
    children: h
  })]
});
function fs({ text: h, matchedTerms: g }) {
  if (!g.length) return /* @__PURE__ */ (0, K.jsx)("span", { children: h });
  const b = new RegExp(`(${g.map((s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|")})`, "gi");
  return /* @__PURE__ */ (0, K.jsx)("span", { children: h.split(b).map((s, x) => b.test(s) ? /* @__PURE__ */ (0, K.jsx)("b", { children: s }, x) : s) });
}
var oo = {
  products: "Products",
  searchSuggestions: "Search Suggestions"
};
function ss({ cioKeys: h, searchUrl: g, parameters: b, showSuggestions: s = !0, showRecentSearches: x = !0, showTrendingSearches: C = !0, showTopProducts: S = !0, onNavigate: M, onTrackEvent: O }) {
  const D = (0, Gn.useId)(), N = (0, Gn.useId)(), W = (0, Gn.useRef)(null), [z, U] = (0, Gn.useState)(""), [B, Y] = (0, Gn.useState)(""), [J, H] = (0, Gn.useState)(!1), [$, bn] = (0, Gn.useState)(!1), En = b?.numResults || 6, [hn, p] = (0, Gn.useState)(Zu());
  zu(W, () => {
    H(!1);
  }), ro("Escape", () => {
    H(!1);
  }), ro("Tab", () => {
    H(!1);
  }), ro("Shift+Tab", () => {
    H(!1);
  });
  const ln = (0, Gn.useMemo)(() => Yu(h), [h]), on = Gu(h, B, {
    ...b,
    numResults: En * 2
  }), cn = mu({
    filterName: "group_id",
    filterValue: "all",
    clientOptions: h,
    requestParams: {
      ...b,
      resultsPerPage: En
    }
  }, $ && !B && S), nn = Bu({
    keys: h,
    requestParams: { numResults: En }
  }, $ && !B), An = (0, Gn.useMemo)(() => on ? on.sections[oo.searchSuggestions] : [], [on]);
  rf(() => {
    Y(z), z && (An?.length === 0 ? H(!1) : H(!0));
  }, 300, [z, An]);
  const ae = (0, Gn.useMemo)(() => B ? on ? on.sections[oo.products] : [] : cn?.response?.results ? cn.response.results : [], [
    on,
    cn,
    B
  ]), _n = () => {
    H(!0), $ || bn(!0);
  }, Kn = () => {
    U(""), Y("");
  }, In = (gn, Nn, G = !1) => {
    if (!Nn) return;
    U(Nn), G && ln?.tracker.trackAutocompleteSelect(Nn, {
      originalQuery: B,
      section: oo.searchSuggestions
    });
    const k = tu(Nn);
    k && p(k), O?.(`click_${gn}`, { searchTerm: Nn });
    const ee = new URL(g, typeof location < "u" ? location.origin : "https://localhost");
    ee.searchParams.set("q", Nn), M ? M(ee.toString()) : typeof window < "u" && window.location.assign(ee.toString());
  }, On = (gn) => {
    const Nn = hn.filter((G) => G.id !== gn);
    p(Nn), eu(Nn);
  }, _ = () => {
    p([]), eu([]);
  }, V = (gn) => {
    if (!z.trim()) {
      gn.preventDefault();
      return;
    }
    if (z.trim()) {
      const Nn = tu(z);
      Nn && p(Nn), O?.("search_submit", { searchTerm: z });
    }
  };
  return /* @__PURE__ */ (0, K.jsxs)("div", {
    ref: W,
    className: "relative px-1 md:px-0",
    children: [/* @__PURE__ */ (0, K.jsxs)("form", {
      className: "w-full md:w-[355px] md:pr-2 h-10 flex items-center border border-input-900 rounded md:rounded-full bg-white",
      action: g,
      onSubmit: V,
      children: [
        /* @__PURE__ */ (0, K.jsx)("button", {
          type: "submit",
          className: "p-2 disabled:cursor-not-allowed flex justify-center items-center",
          "aria-label": "Submit Search",
          children: /* @__PURE__ */ (0, K.jsx)(nf, { className: "size-4" })
        }),
        /* @__PURE__ */ (0, K.jsx)("label", {
          className: "sr-only",
          htmlFor: N,
          children: "Search"
        }),
        /* @__PURE__ */ (0, K.jsx)("input", {
          "aria-autocomplete": "list",
          "aria-controls": D,
          "aria-expanded": J ? "true" : "false",
          autoComplete: "off",
          role: "combobox",
          id: N,
          name: "q",
          className: "flex-1 h-full border-0 rounded-r md:rounded-r-full text-foreground placeholder:text-input-900 [&::-webkit-calendar-picker-indicator]:hidden [&::-webkit-calendar-picker-indicator]:appearance-none",
          placeholder: "Search",
          enterKeyHint: "search",
          value: z,
          onInput: (gn) => {
            U(gn.currentTarget.value);
          },
          onFocus: _n
        }),
        /* @__PURE__ */ (0, K.jsx)("button", {
          onClick: Kn,
          className: Ye("disabled:cursor-not-allowed text-sm text-muted hover:text-primary flex justify-center items-center", !B && "hidden"),
          type: "reset",
          "aria-label": "Clear search",
          children: /* @__PURE__ */ (0, K.jsx)(yc, { className: "size-4" })
        })
      ]
    }), /* @__PURE__ */ (0, K.jsxs)("div", {
      id: D,
      role: "dialog",
      "aria-labelledby": N,
      className: Ye("absolute inset-x-1 max-h-[80vh] [&>div+div]:border-t [&>div+div]:border-gray-100 md:inset-x-auto mt-1 rounded-md overflow-y-auto bg-white z-50 flex flex-col border md:w-[520px] shadow-lg", !J && "hidden"),
      children: [
        z !== "" && s && /* @__PURE__ */ (0, K.jsx)(gc, { items: An.map((gn) => ({
          children: /* @__PURE__ */ (0, K.jsx)(fs, {
            text: gn.value,
            matchedTerms: gn.matched_terms
          }),
          className: { option: "hover:bg-gray-100" },
          onClick: () => In("suggestions", gn.value, !0)
        })) }),
        x && !z && hn.length > 0 && /* @__PURE__ */ (0, K.jsx)(gc, {
          title: "Recent Searches",
          icon: pu,
          className: { icon: "text-white" },
          clearText: "Clear History",
          onClear: _,
          items: hn.map((gn) => ({
            className: {
              option: "hover:bg-gray-100",
              button: "hover:underline"
            },
            children: gn.search,
            onClick: () => In("recent_search", gn.search),
            onRemove: () => On(gn.id)
          }))
        }),
        (z === "" || An.length === 0) && C && nn && !!nn.response?.results?.length && /* @__PURE__ */ (0, K.jsx)(gc, {
          title: "Trending Searches",
          icon: tf,
          className: { body: "flex-wrap flex-row" },
          items: nn.response.results.map((gn) => ({
            children: /* @__PURE__ */ (0, K.jsx)(Lu, {
              rounded: "pill",
              variant: "outline",
              hoverable: !0,
              children: gn.value
            }),
            className: { option: "p-0" },
            onClick: () => In("trending", gn.value, !0)
          }))
        }),
        (An.length > 0 || z === "") && S && /* @__PURE__ */ (0, K.jsx)(gc, {
          title: "Top Products",
          icon: ju,
          className: { body: "md:grid md:grid-cols-2" },
          items: ae.map((gn) => ({
            children: /* @__PURE__ */ (0, K.jsx)(us, {
              name: gn.value,
              images: gn.data?.images
            }),
            className: { option: "p-0" },
            href: gn.data?.url
          }))
        })
      ]
    })]
  });
}
var hs = class extends uu {
  async connectedCallback() {
    await super.connectedCallback();
    const h = this.dataset.apiKey || "";
    if (!h) {
      this.innerHTML = "Constructor API key is required";
      return;
    }
    const g = this.dataset.version || "", b = this.dataset.searchUrl || "", { visible: s, ...x } = this.getJson("options") || {};
    (0, xc.createRoot)(this).render(/* @__PURE__ */ (0, K.jsx)(Eo, { children: /* @__PURE__ */ (0, K.jsx)(ss, {
      cioKeys: {
        apiKey: h,
        version: g
      },
      searchUrl: b,
      parameters: x,
      showTopProducts: s?.topProducts,
      onNavigate: (C) => window.location.assign(C),
      onTrackEvent: (C, S) => {
        window.igEvents && window.igEvents.push({
          event: C,
          ...S
        });
      }
    }) }));
  }
};
customElements.get("cio-autocomplete") || customElements.define("cio-autocomplete", hs);
var bu = async (h, g) => fetch("/cart/change", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({
    id: h,
    quantity: g
  })
}).then((b) => {
  if (b.ok) return b;
  throw new Error(b.statusText);
}), ds = ({ decrementLabel: h = "Decrease", incrementLabel: g = "Increase", inputLabel: b = "Quantity", decrementIcon: s = "-", incrementIcon: x = "+", lineKey: C, min: S = 1, max: M, step: O = 1, onChange: D, defaultValue: N }) => {
  const [W, z] = (0, Gn.useState)(N ?? 1), [U, B] = (0, Gn.useState)(), [Y, J] = (0, Gn.useState)(!1), H = (hn, p) => {
    z(p), B(void 0), J(!0), bu(C, p).then(() => {
      D && D(hn, {
        lineKey: C,
        quantity: p
      });
    }).catch((ln) => {
      console.error("[cart:change:quantity]", ln.message), B(ln.message);
    }).finally(() => {
      J(!1);
    });
  }, $ = (hn) => {
    H(hn, Math.max(W - O, S));
  }, bn = (hn) => {
    H(hn, M ? Math.min(W + O, M) : W + O);
  }, En = (hn) => {
    const p = Number(hn.target.value);
    if (Number.isNaN(p) || p === W) return;
    let ln = p;
    p < S ? ln = S : M && p > M && (ln = M), H(hn, ln);
  };
  return /* @__PURE__ */ (0, K.jsxs)("div", {
    className: Ye("flex border rounded-md h-full", U ? "border-red-500" : "border-black"),
    title: U,
    children: [
      /* @__PURE__ */ (0, K.jsxs)("button", {
        type: "button",
        disabled: W <= S || Y,
        className: "cart-item__decrement pl-3 disabled:opacity-25",
        onClick: $,
        children: [/* @__PURE__ */ (0, K.jsx)("span", {
          className: "sr-only",
          children: h
        }), /* @__PURE__ */ (0, K.jsx)("span", { dangerouslySetInnerHTML: { __html: s } })]
      }),
      /* @__PURE__ */ (0, K.jsx)("input", {
        className: "cart-item__quantity text-center w-full disabled:opacity-25",
        inputMode: "numeric",
        name: "quantity",
        disabled: Y,
        value: W,
        min: S,
        max: M,
        step: O,
        "aria-label": b,
        onChange: (hn) => {
          const p = Number(hn.target.value);
          Number.isNaN(p) || z(p);
        },
        onBlur: En
      }),
      /* @__PURE__ */ (0, K.jsxs)("button", {
        type: "button",
        disabled: !!(M && W >= M) || Y,
        className: "cart-item__increment pr-3 disabled:opacity-25",
        onClick: bn,
        children: [/* @__PURE__ */ (0, K.jsx)("span", {
          className: "sr-only",
          children: g
        }), /* @__PURE__ */ (0, K.jsx)("span", { dangerouslySetInnerHTML: { __html: x } })]
      })
    ]
  });
}, gs = class extends HTMLElement {
  connectedCallback() {
    const h = this.querySelector("[data-decrement-icon]"), g = this.querySelector("[data-increment-icon]"), b = this.dataset.decrementLabel, s = this.dataset.incrementLabel, x = this.dataset.inputLabel, C = this.dataset.lineKey, S = this.dataset.ajax ? this.dataset.ajax === "true" : !0, M = (O, D) => {
      S || location.reload(), window.dispatchEvent(new CustomEvent("cart:change:quantity", {
        detail: {
          ...D,
          originalEvent: O
        },
        bubbles: !0
      }));
    };
    (0, xc.createRoot)(this).render(/* @__PURE__ */ (0, K.jsx)(Eo, { children: C ? /* @__PURE__ */ (0, K.jsx)(ds, {
      decrementLabel: b,
      incrementLabel: s,
      inputLabel: x,
      lineKey: C,
      defaultValue: Number(this.dataset.defaultValue),
      min: Number(this.dataset.min) || 1,
      max: Number(this.dataset.max),
      step: Number(this.dataset.step),
      decrementIcon: h?.innerHTML,
      incrementIcon: g?.innerHTML,
      onChange: M
    }) : /* @__PURE__ */ (0, K.jsx)("p", { children: "(Line Key is required)" }) }));
  }
};
customElements.get("cart-quantity") || customElements.define("cart-quantity", gs);
var vs = ({ lineKey: h, children: g, onSuccess: b }) => {
  const [s, x] = (0, Gn.useState)(!1), C = () => {
    x(!0), bu(h, 0).then(() => {
      b?.();
    }).catch((S) => {
      console.error("[cart:remove:item]", S.message);
    }).finally(() => {
      x(!1);
    });
  };
  return s ? /* @__PURE__ */ (0, K.jsx)("button", {
    className: "btn btn-link",
    disabled: !0,
    children: /* @__PURE__ */ (0, K.jsx)("span", { children: "Removing..." })
  }) : /* @__PURE__ */ (0, K.jsx)("button", {
    className: "btn btn-link",
    onClick: () => C(),
    dangerouslySetInnerHTML: { __html: g }
  });
}, bs = class extends HTMLElement {
  connectedCallback() {
    const h = this.dataset.confirmText, g = this.dataset.cancelText, b = this.dataset.lineKey, s = this.dataset.ajax ? this.dataset.ajax === "true" : !0, x = () => {
      s || location.reload(), window.dispatchEvent(new CustomEvent("cart:remove:item", { detail: { lineKey: b } }));
    };
    (0, xc.createRoot)(this).render(/* @__PURE__ */ (0, K.jsx)(Eo, { children: b ? /* @__PURE__ */ (0, K.jsx)(vs, {
      lineKey: b,
      confirmText: h,
      cancelText: g,
      onSuccess: x,
      children: this.innerHTML
    }) : /* @__PURE__ */ (0, K.jsx)("p", { children: "(Line Key is required)" }) }));
  }
};
customElements.get("cart-remove-item") || customElements.define("cart-remove-item", bs);
var ys = class extends HTMLElement {
  connectedCallback() {
    const h = (this.dataset.events || "").split(/,\s*/).filter((b, s, x) => x.indexOf(b) === s), g = this.dataset.src;
    if (!g || !this.id) {
      console.warn("[ajax-component]", "src & id is required");
      return;
    }
    for (const b of h) window.addEventListener(b, () => {
      fetch(g).then((s) => {
        s.ok ? s.text().then((x) => {
          const C = new DOMParser().parseFromString(x, "text/html").getElementById(this.id);
          C && (this.innerHTML = C.innerHTML);
        }) : console.error("[ajax-component]", "Failed to fetch src", s.statusText);
      });
    });
  }
};
customElements.get("ajax-component") || customElements.define("ajax-component", ys);
var Es = class extends HTMLAnchorElement {
  connectedCallback() {
    this.addEventListener("click", (h) => {
      window.history.length > 1 && document.referrer && new URL(document.referrer).origin === window.location.origin && (h.preventDefault(), window.history.back());
    });
  }
};
customElements.get("go-back") || customElements.define("go-back", Es, { extends: "a" });
var Ts = /* @__PURE__ */ yo(((h) => {
  var g = bo(), b = ou();
  function s(e) {
    var l = "https://react.dev/errors/" + e;
    if (1 < arguments.length) {
      l += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var r = 2; r < arguments.length; r++) l += "&args[]=" + encodeURIComponent(arguments[r]);
    }
    return "Minified React error #" + e + "; visit " + l + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var x = /* @__PURE__ */ Symbol.for("react.transitional.element"), C = /* @__PURE__ */ Symbol.for("react.portal"), S = /* @__PURE__ */ Symbol.for("react.fragment"), M = /* @__PURE__ */ Symbol.for("react.strict_mode"), O = /* @__PURE__ */ Symbol.for("react.profiler"), D = /* @__PURE__ */ Symbol.for("react.consumer"), N = /* @__PURE__ */ Symbol.for("react.context"), W = /* @__PURE__ */ Symbol.for("react.forward_ref"), z = /* @__PURE__ */ Symbol.for("react.suspense"), U = /* @__PURE__ */ Symbol.for("react.suspense_list"), B = /* @__PURE__ */ Symbol.for("react.memo"), Y = /* @__PURE__ */ Symbol.for("react.lazy"), J = /* @__PURE__ */ Symbol.for("react.scope"), H = /* @__PURE__ */ Symbol.for("react.activity"), $ = /* @__PURE__ */ Symbol.for("react.legacy_hidden"), bn = /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel"), En = /* @__PURE__ */ Symbol.for("react.view_transition"), hn = Symbol.iterator;
  function p(e) {
    return e === null || typeof e != "object" ? null : (e = hn && e[hn] || e["@@iterator"], typeof e == "function" ? e : null);
  }
  var ln = Array.isArray;
  function on(e, l) {
    var r = e.length & 3, c = e.length - r, u = l;
    for (l = 0; l < c; ) {
      var d = e.charCodeAt(l) & 255 | (e.charCodeAt(++l) & 255) << 8 | (e.charCodeAt(++l) & 255) << 16 | (e.charCodeAt(++l) & 255) << 24;
      ++l, d = 3432918353 * (d & 65535) + ((3432918353 * (d >>> 16) & 65535) << 16) & 4294967295, d = d << 15 | d >>> 17, d = 461845907 * (d & 65535) + ((461845907 * (d >>> 16) & 65535) << 16) & 4294967295, u ^= d, u = u << 13 | u >>> 19, u = 5 * (u & 65535) + ((5 * (u >>> 16) & 65535) << 16) & 4294967295, u = (u & 65535) + 27492 + (((u >>> 16) + 58964 & 65535) << 16);
    }
    switch (d = 0, r) {
      case 3:
        d ^= (e.charCodeAt(l + 2) & 255) << 16;
      case 2:
        d ^= (e.charCodeAt(l + 1) & 255) << 8;
      case 1:
        d ^= e.charCodeAt(l) & 255, d = 3432918353 * (d & 65535) + ((3432918353 * (d >>> 16) & 65535) << 16) & 4294967295, d = d << 15 | d >>> 17, u ^= 461845907 * (d & 65535) + ((461845907 * (d >>> 16) & 65535) << 16) & 4294967295;
    }
    return u ^= e.length, u ^= u >>> 16, u = 2246822507 * (u & 65535) + ((2246822507 * (u >>> 16) & 65535) << 16) & 4294967295, u ^= u >>> 13, u = 3266489909 * (u & 65535) + ((3266489909 * (u >>> 16) & 65535) << 16) & 4294967295, (u ^ u >>> 16) >>> 0;
  }
  var cn = Object.assign, nn = Object.prototype.hasOwnProperty, An = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), ae = {}, _n = {};
  function Kn(e) {
    return nn.call(_n, e) ? !0 : nn.call(ae, e) ? !1 : An.test(e) ? _n[e] = !0 : (ae[e] = !0, !1);
  }
  var In = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" ")), On = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), _ = /["'&<>]/;
  function V(e) {
    if (typeof e == "boolean" || typeof e == "number" || typeof e == "bigint") return "" + e;
    e = "" + e;
    var l = _.exec(e);
    if (l) {
      var r = "", c, u = 0;
      for (c = l.index; c < e.length; c++) {
        switch (e.charCodeAt(c)) {
          case 34:
            l = "&quot;";
            break;
          case 38:
            l = "&amp;";
            break;
          case 39:
            l = "&#x27;";
            break;
          case 60:
            l = "&lt;";
            break;
          case 62:
            l = "&gt;";
            break;
          default:
            continue;
        }
        u !== c && (r += e.slice(u, c)), u = c + 1, r += l;
      }
      e = u !== c ? r + e.slice(u, c) : r;
    }
    return e;
  }
  var gn = /([A-Z])/g, Nn = /^ms-/, G = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function k(e) {
    return G.test("" + e) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : e;
  }
  var ee = g.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ft = b.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, te = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, rn = ft.d;
  ft.d = {
    f: rn.f,
    r: rn.r,
    D: ql,
    C: ze,
    L: Cc,
    m: Rr,
    X: Da,
    S: Na,
    M: Rc
  };
  var Yn = [], Xn = null, tt = /(<\/|<)(s)(cript)/gi;
  function he(e, l, r, c) {
    return "" + l + (r === "s" ? "\\u0073" : "\\u0053") + c;
  }
  function q(e, l, r, c, u) {
    return {
      idPrefix: e === void 0 ? "" : e,
      nextFormID: 0,
      streamingFormat: 0,
      bootstrapScriptContent: r,
      bootstrapScripts: c,
      bootstrapModules: u,
      instructions: 0,
      hasBody: !1,
      hasHtml: !1,
      unknownResources: {},
      dnsResources: {},
      connectResources: {
        default: {},
        anonymous: {},
        credentials: {}
      },
      imageResources: {},
      styleResources: {},
      scriptResources: {},
      moduleUnknownResources: {},
      moduleScriptResources: {}
    };
  }
  function tn(e, l, r, c) {
    return {
      insertionMode: e,
      selectedValue: l,
      tagScope: r,
      viewTransition: c
    };
  }
  function Mn(e, l, r) {
    var c = e.tagScope & -25;
    switch (l) {
      case "noscript":
        return tn(2, null, c | 1, null);
      case "select":
        return tn(2, r.value != null ? r.value : r.defaultValue, c, null);
      case "svg":
        return tn(4, null, c, null);
      case "picture":
        return tn(2, null, c | 2, null);
      case "math":
        return tn(5, null, c, null);
      case "foreignObject":
        return tn(2, null, c, null);
      case "table":
        return tn(6, null, c, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return tn(7, null, c, null);
      case "colgroup":
        return tn(9, null, c, null);
      case "tr":
        return tn(8, null, c, null);
      case "head":
        if (2 > e.insertionMode) return tn(3, null, c, null);
        break;
      case "html":
        if (e.insertionMode === 0) return tn(1, null, c, null);
    }
    return 6 <= e.insertionMode || 2 > e.insertionMode ? tn(2, null, c, null) : e.tagScope !== c ? tn(e.insertionMode, e.selectedValue, c, null) : e;
  }
  function j(e) {
    return e === null ? null : {
      update: e.update,
      enter: "none",
      exit: "none",
      share: e.update,
      name: e.autoName,
      autoName: e.autoName,
      nameIdx: 0
    };
  }
  function Ne(e, l) {
    return l.tagScope & 32 && (e.instructions |= 128), tn(l.insertionMode, l.selectedValue, l.tagScope | 12, j(l.viewTransition));
  }
  function De(e, l) {
    e = j(l.viewTransition);
    var r = l.tagScope | 16;
    return e !== null && e.share !== "none" && (r |= 64), tn(l.insertionMode, l.selectedValue, r, e);
  }
  var Ft = /* @__PURE__ */ new Map();
  function me(e, l) {
    if (typeof l != "object") throw Error(s(62));
    var r = !0, c;
    for (c in l) if (nn.call(l, c)) {
      var u = l[c];
      if (u != null && typeof u != "boolean" && u !== "") {
        if (c.indexOf("--") === 0) {
          var d = V(c);
          u = V(("" + u).trim());
        } else d = Ft.get(c), d === void 0 && (d = V(c.replace(gn, "-$1").toLowerCase().replace(Nn, "-ms-")), Ft.set(c, d)), u = typeof u == "number" ? u === 0 || In.has(c) ? "" + u : u + "px" : V(("" + u).trim());
        r ? (r = !1, e.push(' style="', d, ":", u)) : e.push(";", d, ":", u);
      }
    }
    r || e.push('"');
  }
  function Te(e, l, r) {
    r && typeof r != "function" && typeof r != "symbol" && e.push(" ", l, '=""');
  }
  function Zn(e, l, r) {
    typeof r != "function" && typeof r != "symbol" && typeof r != "boolean" && e.push(" ", l, '="', V(r), '"');
  }
  var bl = V("javascript:throw new Error('React form unexpectedly submitted.')");
  function Me(e, l) {
    this.push('<input type="hidden"'), xe(e), Zn(this, "name", l), Zn(this, "value", e), this.push("/>");
  }
  function xe(e) {
    if (typeof e != "string") throw Error(s(480));
  }
  function lt(e, l) {
    if (typeof l.$$FORM_ACTION == "function") {
      var r = e.nextFormID++;
      e = e.idPrefix + r;
      try {
        var c = l.$$FORM_ACTION(e);
        return c && c.data?.forEach(xe), c;
      } catch (u) {
        if (typeof u == "object" && u !== null && typeof u.then == "function") throw u;
      }
    }
    return null;
  }
  function Oi(e, l, r, c, u, d, y, I) {
    var T = null;
    if (typeof c == "function") {
      var A = lt(l, c);
      A !== null ? (I = A.name, c = A.action || "", u = A.encType, d = A.method, y = A.target, T = A.data) : (e.push(" ", "formAction", '="', bl, '"'), y = d = u = c = I = null, it(l, r));
    }
    return I != null && Tn(e, "name", I), c != null && Tn(e, "formAction", c), u != null && Tn(e, "formEncType", u), d != null && Tn(e, "formMethod", d), y != null && Tn(e, "formTarget", y), T;
  }
  function Tn(e, l, r) {
    switch (l) {
      case "className":
        Zn(e, "class", r);
        break;
      case "tabIndex":
        Zn(e, "tabindex", r);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        Zn(e, l, r);
        break;
      case "style":
        me(e, r);
        break;
      case "src":
      case "href":
        if (r === "") break;
      case "action":
      case "formAction":
        if (r == null || typeof r == "function" || typeof r == "symbol" || typeof r == "boolean") break;
        r = k("" + r), e.push(" ", l, '="', V(r), '"');
        break;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "ref":
        break;
      case "autoFocus":
      case "multiple":
      case "muted":
        Te(e, l.toLowerCase(), r);
        break;
      case "xlinkHref":
        if (typeof r == "function" || typeof r == "symbol" || typeof r == "boolean") break;
        r = k("" + r), e.push(" ", "xlink:href", '="', V(r), '"');
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        typeof r != "function" && typeof r != "symbol" && e.push(" ", l, '="', V(r), '"');
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        r && typeof r != "function" && typeof r != "symbol" && e.push(" ", l, '=""');
        break;
      case "capture":
      case "download":
        r === !0 ? e.push(" ", l, '=""') : r !== !1 && typeof r != "function" && typeof r != "symbol" && e.push(" ", l, '="', V(r), '"');
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        typeof r != "function" && typeof r != "symbol" && !isNaN(r) && 1 <= r && e.push(" ", l, '="', V(r), '"');
        break;
      case "rowSpan":
      case "start":
        typeof r == "function" || typeof r == "symbol" || isNaN(r) || e.push(" ", l, '="', V(r), '"');
        break;
      case "xlinkActuate":
        Zn(e, "xlink:actuate", r);
        break;
      case "xlinkArcrole":
        Zn(e, "xlink:arcrole", r);
        break;
      case "xlinkRole":
        Zn(e, "xlink:role", r);
        break;
      case "xlinkShow":
        Zn(e, "xlink:show", r);
        break;
      case "xlinkTitle":
        Zn(e, "xlink:title", r);
        break;
      case "xlinkType":
        Zn(e, "xlink:type", r);
        break;
      case "xmlBase":
        Zn(e, "xml:base", r);
        break;
      case "xmlLang":
        Zn(e, "xml:lang", r);
        break;
      case "xmlSpace":
        Zn(e, "xml:space", r);
        break;
      default:
        if ((!(2 < l.length) || l[0] !== "o" && l[0] !== "O" || l[1] !== "n" && l[1] !== "N") && (l = On.get(l) || l, Kn(l))) {
          switch (typeof r) {
            case "function":
            case "symbol":
              return;
            case "boolean":
              var c = l.toLowerCase().slice(0, 5);
              if (c !== "data-" && c !== "aria-") return;
          }
          e.push(" ", l, '="', V(r), '"');
        }
    }
  }
  function Fe(e, l, r) {
    if (l != null) {
      if (r != null) throw Error(s(60));
      if (typeof l != "object" || !("__html" in l)) throw Error(s(61));
      l = l.__html, l != null && e.push("" + l);
    }
  }
  function Zl(e) {
    var l = "";
    return g.Children.forEach(e, function(r) {
      r != null && (l += r);
    }), l;
  }
  function it(e, l) {
    if ((e.instructions & 16) === 0) {
      e.instructions |= 16;
      var r = l.preamble, c = l.bootstrapChunks;
      (r.htmlChunks || r.headChunks) && c.length === 0 ? (c.push(l.startInlineScript), pl(c, e), c.push(">", `addEventListener("submit",function(a){if(!a.defaultPrevented){var c=a.target,d=a.submitter,e=c.action,b=d;if(d){var f=d.getAttribute("formAction");null!=f&&(e=f,b=null)}"javascript:throw new Error('React form unexpectedly submitted.')"===e&&(a.preventDefault(),b?(a=document.createElement("input"),a.name=b.name,a.value=b.value,b.parentNode.insertBefore(a,b),b=new FormData(c),a.parentNode.removeChild(a)):b=new FormData(c),a=c.ownerDocument||c,(a.$$reactFormReplay=a.$$reactFormReplay||[]).push(c,d,b))}});`, "<\/script>")) : c.unshift(l.startInlineScript, ">", `addEventListener("submit",function(a){if(!a.defaultPrevented){var c=a.target,d=a.submitter,e=c.action,b=d;if(d){var f=d.getAttribute("formAction");null!=f&&(e=f,b=null)}"javascript:throw new Error('React form unexpectedly submitted.')"===e&&(a.preventDefault(),b?(a=document.createElement("input"),a.name=b.name,a.value=b.value,b.parentNode.insertBefore(a,b),b=new FormData(c),a.parentNode.removeChild(a)):b=new FormData(c),a=c.ownerDocument||c,(a.$$reactFormReplay=a.$$reactFormReplay||[]).push(c,d,b))}});`, "<\/script>");
    }
  }
  function jn(e, l) {
    e.push(Dn("link"));
    for (var r in l) if (nn.call(l, r)) {
      var c = l[r];
      if (c != null) switch (r) {
        case "children":
        case "dangerouslySetInnerHTML":
          throw Error(s(399, "link"));
        default:
          Tn(e, r, c);
      }
    }
    return e.push("/>"), null;
  }
  var Vt = /(<\/|<)(s)(tyle)/gi;
  function It(e, l, r, c) {
    return "" + l + (r === "s" ? "\\73 " : "\\53 ") + c;
  }
  function At(e, l, r) {
    e.push(Dn(r));
    for (var c in l) if (nn.call(l, c)) {
      var u = l[c];
      if (u != null) switch (c) {
        case "children":
        case "dangerouslySetInnerHTML":
          throw Error(s(399, r));
        default:
          Tn(e, c, u);
      }
    }
    return e.push("/>"), null;
  }
  function yl(e, l) {
    e.push(Dn("title"));
    var r = null, c = null, u;
    for (u in l) if (nn.call(l, u)) {
      var d = l[u];
      if (d != null) switch (u) {
        case "children":
          r = d;
          break;
        case "dangerouslySetInnerHTML":
          c = d;
          break;
        default:
          Tn(e, u, d);
      }
    }
    return e.push(">"), l = Array.isArray(r) ? 2 > r.length ? r[0] : null : r, typeof l != "function" && typeof l != "symbol" && l !== null && l !== void 0 && e.push(V("" + l)), Fe(e, c, r), e.push(rt("title")), null;
  }
  function _t(e, l) {
    e.push(Dn("script"));
    var r = null, c = null, u;
    for (u in l) if (nn.call(l, u)) {
      var d = l[u];
      if (d != null) switch (u) {
        case "children":
          r = d;
          break;
        case "dangerouslySetInnerHTML":
          c = d;
          break;
        default:
          Tn(e, u, d);
      }
    }
    return e.push(">"), Fe(e, c, r), typeof r == "string" && e.push(("" + r).replace(tt, he)), e.push(rt("script")), null;
  }
  function Jl(e, l, r) {
    e.push(Dn(r));
    var c = r = null, u;
    for (u in l) if (nn.call(l, u)) {
      var d = l[u];
      if (d != null) switch (u) {
        case "children":
          r = d;
          break;
        case "dangerouslySetInnerHTML":
          c = d;
          break;
        default:
          Tn(e, u, d);
      }
    }
    return e.push(">"), Fe(e, c, r), r;
  }
  function El(e, l, r) {
    e.push(Dn(r));
    var c = r = null, u;
    for (u in l) if (nn.call(l, u)) {
      var d = l[u];
      if (d != null) switch (u) {
        case "children":
          r = d;
          break;
        case "dangerouslySetInnerHTML":
          c = d;
          break;
        default:
          Tn(e, u, d);
      }
    }
    return e.push(">"), Fe(e, c, r), typeof r == "string" ? (e.push(V(r)), null) : r;
  }
  var Kt = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Ql = /* @__PURE__ */ new Map();
  function Dn(e) {
    var l = Ql.get(e);
    if (l === void 0) {
      if (!Kt.test(e)) throw Error(s(65, e));
      l = "<" + e, Ql.set(e, l);
    }
    return l;
  }
  function le(e, l, r, c, u, d, y, I, T) {
    switch (l) {
      case "div":
      case "span":
      case "svg":
      case "path":
        break;
      case "a":
        e.push(Dn("a"));
        var A = null, m = null, L;
        for (L in r) if (nn.call(r, L)) {
          var Z = r[L];
          if (Z != null) switch (L) {
            case "children":
              A = Z;
              break;
            case "dangerouslySetInnerHTML":
              m = Z;
              break;
            case "href":
              Z === "" ? Zn(e, "href", "") : Tn(e, L, Z);
              break;
            default:
              Tn(e, L, Z);
          }
        }
        if (e.push(">"), Fe(e, m, A), typeof A == "string") {
          e.push(V(A));
          var en = null;
        } else en = A;
        return en;
      case "g":
      case "p":
      case "li":
        break;
      case "select":
        e.push(Dn("select"));
        var xn = null, fn = null, sn;
        for (sn in r) if (nn.call(r, sn)) {
          var un = r[sn];
          if (un != null) switch (sn) {
            case "children":
              xn = un;
              break;
            case "dangerouslySetInnerHTML":
              fn = un;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              Tn(e, sn, un);
          }
        }
        return e.push(">"), Fe(e, fn, xn), xn;
      case "option":
        var dn = I.selectedValue;
        e.push(Dn("option"));
        var Wn = null, Vn = null, Rn = null, Fn = null, wn;
        for (wn in r) if (nn.call(r, wn)) {
          var ke = r[wn];
          if (ke != null) switch (wn) {
            case "children":
              Wn = ke;
              break;
            case "selected":
              Rn = ke;
              break;
            case "dangerouslySetInnerHTML":
              Fn = ke;
              break;
            case "value":
              Vn = ke;
            default:
              Tn(e, wn, ke);
          }
        }
        if (dn != null) {
          var Sn = Vn !== null ? "" + Vn : Zl(Wn);
          if (ln(dn)) {
            for (var We = 0; We < dn.length; We++) if ("" + dn[We] === Sn) {
              e.push(' selected=""');
              break;
            }
          } else "" + dn === Sn && e.push(' selected=""');
        } else Rn && e.push(' selected=""');
        return e.push(">"), Fe(e, Fn, Wn), Wn;
      case "textarea":
        e.push(Dn("textarea"));
        var kn = null, re = null, oe = null, Un;
        for (Un in r) if (nn.call(r, Un)) {
          var Ae = r[Un];
          if (Ae != null) switch (Un) {
            case "children":
              oe = Ae;
              break;
            case "value":
              kn = Ae;
              break;
            case "defaultValue":
              re = Ae;
              break;
            case "dangerouslySetInnerHTML":
              throw Error(s(91));
            default:
              Tn(e, Un, Ae);
          }
        }
        if (kn === null && re !== null && (kn = re), e.push(">"), oe != null) {
          if (kn != null) throw Error(s(92));
          if (ln(oe)) {
            if (1 < oe.length) throw Error(s(93));
            kn = "" + oe[0];
          }
          kn = "" + oe;
        }
        return typeof kn == "string" && kn[0] === `
` && e.push(`
`), kn !== null && e.push(V("" + kn)), null;
      case "input":
        e.push(Dn("input"));
        var ol = null, Ue = null, si = null, _l = null, Ce = null, Je = null, nt = null, et = null, dt = null, zt;
        for (zt in r) if (nn.call(r, zt)) {
          var se = r[zt];
          if (se != null) switch (zt) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(s(399, "input"));
            case "name":
              ol = se;
              break;
            case "formAction":
              Ue = se;
              break;
            case "formEncType":
              si = se;
              break;
            case "formMethod":
              _l = se;
              break;
            case "formTarget":
              Ce = se;
              break;
            case "defaultChecked":
              dt = se;
              break;
            case "defaultValue":
              nt = se;
              break;
            case "checked":
              et = se;
              break;
            case "value":
              Je = se;
              break;
            default:
              Tn(e, zt, se);
          }
        }
        var Pl = Oi(e, c, u, Ue, si, _l, Ce, ol);
        return et !== null ? Te(e, "checked", et) : dt !== null && Te(e, "checked", dt), Je !== null ? Tn(e, "value", Je) : nt !== null && Tn(e, "value", nt), e.push("/>"), Pl?.forEach(Me, e), null;
      case "button":
        e.push(Dn("button"));
        var hi = null, Xr = null, Zr = null, ja = null, Jr = null, di = null, $a = null, ul;
        for (ul in r) if (nn.call(r, ul)) {
          var ot = r[ul];
          if (ot != null) switch (ul) {
            case "children":
              hi = ot;
              break;
            case "dangerouslySetInnerHTML":
              Xr = ot;
              break;
            case "name":
              Zr = ot;
              break;
            case "formAction":
              ja = ot;
              break;
            case "formEncType":
              Jr = ot;
              break;
            case "formMethod":
              di = ot;
              break;
            case "formTarget":
              $a = ot;
              break;
            default:
              Tn(e, ul, ot);
          }
        }
        var kl = Oi(e, c, u, ja, Jr, di, $a, Zr);
        if (e.push(">"), kl?.forEach(Me, e), Fe(e, Xr, hi), typeof hi == "string") {
          e.push(V(hi));
          var cr = null;
        } else cr = hi;
        return cr;
      case "form":
        e.push(Dn("form"));
        var Ht = null, Qr = null, Qe = null, gi = null, Ol = null, Ll = null, vi;
        for (vi in r) if (nn.call(r, vi)) {
          var gt = r[vi];
          if (gt != null) switch (vi) {
            case "children":
              Ht = gt;
              break;
            case "dangerouslySetInnerHTML":
              Qr = gt;
              break;
            case "action":
              Qe = gt;
              break;
            case "encType":
              gi = gt;
              break;
            case "method":
              Ol = gt;
              break;
            case "target":
              Ll = gt;
              break;
            default:
              Tn(e, vi, gt);
          }
        }
        var nc = null, ue = null;
        if (typeof Qe == "function") {
          var Wt = lt(c, Qe);
          Wt !== null ? (Qe = Wt.action || "", gi = Wt.encType, Ol = Wt.method, Ll = Wt.target, nc = Wt.data, ue = Wt.name) : (e.push(" ", "action", '="', bl, '"'), Ll = Ol = gi = Qe = null, it(c, u));
        }
        if (Qe != null && Tn(e, "action", Qe), gi != null && Tn(e, "encType", gi), Ol != null && Tn(e, "method", Ol), Ll != null && Tn(e, "target", Ll), e.push(">"), ue !== null && (e.push('<input type="hidden"'), Zn(e, "name", ue), e.push("/>"), nc?.forEach(Me, e)), Fe(e, Qr, Ht), typeof Ht == "string") {
          e.push(V(Ht));
          var Nl = null;
        } else Nl = Ht;
        return Nl;
      case "menuitem":
        e.push(Dn("menuitem"));
        for (var Ut in r) if (nn.call(r, Ut)) {
          var or = r[Ut];
          if (or != null) switch (Ut) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(s(400));
            default:
              Tn(e, Ut, or);
          }
        }
        return e.push(">"), null;
      case "object":
        e.push(Dn("object"));
        var Ve = null, Gt = null, fl;
        for (fl in r) if (nn.call(r, fl)) {
          var Ke = r[fl];
          if (Ke != null) switch (fl) {
            case "children":
              Ve = Ke;
              break;
            case "dangerouslySetInnerHTML":
              Gt = Ke;
              break;
            case "data":
              var ve = k("" + Ke);
              if (ve === "") break;
              e.push(" ", "data", '="', V(ve), '"');
              break;
            default:
              Tn(e, fl, Ke);
          }
        }
        if (e.push(">"), Fe(e, Gt, Ve), typeof Ve == "string") {
          e.push(V(Ve));
          var Dl = null;
        } else Dl = Ve;
        return Dl;
      case "title":
        var Re = I.tagScope & 1, Vr = I.tagScope & 4;
        if (I.insertionMode === 4 || Re || r.itemProp != null) var bi = yl(e, r);
        else Vr ? bi = null : (yl(u.hoistableChunks, r), bi = void 0);
        return bi;
      case "link":
        var yi = I.tagScope & 1, ec = I.tagScope & 4, tc = r.rel, vt = r.href, sl = r.precedence;
        if (I.insertionMode === 4 || yi || r.itemProp != null || typeof tc != "string" || typeof vt != "string" || vt === "") {
          jn(e, r);
          var Yt = null;
        } else if (r.rel === "stylesheet") if (typeof sl != "string" || r.disabled != null || r.onLoad || r.onError) Yt = jn(e, r);
        else {
          var be = u.styles.get(sl), ml = c.styleResources.hasOwnProperty(vt) ? c.styleResources[vt] : void 0;
          if (ml !== null) {
            c.styleResources[vt] = null, be || (be = {
              precedence: V(sl),
              rules: [],
              hrefs: [],
              sheets: /* @__PURE__ */ new Map()
            }, u.styles.set(sl, be));
            var Bl = {
              state: 0,
              props: cn({}, r, {
                "data-precedence": r.precedence,
                precedence: null
              })
            };
            if (ml) {
              ml.length === 2 && jl(Bl.props, ml);
              var ur = u.preloads.stylesheets.get(vt);
              ur && 0 < ur.length ? ur.length = 0 : Bl.state = 1;
            }
            be.sheets.set(vt, Bl), y && y.stylesheets.add(Bl);
          } else if (be) {
            var fr = be.sheets.get(vt);
            fr && y && y.stylesheets.add(fr);
          }
          T && e.push("<!-- -->"), Yt = null;
        }
        else r.onLoad || r.onError ? Yt = jn(e, r) : (T && e.push("<!-- -->"), Yt = ec ? null : jn(u.hoistableChunks, r));
        return Yt;
      case "script":
        var Kr = I.tagScope & 1, sr = r.async;
        if (typeof r.src != "string" || !r.src || !sr || typeof sr == "function" || typeof sr == "symbol" || r.onLoad || r.onError || I.insertionMode === 4 || Kr || r.itemProp != null) var pr = _t(e, r);
        else {
          var $n = r.src;
          if (r.type === "module")
            var hr = c.moduleScriptResources, zl = u.preloads.moduleScripts;
          else hr = c.scriptResources, zl = u.preloads.scripts;
          var Hl = hr.hasOwnProperty($n) ? hr[$n] : void 0;
          if (Hl !== null) {
            hr[$n] = null;
            var Ei = r;
            if (Hl) {
              Hl.length === 2 && (Ei = cn({}, r), jl(Ei, Hl));
              var dr = zl.get($n);
              dr && (dr.length = 0);
            }
            var Ti = [];
            u.scripts.add(Ti), _t(Ti, Ei);
          }
          T && e.push("<!-- -->"), pr = null;
        }
        return pr;
      case "style":
        var xi = I.tagScope & 1, bt = r.precedence, Ge = r.href, qr = r.nonce;
        if (I.insertionMode === 4 || xi || r.itemProp != null || typeof bt != "string" || typeof Ge != "string" || Ge === "") {
          e.push(Dn("style"));
          var Xt = null, jr = null, yt;
          for (yt in r) if (nn.call(r, yt)) {
            var hl = r[yt];
            if (hl != null) switch (yt) {
              case "children":
                Xt = hl;
                break;
              case "dangerouslySetInnerHTML":
                jr = hl;
                break;
              default:
                Tn(e, yt, hl);
            }
          }
          e.push(">");
          var Et = Array.isArray(Xt) ? 2 > Xt.length ? Xt[0] : null : Xt;
          typeof Et != "function" && typeof Et != "symbol" && Et !== null && Et !== void 0 && e.push(("" + Et).replace(Vt, It)), Fe(e, jr, Xt), e.push(rt("style"));
          var Wl = null;
        } else {
          var Tt = u.styles.get(bt);
          if ((c.styleResources.hasOwnProperty(Ge) ? c.styleResources[Ge] : void 0) !== null) {
            c.styleResources[Ge] = null, Tt || (Tt = {
              precedence: V(bt),
              rules: [],
              hrefs: [],
              sheets: /* @__PURE__ */ new Map()
            }, u.styles.set(bt, Tt));
            var $r = u.nonce.style;
            if (!$r || $r === qr) {
              Tt.hrefs.push(V(Ge));
              var na = Tt.rules, xt = null, wi = null, dl;
              for (dl in r) if (nn.call(r, dl)) {
                var wt = r[dl];
                if (wt != null) switch (dl) {
                  case "children":
                    xt = wt;
                    break;
                  case "dangerouslySetInnerHTML":
                    wi = wt;
                }
              }
              var Zt = Array.isArray(xt) ? 2 > xt.length ? xt[0] : null : xt;
              typeof Zt != "function" && typeof Zt != "symbol" && Zt !== null && Zt !== void 0 && na.push(("" + Zt).replace(Vt, It)), Fe(na, wi, xt);
            }
          }
          Tt && y && y.styles.add(Tt), T && e.push("<!-- -->"), Wl = void 0;
        }
        return Wl;
      case "meta":
        var pe = I.tagScope & 1, gr = I.tagScope & 4;
        if (I.insertionMode === 4 || pe || r.itemProp != null) var ea = At(e, r, "meta");
        else T && e.push("<!-- -->"), ea = gr ? null : typeof r.charSet == "string" ? At(u.charsetChunks, r, "meta") : r.name === "viewport" ? At(u.viewportChunks, r, "meta") : At(u.hoistableChunks, r, "meta");
        return ea;
      case "listing":
      case "pre":
        e.push(Dn(l));
        var Ul = null, n = null, t;
        for (t in r) if (nn.call(r, t)) {
          var i = r[t];
          if (i != null) switch (t) {
            case "children":
              Ul = i;
              break;
            case "dangerouslySetInnerHTML":
              n = i;
              break;
            default:
              Tn(e, t, i);
          }
        }
        if (e.push(">"), n != null) {
          if (Ul != null) throw Error(s(60));
          if (typeof n != "object" || !("__html" in n)) throw Error(s(61));
          var a = n.__html;
          a != null && (typeof a == "string" && 0 < a.length && a[0] === `
` ? e.push(`
`, a) : e.push("" + a));
        }
        return typeof Ul == "string" && Ul[0] === `
` && e.push(`
`), Ul;
      case "img":
        var o = I.tagScope & 3, f = r.src, v = r.srcSet;
        if (!(r.loading === "lazy" || !f && !v || typeof f != "string" && f != null || typeof v != "string" && v != null || r.fetchPriority === "low" || o) && (typeof f != "string" || f[4] !== ":" || f[0] !== "d" && f[0] !== "D" || f[1] !== "a" && f[1] !== "A" || f[2] !== "t" && f[2] !== "T" || f[3] !== "a" && f[3] !== "A") && (typeof v != "string" || v[4] !== ":" || v[0] !== "d" && v[0] !== "D" || v[1] !== "a" && v[1] !== "A" || v[2] !== "t" && v[2] !== "T" || v[3] !== "a" && v[3] !== "A")) {
          y !== null && I.tagScope & 64 && (y.suspenseyImages = !0);
          var R = typeof r.sizes == "string" ? r.sizes : void 0, E = v ? v + `
` + (R || "") : f, w = u.preloads.images, F = w.get(E);
          if (F)
            (r.fetchPriority === "high" || 10 > u.highImagePreloads.size) && (w.delete(E), u.highImagePreloads.add(F));
          else if (!c.imageResources.hasOwnProperty(E)) {
            c.imageResources[E] = Yn;
            var P = r.crossOrigin, X = typeof P == "string" ? P === "use-credentials" ? P : "" : void 0, Q = u.headers, Cn;
            Q && 0 < Q.remainingCapacity && typeof r.srcSet != "string" && (r.fetchPriority === "high" || 500 > Q.highImagePreloads.length) && (Cn = ce(f, "image", {
              imageSrcSet: r.srcSet,
              imageSizes: r.sizes,
              crossOrigin: X,
              integrity: r.integrity,
              nonce: r.nonce,
              type: r.type,
              fetchPriority: r.fetchPriority,
              referrerPolicy: r.refererPolicy
            }), 0 <= (Q.remainingCapacity -= Cn.length + 2)) ? (u.resets.image[E] = Yn, Q.highImagePreloads && (Q.highImagePreloads += ", "), Q.highImagePreloads += Cn) : (F = [], jn(F, {
              rel: "preload",
              as: "image",
              href: v ? void 0 : f,
              imageSrcSet: v,
              imageSizes: R,
              crossOrigin: X,
              integrity: r.integrity,
              type: r.type,
              fetchPriority: r.fetchPriority,
              referrerPolicy: r.referrerPolicy
            }), r.fetchPriority === "high" || 10 > u.highImagePreloads.size ? u.highImagePreloads.add(F) : (u.bulkPreloads.add(F), w.set(E, F)));
          }
        }
        return At(e, r, "img");
      case "base":
      case "area":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "param":
      case "source":
      case "track":
      case "wbr":
        return At(e, r, l);
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        break;
      case "head":
        if (2 > I.insertionMode) {
          var vn = d || u.preamble;
          if (vn.headChunks) throw Error(s(545, "`<head>`"));
          d !== null && e.push("<!--head-->"), vn.headChunks = [];
          var yn = Jl(vn.headChunks, r, "head");
        } else yn = El(e, r, "head");
        return yn;
      case "body":
        if (2 > I.insertionMode) {
          var Hn = d || u.preamble;
          if (Hn.bodyChunks) throw Error(s(545, "`<body>`"));
          d !== null && e.push("<!--body-->"), Hn.bodyChunks = [];
          var Ln = Jl(Hn.bodyChunks, r, "body");
        } else Ln = El(e, r, "body");
        return Ln;
      case "html":
        if (I.insertionMode === 0) {
          var ye = d || u.preamble;
          if (ye.htmlChunks) throw Error(s(545, "`<html>`"));
          d !== null && e.push("<!--html-->"), ye.htmlChunks = [""];
          var Oe = Jl(ye.htmlChunks, r, "html");
        } else Oe = El(e, r, "html");
        return Oe;
      default:
        if (l.indexOf("-") !== -1) {
          e.push(Dn(l));
          var qe = null, an = null, Se;
          for (Se in r) if (nn.call(r, Se)) {
            var pn = r[Se];
            if (pn != null) {
              var _e = Se;
              switch (Se) {
                case "children":
                  qe = pn;
                  break;
                case "dangerouslySetInnerHTML":
                  an = pn;
                  break;
                case "style":
                  me(e, pn);
                  break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                case "ref":
                  break;
                case "className":
                  _e = "class";
                default:
                  if (Kn(Se) && typeof pn != "function" && typeof pn != "symbol" && pn !== !1) {
                    if (pn === !0) pn = "";
                    else if (typeof pn == "object") continue;
                    e.push(" ", _e, '="', V(pn), '"');
                  }
              }
            }
          }
          return e.push(">"), Fe(e, an, qe), qe;
        }
    }
    return El(e, r, l);
  }
  var Tl = /* @__PURE__ */ new Map();
  function rt(e) {
    var l = Tl.get(e);
    return l === void 0 && (l = "</" + e + ">", Tl.set(e, l)), l;
  }
  function xl(e, l) {
    e = e.preamble, e.htmlChunks === null && l.htmlChunks && (e.htmlChunks = l.htmlChunks), e.headChunks === null && l.headChunks && (e.headChunks = l.headChunks), e.bodyChunks === null && l.bodyChunks && (e.bodyChunks = l.bodyChunks);
  }
  function pt(e, l) {
    l = l.bootstrapChunks;
    for (var r = 0; r < l.length - 1; r++) e.push(l[r]);
    return r < l.length ? (r = l[r], l.length = 0, e.push(r)) : !0;
  }
  function qt(e, l, r) {
    if (e.push('<!--$?--><template id="'), r === null) throw Error(s(395));
    return e.push(l.boundaryPrefix), l = r.toString(16), e.push(l), e.push('"></template>');
  }
  function $e(e, l, r, c) {
    switch (r.insertionMode) {
      case 0:
      case 1:
      case 3:
      case 2:
        return e.push('<div hidden id="'), e.push(l.segmentPrefix), l = c.toString(16), e.push(l), e.push('">');
      case 4:
        return e.push('<svg aria-hidden="true" style="display:none" id="'), e.push(l.segmentPrefix), l = c.toString(16), e.push(l), e.push('">');
      case 5:
        return e.push('<math aria-hidden="true" style="display:none" id="'), e.push(l.segmentPrefix), l = c.toString(16), e.push(l), e.push('">');
      case 6:
        return e.push('<table hidden id="'), e.push(l.segmentPrefix), l = c.toString(16), e.push(l), e.push('">');
      case 7:
        return e.push('<table hidden><tbody id="'), e.push(l.segmentPrefix), l = c.toString(16), e.push(l), e.push('">');
      case 8:
        return e.push('<table hidden><tr id="'), e.push(l.segmentPrefix), l = c.toString(16), e.push(l), e.push('">');
      case 9:
        return e.push('<table hidden><colgroup id="'), e.push(l.segmentPrefix), l = c.toString(16), e.push(l), e.push('">');
      default:
        throw Error(s(397));
    }
  }
  function Ia(e, l) {
    switch (l.insertionMode) {
      case 0:
      case 1:
      case 3:
      case 2:
        return e.push("</div>");
      case 4:
        return e.push("</svg>");
      case 5:
        return e.push("</math>");
      case 6:
        return e.push("</table>");
      case 7:
        return e.push("</tbody></table>");
      case 8:
        return e.push("</tr></table>");
      case 9:
        return e.push("</colgroup></table>");
      default:
        throw Error(s(397));
    }
  }
  var Aa = /[<\u2028\u2029]/g;
  function wc(e) {
    return JSON.stringify(e).replace(Aa, function(l) {
      switch (l) {
        case "<":
          return "\\u003c";
        case "\u2028":
          return "\\u2028";
        case "\u2029":
          return "\\u2029";
        default:
          throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
      }
    });
  }
  var _a = /[&><\u2028\u2029]/g;
  function Vl(e) {
    return JSON.stringify(e).replace(_a, function(l) {
      switch (l) {
        case "&":
          return "\\u0026";
        case ">":
          return "\\u003e";
        case "<":
          return "\\u003c";
        case "\u2028":
          return "\\u2028";
        case "\u2029":
          return "\\u2029";
        default:
          throw Error("escapeJSObjectForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
      }
    });
  }
  var Kl = !1, de = !0;
  function Xe(e) {
    var l = e.rules, r = e.hrefs, c = 0;
    if (r.length) {
      for (this.push(Xn.startInlineStyle), this.push(' media="not all" data-precedence="'), this.push(e.precedence), this.push('" data-href="'); c < r.length - 1; c++) this.push(r[c]), this.push(" ");
      for (this.push(r[c]), this.push('">'), c = 0; c < l.length; c++) this.push(l[c]);
      de = this.push("</style>"), Kl = !0, l.length = 0, r.length = 0;
    }
  }
  function Jn(e) {
    return e.state !== 2 ? Kl = !0 : !1;
  }
  function Li(e, l, r) {
    return Kl = !1, de = !0, Xn = r, l.styles.forEach(Xe, e), Xn = null, l.stylesheets.forEach(Jn), Kl && (r.stylesToHoist = !0), de;
  }
  function Be(e) {
    for (var l = 0; l < e.length; l++) this.push(e[l]);
    e.length = 0;
  }
  var Qn = [];
  function Pa(e) {
    jn(Qn, e.props);
    for (var l = 0; l < Qn.length; l++) this.push(Qn[l]);
    Qn.length = 0, e.state = 2;
  }
  function ka(e) {
    var l = 0 < e.sheets.size;
    e.sheets.forEach(Pa, this), e.sheets.clear();
    var r = e.rules, c = e.hrefs;
    if (!l || c.length) {
      if (this.push(Xn.startInlineStyle), this.push(' data-precedence="'), this.push(e.precedence), e = 0, c.length) {
        for (this.push('" data-href="'); e < c.length - 1; e++) this.push(c[e]), this.push(" ");
        this.push(c[e]);
      }
      for (this.push('">'), e = 0; e < r.length; e++) this.push(r[e]);
      this.push("</style>"), r.length = 0, c.length = 0;
    }
  }
  function Cr(e) {
    if (e.state === 0) {
      e.state = 1;
      var l = e.props;
      for (jn(Qn, {
        rel: "preload",
        as: "style",
        href: e.props.href,
        crossOrigin: l.crossOrigin,
        fetchPriority: l.fetchPriority,
        integrity: l.integrity,
        media: l.media,
        hrefLang: l.hrefLang,
        referrerPolicy: l.referrerPolicy
      }), e = 0; e < Qn.length; e++) this.push(Qn[e]);
      Qn.length = 0;
    }
  }
  function Oa(e) {
    e.sheets.forEach(Cr, this), e.sheets.clear();
  }
  function pl(e, l) {
    (l.instructions & 32) === 0 && (l.instructions |= 32, e.push(' id="', V("_" + l.idPrefix + "R_"), '"'));
  }
  function La(e, l) {
    e.push("[");
    var r = "[";
    l.stylesheets.forEach(function(c) {
      if (c.state !== 2) if (c.state === 3) e.push(r), c = Vl("" + c.props.href), e.push(c), e.push("]"), r = ",[";
      else {
        e.push(r);
        var u = c.props["data-precedence"], d = c.props, y = k("" + c.props.href);
        y = Vl(y), e.push(y), u = "" + u, e.push(","), u = Vl(u), e.push(u);
        for (var I in d) if (nn.call(d, I) && (u = d[I], u != null)) switch (I) {
          case "href":
          case "rel":
          case "precedence":
          case "data-precedence":
            break;
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(s(399, "link"));
          default:
            Pn(e, I, u);
        }
        e.push("]"), r = ",[", c.state = 3;
      }
    }), e.push("]");
  }
  function Pn(e, l, r) {
    var c = l.toLowerCase();
    switch (typeof r) {
      case "function":
      case "symbol":
        return;
    }
    switch (l) {
      case "innerHTML":
      case "dangerouslySetInnerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "style":
      case "ref":
        return;
      case "className":
        c = "class", l = "" + r;
        break;
      case "hidden":
        if (r === !1) return;
        l = "";
        break;
      case "src":
      case "href":
        r = k(r), l = "" + r;
        break;
      default:
        if (2 < l.length && (l[0] === "o" || l[0] === "O") && (l[1] === "n" || l[1] === "N") || !Kn(l)) return;
        l = "" + r;
    }
    e.push(","), c = Vl(c), e.push(c), e.push(","), c = Vl(l), e.push(c);
  }
  function zn() {
    return {
      styles: /* @__PURE__ */ new Set(),
      stylesheets: /* @__PURE__ */ new Set(),
      suspenseyImages: !1
    };
  }
  function ql(e) {
    var l = ge || null;
    if (l) {
      var r = l.resumableState, c = l.renderState;
      if (typeof e == "string" && e) {
        if (!r.dnsResources.hasOwnProperty(e)) {
          r.dnsResources[e] = null, r = c.headers;
          var u, d;
          (d = r && 0 < r.remainingCapacity) && (d = (u = "<" + ("" + e).replace(Ni, Di) + ">; rel=dns-prefetch", 0 <= (r.remainingCapacity -= u.length + 2))), d ? (c.resets.dns[e] = null, r.preconnects && (r.preconnects += ", "), r.preconnects += u) : (u = [], jn(u, {
            href: e,
            rel: "dns-prefetch"
          }), c.preconnects.add(u));
        }
        cl(l);
      }
    } else rn.D(e);
  }
  function ze(e, l) {
    var r = ge || null;
    if (r) {
      var c = r.resumableState, u = r.renderState;
      if (typeof e == "string" && e) {
        var d = l === "use-credentials" ? "credentials" : typeof l == "string" ? "anonymous" : "default";
        if (!c.connectResources[d].hasOwnProperty(e)) {
          c.connectResources[d][e] = null, c = u.headers;
          var y, I;
          if (I = c && 0 < c.remainingCapacity) {
            if (I = "<" + ("" + e).replace(Ni, Di) + ">; rel=preconnect", typeof l == "string") {
              var T = ("" + l).replace(Pt, mi);
              I += '; crossorigin="' + T + '"';
            }
            I = (y = I, 0 <= (c.remainingCapacity -= y.length + 2));
          }
          I ? (u.resets.connect[d][e] = null, c.preconnects && (c.preconnects += ", "), c.preconnects += y) : (d = [], jn(d, {
            rel: "preconnect",
            href: e,
            crossOrigin: l
          }), u.preconnects.add(d));
        }
        cl(r);
      }
    } else rn.C(e, l);
  }
  function Cc(e, l, r) {
    var c = ge || null;
    if (c) {
      var u = c.resumableState, d = c.renderState;
      if (l && e) {
        switch (l) {
          case "image":
            if (r)
              var y = r.imageSrcSet, I = r.imageSizes, T = r.fetchPriority;
            var A = y ? y + `
` + (I || "") : e;
            if (u.imageResources.hasOwnProperty(A)) return;
            u.imageResources[A] = Yn, u = d.headers;
            var m;
            u && 0 < u.remainingCapacity && typeof y != "string" && T === "high" && (m = ce(e, l, r), 0 <= (u.remainingCapacity -= m.length + 2)) ? (d.resets.image[A] = Yn, u.highImagePreloads && (u.highImagePreloads += ", "), u.highImagePreloads += m) : (u = [], jn(u, cn({
              rel: "preload",
              href: y ? void 0 : e,
              as: l
            }, r)), T === "high" ? d.highImagePreloads.add(u) : (d.bulkPreloads.add(u), d.preloads.images.set(A, u)));
            break;
          case "style":
            if (u.styleResources.hasOwnProperty(e)) return;
            y = [], jn(y, cn({
              rel: "preload",
              href: e,
              as: l
            }, r)), u.styleResources[e] = !r || typeof r.crossOrigin != "string" && typeof r.integrity != "string" ? Yn : [r.crossOrigin, r.integrity], d.preloads.stylesheets.set(e, y), d.bulkPreloads.add(y);
            break;
          case "script":
            if (u.scriptResources.hasOwnProperty(e)) return;
            y = [], d.preloads.scripts.set(e, y), d.bulkPreloads.add(y), jn(y, cn({
              rel: "preload",
              href: e,
              as: l
            }, r)), u.scriptResources[e] = !r || typeof r.crossOrigin != "string" && typeof r.integrity != "string" ? Yn : [r.crossOrigin, r.integrity];
            break;
          default:
            if (u.unknownResources.hasOwnProperty(l)) {
              if (y = u.unknownResources[l], y.hasOwnProperty(e)) return;
            } else y = {}, u.unknownResources[l] = y;
            y[e] = Yn, (u = d.headers) && 0 < u.remainingCapacity && l === "font" && (A = ce(e, l, r), 0 <= (u.remainingCapacity -= A.length + 2)) ? (d.resets.font[e] = Yn, u.fontPreloads && (u.fontPreloads += ", "), u.fontPreloads += A) : (u = [], e = cn({
              rel: "preload",
              href: e,
              as: l
            }, r), jn(u, e), l) === "font" ? d.fontPreloads.add(u) : d.bulkPreloads.add(u);
        }
        cl(c);
      }
    } else rn.L(e, l, r);
  }
  function Rr(e, l) {
    var r = ge || null;
    if (r) {
      var c = r.resumableState, u = r.renderState;
      if (e) {
        var d = l && typeof l.as == "string" ? l.as : "script";
        switch (d) {
          case "script":
            if (c.moduleScriptResources.hasOwnProperty(e)) return;
            d = [], c.moduleScriptResources[e] = !l || typeof l.crossOrigin != "string" && typeof l.integrity != "string" ? Yn : [l.crossOrigin, l.integrity], u.preloads.moduleScripts.set(e, d);
            break;
          default:
            if (c.moduleUnknownResources.hasOwnProperty(d)) {
              var y = c.unknownResources[d];
              if (y.hasOwnProperty(e)) return;
            } else y = {}, c.moduleUnknownResources[d] = y;
            d = [], y[e] = Yn;
        }
        jn(d, cn({
          rel: "modulepreload",
          href: e
        }, l)), u.bulkPreloads.add(d), cl(r);
      }
    } else rn.m(e, l);
  }
  function Na(e, l, r) {
    var c = ge || null;
    if (c) {
      var u = c.resumableState, d = c.renderState;
      if (e) {
        l = l || "default";
        var y = d.styles.get(l), I = u.styleResources.hasOwnProperty(e) ? u.styleResources[e] : void 0;
        I !== null && (u.styleResources[e] = null, y || (y = {
          precedence: V(l),
          rules: [],
          hrefs: [],
          sheets: /* @__PURE__ */ new Map()
        }, d.styles.set(l, y)), l = {
          state: 0,
          props: cn({
            rel: "stylesheet",
            href: e,
            "data-precedence": l
          }, r)
        }, I && (I.length === 2 && jl(l.props, I), (d = d.preloads.stylesheets.get(e)) && 0 < d.length ? d.length = 0 : l.state = 1), y.sheets.set(e, l), cl(c));
      }
    } else rn.S(e, l, r);
  }
  function Da(e, l) {
    var r = ge || null;
    if (r) {
      var c = r.resumableState, u = r.renderState;
      if (e) {
        var d = c.scriptResources.hasOwnProperty(e) ? c.scriptResources[e] : void 0;
        d !== null && (c.scriptResources[e] = null, l = cn({
          src: e,
          async: !0
        }, l), d && (d.length === 2 && jl(l, d), e = u.preloads.scripts.get(e)) && (e.length = 0), e = [], u.scripts.add(e), _t(e, l), cl(r));
      }
    } else rn.X(e, l);
  }
  function Rc(e, l) {
    var r = ge || null;
    if (r) {
      var c = r.resumableState, u = r.renderState;
      if (e) {
        var d = c.moduleScriptResources.hasOwnProperty(e) ? c.moduleScriptResources[e] : void 0;
        d !== null && (c.moduleScriptResources[e] = null, l = cn({
          src: e,
          type: "module",
          async: !0
        }, l), d && (d.length === 2 && jl(l, d), e = u.preloads.moduleScripts.get(e)) && (e.length = 0), e = [], u.scripts.add(e), _t(e, l), cl(r));
      }
    } else rn.M(e, l);
  }
  function jl(e, l) {
    e.crossOrigin ?? (e.crossOrigin = l[0]), e.integrity ?? (e.integrity = l[1]);
  }
  function ce(e, l, r) {
    e = ("" + e).replace(Ni, Di), l = ("" + l).replace(Pt, mi), l = "<" + e + '>; rel=preload; as="' + l + '"';
    for (var c in r) nn.call(r, c) && (e = r[c], typeof e == "string" && (l += "; " + c.toLowerCase() + '="' + ("" + e).replace(Pt, mi) + '"'));
    return l;
  }
  var Ni = /[<>\r\n]/g;
  function Di(e) {
    switch (e) {
      case "<":
        return "%3C";
      case ">":
        return "%3E";
      case `
`:
        return "%0A";
      case "\r":
        return "%0D";
      default:
        throw Error("escapeLinkHrefForHeaderContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
    }
  }
  var Pt = /["';,\r\n]/g;
  function mi(e) {
    switch (e) {
      case '"':
        return "%22";
      case "'":
        return "%27";
      case ";":
        return "%3B";
      case ",":
        return "%2C";
      case `
`:
        return "%0A";
      case "\r":
        return "%0D";
      default:
        throw Error("escapeStringForLinkHeaderQuotedParamValueContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
    }
  }
  function Sc(e) {
    this.styles.add(e);
  }
  function Mc(e) {
    this.stylesheets.add(e);
  }
  function wl(e, l) {
    l.styles.forEach(Sc, e), l.stylesheets.forEach(Mc, e), l.suspenseyImages && (e.suspenseyImages = !0);
  }
  function Bi(e, l) {
    var r = e.idPrefix, c = [], u = e.bootstrapScriptContent, d = e.bootstrapScripts, y = e.bootstrapModules;
    u !== void 0 && (c.push("<script"), pl(c, e), c.push(">", ("" + u).replace(tt, he), "<\/script>")), u = r + "P:";
    var I = r + "S:";
    r += "B:";
    var T = /* @__PURE__ */ new Set(), A = /* @__PURE__ */ new Set(), m = /* @__PURE__ */ new Set(), L = /* @__PURE__ */ new Map(), Z = /* @__PURE__ */ new Set(), en = /* @__PURE__ */ new Set(), xn = /* @__PURE__ */ new Set(), fn = {
      images: /* @__PURE__ */ new Map(),
      stylesheets: /* @__PURE__ */ new Map(),
      scripts: /* @__PURE__ */ new Map(),
      moduleScripts: /* @__PURE__ */ new Map()
    };
    if (d !== void 0) for (var sn = 0; sn < d.length; sn++) {
      var un = d[sn], dn, Wn = void 0, Vn = void 0, Rn = {
        rel: "preload",
        as: "script",
        fetchPriority: "low",
        nonce: void 0
      };
      typeof un == "string" ? Rn.href = dn = un : (Rn.href = dn = un.src, Rn.integrity = Vn = typeof un.integrity == "string" ? un.integrity : void 0, Rn.crossOrigin = Wn = typeof un == "string" || un.crossOrigin == null ? void 0 : un.crossOrigin === "use-credentials" ? "use-credentials" : ""), un = e;
      var Fn = dn;
      un.scriptResources[Fn] = null, un.moduleScriptResources[Fn] = null, un = [], jn(un, Rn), Z.add(un), c.push('<script src="', V(dn), '"'), typeof Vn == "string" && c.push(' integrity="', V(Vn), '"'), typeof Wn == "string" && c.push(' crossorigin="', V(Wn), '"'), pl(c, e), c.push(' async=""><\/script>');
    }
    if (y !== void 0) for (d = 0; d < y.length; d++) Rn = y[d], Wn = dn = void 0, Vn = {
      rel: "modulepreload",
      fetchPriority: "low",
      nonce: void 0
    }, typeof Rn == "string" ? Vn.href = sn = Rn : (Vn.href = sn = Rn.src, Vn.integrity = Wn = typeof Rn.integrity == "string" ? Rn.integrity : void 0, Vn.crossOrigin = dn = typeof Rn == "string" || Rn.crossOrigin == null ? void 0 : Rn.crossOrigin === "use-credentials" ? "use-credentials" : ""), Rn = e, un = sn, Rn.scriptResources[un] = null, Rn.moduleScriptResources[un] = null, Rn = [], jn(Rn, Vn), Z.add(Rn), c.push('<script type="module" src="', V(sn), '"'), typeof Wn == "string" && c.push(' integrity="', V(Wn), '"'), typeof dn == "string" && c.push(' crossorigin="', V(dn), '"'), pl(c, e), c.push(' async=""><\/script>');
    return {
      placeholderPrefix: u,
      segmentPrefix: I,
      boundaryPrefix: r,
      startInlineScript: "<script",
      startInlineStyle: "<style",
      preamble: {
        htmlChunks: null,
        headChunks: null,
        bodyChunks: null
      },
      externalRuntimeScript: null,
      bootstrapChunks: c,
      importMapChunks: [],
      onHeaders: void 0,
      headers: null,
      resets: {
        font: {},
        dns: {},
        connect: {
          default: {},
          anonymous: {},
          credentials: {}
        },
        image: {},
        style: {}
      },
      charsetChunks: [],
      viewportChunks: [],
      hoistableChunks: [],
      preconnects: T,
      fontPreloads: A,
      highImagePreloads: m,
      styles: L,
      bootstrapScripts: Z,
      scripts: en,
      bulkPreloads: xn,
      preloads: fn,
      nonce: {
        script: void 0,
        style: void 0
      },
      stylesToHoist: !1,
      generateStaticMarkup: l
    };
  }
  function zi(e, l, r, c) {
    return r.generateStaticMarkup ? (e.push(V(l)), !1) : (l === "" ? e = c : (c && e.push("<!-- -->"), e.push(V(l)), e = !0), e);
  }
  function kt(e, l, r, c) {
    l.generateStaticMarkup || r && c && e.push("<!-- -->");
  }
  var Sr = Function.prototype.bind, Fc = /* @__PURE__ */ Symbol.for("react.client.reference");
  function $l(e) {
    if (e == null) return null;
    if (typeof e == "function") return e.$$typeof === Fc ? null : e.displayName || e.name || null;
    if (typeof e == "string") return e;
    switch (e) {
      case S:
        return "Fragment";
      case O:
        return "Profiler";
      case M:
        return "StrictMode";
      case z:
        return "Suspense";
      case U:
        return "SuspenseList";
      case H:
        return "Activity";
    }
    if (typeof e == "object") switch (e.$$typeof) {
      case C:
        return "Portal";
      case N:
        return e.displayName || "Context";
      case D:
        return (e._context.displayName || "Context") + ".Consumer";
      case W:
        var l = e.render;
        return e = e.displayName, e || (e = l.displayName || l.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
      case B:
        return l = e.displayName || null, l !== null ? l : $l(e.type) || "Memo";
      case Y:
        l = e._payload, e = e._init;
        try {
          return $l(e(l));
        } catch {
        }
    }
    return null;
  }
  var ie = {}, jt = null;
  function Hi(e, l) {
    if (e !== l) {
      e.context._currentValue2 = e.parentValue, e = e.parent;
      var r = l.parent;
      if (e === null) {
        if (r !== null) throw Error(s(401));
      } else {
        if (r === null) throw Error(s(401));
        Hi(e, r);
      }
      l.context._currentValue2 = l.value;
    }
  }
  function Mr(e) {
    e.context._currentValue2 = e.parentValue, e = e.parent, e !== null && Mr(e);
  }
  function Ot(e) {
    var l = e.parent;
    l !== null && Ot(l), e.context._currentValue2 = e.value;
  }
  function Fr(e, l) {
    if (e.context._currentValue2 = e.parentValue, e = e.parent, e === null) throw Error(s(402));
    e.depth === l.depth ? Hi(e, l) : Fr(e, l);
  }
  function Ir(e, l) {
    var r = l.parent;
    if (r === null) throw Error(s(402));
    e.depth === r.depth ? Hi(e, r) : Ir(e, r), l.context._currentValue2 = l.value;
  }
  function Lt(e) {
    var l = jt;
    l !== e && (l === null ? Ot(e) : e === null ? Mr(l) : l.depth === e.depth ? Hi(l, e) : l.depth > e.depth ? Fr(l, e) : Ir(l, e), jt = e);
  }
  var ma = {
    enqueueSetState: function(e, l) {
      e = e._reactInternals, e.queue !== null && e.queue.push(l);
    },
    enqueueReplaceState: function(e, l) {
      e = e._reactInternals, e.replace = !0, e.queue = [l];
    },
    enqueueForceUpdate: function() {
    }
  }, Ic = {
    id: 1,
    overflow: ""
  };
  function $t(e, l, r) {
    var c = e.id;
    e = e.overflow;
    var u = 32 - Wi(c) - 1;
    c &= ~(1 << u), r += 1;
    var d = 32 - Wi(l) + u;
    if (30 < d) {
      var y = u - u % 5;
      return d = (c & (1 << y) - 1).toString(32), c >>= y, u -= y, {
        id: 1 << 32 - Wi(l) + u | r << u | c,
        overflow: d + e
      };
    }
    return {
      id: 1 << d | r << u | c,
      overflow: e
    };
  }
  var Wi = Math.clz32 ? Math.clz32 : Pc, Ac = Math.log, _c = Math.LN2;
  function Pc(e) {
    return e >>>= 0, e === 0 ? 32 : 31 - (Ac(e) / _c | 0) | 0;
  }
  function Ie() {
  }
  var He = Error(s(460));
  function kc(e, l, r) {
    switch (r = e[r], r === void 0 ? e.push(l) : r !== l && (l.then(Ie, Ie), l = r), l.status) {
      case "fulfilled":
        return l.value;
      case "rejected":
        throw l.reason;
      default:
        switch (typeof l.status == "string" ? l.then(Ie, Ie) : (e = l, e.status = "pending", e.then(function(c) {
          if (l.status === "pending") {
            var u = l;
            u.status = "fulfilled", u.value = c;
          }
        }, function(c) {
          if (l.status === "pending") {
            var u = l;
            u.status = "rejected", u.reason = c;
          }
        })), l.status) {
          case "fulfilled":
            return l.value;
          case "rejected":
            throw l.reason;
        }
        throw Ui = l, He;
    }
  }
  var Ui = null;
  function Gi() {
    if (Ui === null) throw Error(s(459));
    var e = Ui;
    return Ui = null, e;
  }
  function Oc(e, l) {
    return e === l && (e !== 0 || 1 / e === 1 / l) || e !== e && l !== l;
  }
  var Ba = typeof Object.is == "function" ? Object.is : Oc, st = null, Ar = null, _r = null, Pr = null, Yi = null, mn = null, ni = !1, Xi = !1, ei = 0, ti = 0, li = -1, Zi = 0, Cl = null, Nt = null, Ji = 0;
  function ht() {
    if (st === null) throw Error(s(321));
    return st;
  }
  function za() {
    if (0 < Ji) throw Error(s(312));
    return {
      memoizedState: null,
      queue: null,
      next: null
    };
  }
  function kr() {
    return mn === null ? Yi === null ? (ni = !1, Yi = mn = za()) : (ni = !0, mn = Yi) : mn.next === null ? (ni = !1, mn = mn.next = za()) : (ni = !0, mn = mn.next), mn;
  }
  function Rl() {
    var e = Cl;
    return Cl = null, e;
  }
  function ii() {
    Pr = _r = Ar = st = null, Xi = !1, Yi = null, Ji = 0, mn = Nt = null;
  }
  function Ha(e, l) {
    return typeof l == "function" ? l(e) : l;
  }
  function Wa(e, l, r) {
    if (st = ht(), mn = kr(), ni) {
      var c = mn.queue;
      if (l = c.dispatch, Nt !== null && (r = Nt.get(c), r !== void 0)) {
        Nt.delete(c), c = mn.memoizedState;
        do
          c = e(c, r.action), r = r.next;
        while (r !== null);
        return mn.memoizedState = c, [c, l];
      }
      return [mn.memoizedState, l];
    }
    return e = e === Ha ? typeof l == "function" ? l() : l : r !== void 0 ? r(l) : l, mn.memoizedState = e, e = mn.queue = {
      last: null,
      dispatch: null
    }, e = e.dispatch = Lc.bind(null, st, e), [mn.memoizedState, e];
  }
  function Ua(e, l) {
    if (st = ht(), mn = kr(), l = l === void 0 ? null : l, mn !== null) {
      var r = mn.memoizedState;
      if (r !== null && l !== null) {
        var c = r[1];
        n: if (c === null) c = !1;
        else {
          for (var u = 0; u < c.length && u < l.length; u++) if (!Ba(l[u], c[u])) {
            c = !1;
            break n;
          }
          c = !0;
        }
        if (c) return r[0];
      }
    }
    return e = e(), mn.memoizedState = [e, l], e;
  }
  function Lc(e, l, r) {
    if (25 <= Ji) throw Error(s(301));
    if (e === st) if (Xi = !0, e = {
      action: r,
      next: null
    }, Nt === null && (Nt = /* @__PURE__ */ new Map()), r = Nt.get(l), r === void 0) Nt.set(l, e);
    else {
      for (l = r; l.next !== null; ) l = l.next;
      l.next = e;
    }
  }
  function Nc() {
    throw Error(s(440));
  }
  function Dc() {
    throw Error(s(394));
  }
  function mc() {
    throw Error(s(479));
  }
  function Or(e, l, r) {
    ht();
    var c = ti++, u = _r;
    if (typeof e.$$FORM_ACTION == "function") {
      var d = null, y = Pr;
      u = u.formState;
      var I = e.$$IS_SIGNATURE_EQUAL;
      if (u !== null && typeof I == "function") {
        var T = u[1];
        I.call(e, u[2], u[3]) && (d = r !== void 0 ? "p" + r : "k" + on(JSON.stringify([
          y,
          null,
          c
        ]), 0), T === d && (li = c, l = u[0]));
      }
      var A = e.bind(null, l);
      return e = function(L) {
        A(L);
      }, typeof A.$$FORM_ACTION == "function" && (e.$$FORM_ACTION = function(L) {
        L = A.$$FORM_ACTION(L), r !== void 0 && (r += "", L.action = r);
        var Z = L.data;
        return Z && (d === null && (d = r !== void 0 ? "p" + r : "k" + on(JSON.stringify([
          y,
          null,
          c
        ]), 0)), Z.append("$ACTION_KEY", d)), L;
      }), [
        l,
        e,
        !1
      ];
    }
    var m = e.bind(null, l);
    return [
      l,
      function(L) {
        m(L);
      },
      !1
    ];
  }
  function Ga(e) {
    var l = Zi;
    return Zi += 1, Cl === null && (Cl = []), kc(Cl, e, l);
  }
  function Bc() {
    throw Error(s(393));
  }
  var Ya = {
    readContext: function(e) {
      return e._currentValue2;
    },
    use: function(e) {
      if (e !== null && typeof e == "object") {
        if (typeof e.then == "function") return Ga(e);
        if (e.$$typeof === N) return e._currentValue2;
      }
      throw Error(s(438, String(e)));
    },
    useContext: function(e) {
      return ht(), e._currentValue2;
    },
    useMemo: Ua,
    useReducer: Wa,
    useRef: function(e) {
      st = ht(), mn = kr();
      var l = mn.memoizedState;
      return l === null ? (e = { current: e }, mn.memoizedState = e) : l;
    },
    useState: function(e) {
      return Wa(Ha, e);
    },
    useInsertionEffect: Ie,
    useLayoutEffect: Ie,
    useCallback: function(e, l) {
      return Ua(function() {
        return e;
      }, l);
    },
    useImperativeHandle: Ie,
    useEffect: Ie,
    useDebugValue: Ie,
    useDeferredValue: function(e, l) {
      return ht(), l !== void 0 ? l : e;
    },
    useTransition: function() {
      return ht(), [!1, Dc];
    },
    useId: function() {
      var e = Ar.treeContext, l = e.overflow;
      e = e.id, e = (e & ~(1 << 32 - Wi(e) - 1)).toString(32) + l;
      var r = Qi;
      if (r === null) throw Error(s(404));
      return l = ei++, e = "_" + r.idPrefix + "R_" + e, 0 < l && (e += "H" + l.toString(32)), e + "_";
    },
    useSyncExternalStore: function(e, l, r) {
      if (r === void 0) throw Error(s(407));
      return r();
    },
    useOptimistic: function(e) {
      return ht(), [e, mc];
    },
    useActionState: Or,
    useFormState: Or,
    useHostTransitionStatus: function() {
      return ht(), te;
    },
    useMemoCache: function(e) {
      for (var l = Array(e), r = 0; r < e; r++) l[r] = bn;
      return l;
    },
    useCacheRefresh: function() {
      return Bc;
    },
    useEffectEvent: function() {
      return Nc;
    }
  }, Qi = null, zc = {
    getCacheForType: function() {
      throw Error(s(248));
    },
    cacheSignal: function() {
      throw Error(s(248));
    }
  }, Lr, Xa;
  function Sl(e) {
    if (Lr === void 0) try {
      throw Error();
    } catch (r) {
      var l = r.stack.trim().match(/\n( *(at )?)/);
      Lr = l && l[1] || "", Xa = -1 < r.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < r.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return `
` + Lr + e + Xa;
  }
  var Nr = !1;
  function Vi(e, l) {
    if (!e || Nr) return "";
    Nr = !0;
    var r = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var c = { DetermineComponentFrameRoot: function() {
        try {
          if (l) {
            var L = function() {
              throw Error();
            };
            if (Object.defineProperty(L.prototype, "props", { set: function() {
              throw Error();
            } }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(L, []);
              } catch (en) {
                var Z = en;
              }
              Reflect.construct(e, [], L);
            } else {
              try {
                L.call();
              } catch (en) {
                Z = en;
              }
              e.call(L.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (en) {
              Z = en;
            }
            (L = e()) && typeof L.catch == "function" && L.catch(function() {
            });
          }
        } catch (en) {
          if (en && Z && typeof en.stack == "string") return [en.stack, Z.stack];
        }
        return [null, null];
      } };
      c.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var u = Object.getOwnPropertyDescriptor(c.DetermineComponentFrameRoot, "name");
      u && u.configurable && Object.defineProperty(c.DetermineComponentFrameRoot, "name", { value: "DetermineComponentFrameRoot" });
      var d = c.DetermineComponentFrameRoot(), y = d[0], I = d[1];
      if (y && I) {
        var T = y.split(`
`), A = I.split(`
`);
        for (u = c = 0; c < T.length && !T[c].includes("DetermineComponentFrameRoot"); ) c++;
        for (; u < A.length && !A[u].includes("DetermineComponentFrameRoot"); ) u++;
        if (c === T.length || u === A.length) for (c = T.length - 1, u = A.length - 1; 1 <= c && 0 <= u && T[c] !== A[u]; ) u--;
        for (; 1 <= c && 0 <= u; c--, u--) if (T[c] !== A[u]) {
          if (c !== 1 || u !== 1) do
            if (c--, u--, 0 > u || T[c] !== A[u]) {
              var m = `
` + T[c].replace(" at new ", " at ");
              return e.displayName && m.includes("<anonymous>") && (m = m.replace("<anonymous>", e.displayName)), m;
            }
          while (1 <= c && 0 <= u);
          break;
        }
      }
    } finally {
      Nr = !1, Error.prepareStackTrace = r;
    }
    return (r = e ? e.displayName || e.name : "") ? Sl(r) : "";
  }
  function Za(e) {
    if (typeof e == "string") return Sl(e);
    if (typeof e == "function") return e.prototype && e.prototype.isReactComponent ? Vi(e, !0) : Vi(e, !1);
    if (typeof e == "object" && e !== null) {
      switch (e.$$typeof) {
        case W:
          return Vi(e.render, !1);
        case B:
          return Vi(e.type, !1);
        case Y:
          var l = e, r = l._payload;
          l = l._init;
          try {
            e = l(r);
          } catch {
            return Sl("Lazy");
          }
          return Za(e);
      }
      if (typeof e.name == "string") {
        n: {
          r = e.name, l = e.env;
          var c = e.debugLocation;
          if (c != null && (e = Error.prepareStackTrace, Error.prepareStackTrace = void 0, c = c.stack, Error.prepareStackTrace = e, c.startsWith(`Error: react-stack-top-frame
`) && (c = c.slice(29)), e = c.indexOf(`
`), e !== -1 && (c = c.slice(e + 1)), e = c.indexOf("react_stack_bottom_frame"), e !== -1 && (e = c.lastIndexOf(`
`, e)), e = e !== -1 ? c = c.slice(0, e) : "", c = e.lastIndexOf(`
`), e = c === -1 ? e : e.slice(c + 1), e.indexOf(r) !== -1)) {
            r = `
` + e;
            break n;
          }
          r = Sl(r + (l ? " [" + l + "]" : ""));
        }
        return r;
      }
    }
    switch (e) {
      case U:
        return Sl("SuspenseList");
      case z:
        return Sl("Suspense");
    }
    return "";
  }
  function Ml(e, l) {
    return (500 < l.byteSize || !1) && l.contentPreamble === null;
  }
  function Hc(e) {
    if (typeof e == "object" && e !== null && typeof e.environmentName == "string") {
      var l = e.environmentName;
      e = [e].slice(0), typeof e[0] == "string" ? e.splice(0, 1, "[%s] " + e[0], " " + l + " ") : e.splice(0, 0, "[%s]", " " + l + " "), e.unshift(console), l = Sr.apply(console.error, e), l();
    } else console.error(e);
    return null;
  }
  function Wc(e, l, r, c, u, d, y, I, T, A, m) {
    var L = /* @__PURE__ */ new Set();
    this.destination = null, this.flushScheduled = !1, this.resumableState = e, this.renderState = l, this.rootFormatContext = r, this.progressiveChunkSize = c === void 0 ? 12800 : c, this.status = 10, this.fatalError = null, this.pendingRootTasks = this.allPendingTasks = this.nextSegmentId = 0, this.completedPreambleSegments = this.completedRootSegment = null, this.byteSize = 0, this.abortableTasks = L, this.pingedTasks = [], this.clientRenderedBoundaries = [], this.completedBoundaries = [], this.partialBoundaries = [], this.trackedPostpones = null, this.onError = u === void 0 ? Hc : u, this.onPostpone = A === void 0 ? Ie : A, this.onAllReady = d === void 0 ? Ie : d, this.onShellReady = y === void 0 ? Ie : y, this.onShellError = I === void 0 ? Ie : I, this.onFatalError = T === void 0 ? Ie : T, this.formState = m === void 0 ? null : m;
  }
  function Uc(e, l, r, c, u, d, y, I, T, A, m, L) {
    return l = new Wc(l, r, c, u, d, y, I, T, A, m, L), r = nl(l, 0, null, c, !1, !1), r.parentFlushed = !0, e = Ki(l, null, e, -1, null, r, null, null, l.abortableTasks, null, c, null, Ic, null, null), Dt(e), l.pingedTasks.push(e), l;
  }
  var ge = null;
  function Fl(e, l) {
    e.pingedTasks.push(l), e.pingedTasks.length === 1 && (e.flushScheduled = e.destination !== null, Ka(e));
  }
  function Dr(e, l, r, c, u) {
    return r = {
      status: 0,
      rootSegmentID: -1,
      parentFlushed: !1,
      pendingTasks: 0,
      row: l,
      completedSegments: [],
      byteSize: 0,
      fallbackAbortableTasks: r,
      errorDigest: null,
      contentState: zn(),
      fallbackState: zn(),
      contentPreamble: c,
      fallbackPreamble: u,
      trackedContentKeyPath: null,
      trackedFallbackNode: null
    }, l !== null && (l.pendingTasks++, c = l.boundaries, c !== null && (e.allPendingTasks++, r.pendingTasks++, c.push(r)), e = l.inheritedHoistables, e !== null && wl(r.contentState, e)), r;
  }
  function Ki(e, l, r, c, u, d, y, I, T, A, m, L, Z, en, xn) {
    e.allPendingTasks++, u === null ? e.pendingRootTasks++ : u.pendingTasks++, en !== null && en.pendingTasks++;
    var fn = {
      replay: null,
      node: r,
      childIndex: c,
      ping: function() {
        return Fl(e, fn);
      },
      blockedBoundary: u,
      blockedSegment: d,
      blockedPreamble: y,
      hoistableState: I,
      abortSet: T,
      keyPath: A,
      formatContext: m,
      context: L,
      treeContext: Z,
      row: en,
      componentStack: xn,
      thenableState: l
    };
    return T.add(fn), fn;
  }
  function Ja(e, l, r, c, u, d, y, I, T, A, m, L, Z, en) {
    e.allPendingTasks++, d === null ? e.pendingRootTasks++ : d.pendingTasks++, Z !== null && Z.pendingTasks++, r.pendingTasks++;
    var xn = {
      replay: r,
      node: c,
      childIndex: u,
      ping: function() {
        return Fl(e, xn);
      },
      blockedBoundary: d,
      blockedSegment: null,
      blockedPreamble: null,
      hoistableState: y,
      abortSet: I,
      keyPath: T,
      formatContext: A,
      context: m,
      treeContext: L,
      row: Z,
      componentStack: en,
      thenableState: l
    };
    return I.add(xn), xn;
  }
  function nl(e, l, r, c, u, d) {
    return {
      status: 0,
      parentFlushed: !1,
      id: -1,
      index: l,
      chunks: [],
      children: [],
      preambleChildren: [],
      parentFormatContext: c,
      boundary: r,
      lastPushedText: u,
      textEmbedded: d
    };
  }
  function Dt(e) {
    var l = e.node;
    typeof l == "object" && l !== null && l.$$typeof === x && (e.componentStack = {
      parent: e.componentStack,
      type: l.type
    });
  }
  function ri(e) {
    return e === null ? null : {
      parent: e.parent,
      type: "Suspense Fallback"
    };
  }
  function mt(e) {
    var l = {};
    return e && Object.defineProperty(l, "componentStack", {
      configurable: !0,
      enumerable: !0,
      get: function() {
        try {
          var r = "", c = e;
          do
            r += Za(c.type), c = c.parent;
          while (c);
          var u = r;
        } catch (d) {
          u = `
Error generating stack: ` + d.message + `
` + d.stack;
        }
        return Object.defineProperty(l, "componentStack", { value: u }), u;
      }
    }), l;
  }
  function we(e, l, r) {
    if (e = e.onError, l = e(l, r), l == null || typeof l == "string") return l;
  }
  function Il(e, l) {
    var r = e.onShellError, c = e.onFatalError;
    r(l), c(l), e.destination !== null ? (e.status = 14, e.destination.destroy(l)) : (e.status = 13, e.fatalError = l);
  }
  function Bn(e, l) {
    at(e, l.next, l.hoistables);
  }
  function at(e, l, r) {
    for (; l !== null; ) {
      r !== null && (wl(l.hoistables, r), l.inheritedHoistables = r);
      var c = l.boundaries;
      if (c !== null) {
        l.boundaries = null;
        for (var u = 0; u < c.length; u++) {
          var d = c[u];
          r !== null && wl(d.contentState, r), Bt(e, d, null, null);
        }
      }
      if (l.pendingTasks--, 0 < l.pendingTasks) break;
      r = l.hoistables, l = l.next;
    }
  }
  function mr(e, l) {
    var r = l.boundaries;
    if (r !== null && l.pendingTasks === r.length) {
      for (var c = !0, u = 0; u < r.length; u++) {
        var d = r[u];
        if (d.pendingTasks !== 1 || d.parentFlushed || Ml(e, d)) {
          c = !1;
          break;
        }
      }
      c && at(e, l, l.hoistables);
    }
  }
  function ai(e) {
    var l = {
      pendingTasks: 1,
      boundaries: null,
      hoistables: zn(),
      inheritedHoistables: null,
      together: !1,
      next: null
    };
    return e !== null && 0 < e.pendingTasks && (l.pendingTasks++, l.boundaries = [], e.next = l), l;
  }
  function Qa(e, l, r, c, u) {
    var d = l.keyPath, y = l.treeContext, I = l.row;
    l.keyPath = r, r = c.length;
    var T = null;
    if (l.replay !== null) {
      var A = l.replay.slots;
      if (A !== null && typeof A == "object") for (var m = 0; m < r; m++) {
        var L = u !== "backwards" && u !== "unstable_legacy-backwards" ? m : r - 1 - m, Z = c[L];
        l.row = T = ai(T), l.treeContext = $t(y, r, L);
        var en = A[L];
        typeof en == "number" ? (qi(e, l, en, Z, L), delete A[L]) : fe(e, l, Z, L), --T.pendingTasks === 0 && Bn(e, T);
      }
      else for (A = 0; A < r; A++) m = u !== "backwards" && u !== "unstable_legacy-backwards" ? A : r - 1 - A, L = c[m], l.row = T = ai(T), l.treeContext = $t(y, r, m), fe(e, l, L, m), --T.pendingTasks === 0 && Bn(e, T);
    } else if (u !== "backwards" && u !== "unstable_legacy-backwards") for (u = 0; u < r; u++) A = c[u], l.row = T = ai(T), l.treeContext = $t(y, r, u), fe(e, l, A, u), --T.pendingTasks === 0 && Bn(e, T);
    else {
      for (u = l.blockedSegment, A = u.children.length, m = u.chunks.length, L = r - 1; 0 <= L; L--) {
        Z = c[L], l.row = T = ai(T), l.treeContext = $t(y, r, L), en = nl(e, m, null, l.formatContext, L === 0 ? u.lastPushedText : !0, !0), u.children.splice(A, 0, en), l.blockedSegment = en;
        try {
          fe(e, l, Z, L), kt(en.chunks, e.renderState, en.lastPushedText, en.textEmbedded), en.status = 1, --T.pendingTasks === 0 && Bn(e, T);
        } catch (xn) {
          throw en.status = e.status === 12 ? 3 : 4, xn;
        }
      }
      l.blockedSegment = u, u.lastPushedText = !1;
    }
    I !== null && T !== null && 0 < T.pendingTasks && (I.pendingTasks++, T.next = I), l.treeContext = y, l.row = I, l.keyPath = d;
  }
  function Br(e, l, r, c, u, d) {
    var y = l.thenableState;
    for (l.thenableState = null, st = {}, Ar = l, _r = e, Pr = r, ti = ei = 0, li = -1, Zi = 0, Cl = y, e = c(u, d); Xi; ) Xi = !1, ti = ei = 0, li = -1, Zi = 0, Ji += 1, mn = null, e = c(u, d);
    return ii(), e;
  }
  function Va(e, l, r, c, u, d, y) {
    var I = !1;
    if (d !== 0 && e.formState !== null) {
      var T = l.blockedSegment;
      if (T !== null) {
        I = !0, T = T.chunks;
        for (var A = 0; A < d; A++) A === y ? T.push("<!--F!-->") : T.push("<!--F-->");
      }
    }
    d = l.keyPath, l.keyPath = r, u ? (r = l.treeContext, l.treeContext = $t(r, 1, 0), fe(e, l, c, -1), l.treeContext = r) : I ? fe(e, l, c, -1) : Ze(e, l, c, -1), l.keyPath = d;
  }
  function pi(e, l, r, c, u, d) {
    if (typeof c == "function") if (c.prototype && c.prototype.isReactComponent) {
      var y = u;
      if ("ref" in u) {
        y = {};
        for (var I in u) I !== "ref" && (y[I] = u[I]);
      }
      var T = c.defaultProps;
      if (T) {
        y === u && (y = cn({}, y, u));
        for (var A in T) y[A] === void 0 && (y[A] = T[A]);
      }
      u = y, y = ie, T = c.contextType, typeof T == "object" && T !== null && (y = T._currentValue2), y = new c(u, y);
      var m = y.state !== void 0 ? y.state : null;
      if (y.updater = ma, y.props = u, y.state = m, T = {
        queue: [],
        replace: !1
      }, y._reactInternals = T, d = c.contextType, y.context = typeof d == "object" && d !== null ? d._currentValue2 : ie, d = c.getDerivedStateFromProps, typeof d == "function" && (d = d(u, m), m = d == null ? m : cn({}, m, d), y.state = m), typeof c.getDerivedStateFromProps != "function" && typeof y.getSnapshotBeforeUpdate != "function" && (typeof y.UNSAFE_componentWillMount == "function" || typeof y.componentWillMount == "function")) if (c = y.state, typeof y.componentWillMount == "function" && y.componentWillMount(), typeof y.UNSAFE_componentWillMount == "function" && y.UNSAFE_componentWillMount(), c !== y.state && ma.enqueueReplaceState(y, y.state, null), T.queue !== null && 0 < T.queue.length) if (c = T.queue, d = T.replace, T.queue = null, T.replace = !1, d && c.length === 1) y.state = c[0];
      else {
        for (T = d ? c[0] : y.state, m = !0, d = d ? 1 : 0; d < c.length; d++) A = c[d], A = typeof A == "function" ? A.call(y, T, u, void 0) : A, A != null && (m ? (m = !1, T = cn({}, T, A)) : cn(T, A));
        y.state = T;
      }
      else T.queue = null;
      if (c = y.render(), e.status === 12) throw null;
      u = l.keyPath, l.keyPath = r, Ze(e, l, c, -1), l.keyPath = u;
    } else {
      if (c = Br(e, l, r, c, u, void 0), e.status === 12) throw null;
      Va(e, l, r, c, ei !== 0, ti, li);
    }
    else if (typeof c == "string") if (y = l.blockedSegment, y === null) y = u.children, T = l.formatContext, m = l.keyPath, l.formatContext = Mn(T, c, u), l.keyPath = r, fe(e, l, y, -1), l.formatContext = T, l.keyPath = m;
    else {
      if (m = le(y.chunks, c, u, e.resumableState, e.renderState, l.blockedPreamble, l.hoistableState, l.formatContext, y.lastPushedText), y.lastPushedText = !1, T = l.formatContext, d = l.keyPath, l.keyPath = r, (l.formatContext = Mn(T, c, u)).insertionMode === 3) {
        r = nl(e, 0, null, l.formatContext, !1, !1), y.preambleChildren.push(r), l.blockedSegment = r;
        try {
          r.status = 6, fe(e, l, m, -1), kt(r.chunks, e.renderState, r.lastPushedText, r.textEmbedded), r.status = 1;
        } finally {
          l.blockedSegment = y;
        }
      } else fe(e, l, m, -1);
      l.formatContext = T, l.keyPath = d;
      n: {
        switch (l = y.chunks, e = e.resumableState, c) {
          case "title":
          case "style":
          case "script":
          case "area":
          case "base":
          case "br":
          case "col":
          case "embed":
          case "hr":
          case "img":
          case "input":
          case "keygen":
          case "link":
          case "meta":
          case "param":
          case "source":
          case "track":
          case "wbr":
            break n;
          case "body":
            if (1 >= T.insertionMode) {
              e.hasBody = !0;
              break n;
            }
            break;
          case "html":
            if (T.insertionMode === 0) {
              e.hasHtml = !0;
              break n;
            }
            break;
          case "head":
            if (1 >= T.insertionMode) break n;
        }
        l.push(rt(c));
      }
      y.lastPushedText = !1;
    }
    else {
      switch (c) {
        case $:
        case M:
        case O:
        case S:
          c = l.keyPath, l.keyPath = r, Ze(e, l, u.children, -1), l.keyPath = c;
          return;
        case H:
          c = l.blockedSegment, c === null ? u.mode !== "hidden" && (c = l.keyPath, l.keyPath = r, fe(e, l, u.children, -1), l.keyPath = c) : u.mode !== "hidden" && (e.renderState.generateStaticMarkup || c.chunks.push("<!--&-->"), c.lastPushedText = !1, y = l.keyPath, l.keyPath = r, fe(e, l, u.children, -1), l.keyPath = y, e.renderState.generateStaticMarkup || c.chunks.push("<!--/&-->"), c.lastPushedText = !1);
          return;
        case U:
          n: {
            if (c = u.children, u = u.revealOrder, u === "forwards" || u === "backwards" || u === "unstable_legacy-backwards") {
              if (ln(c)) {
                Qa(e, l, r, c, u);
                break n;
              }
              if ((y = p(c)) && (y = y.call(c))) {
                if (T = y.next(), !T.done) {
                  do
                    T = y.next();
                  while (!T.done);
                  Qa(e, l, r, c, u);
                }
                break n;
              }
            }
            u === "together" ? (u = l.keyPath, y = l.row, T = l.row = ai(null), T.boundaries = [], T.together = !0, l.keyPath = r, Ze(e, l, c, -1), --T.pendingTasks === 0 && Bn(e, T), l.keyPath = u, l.row = y, y !== null && 0 < T.pendingTasks && (y.pendingTasks++, T.next = y)) : (u = l.keyPath, l.keyPath = r, Ze(e, l, c, -1), l.keyPath = u);
          }
          return;
        case En:
        case J:
          throw Error(s(343));
        case z:
          n: if (l.replay !== null) {
            c = l.keyPath, y = l.formatContext, T = l.row, l.keyPath = r, l.formatContext = De(e.resumableState, y), l.row = null, r = u.children;
            try {
              fe(e, l, r, -1);
            } finally {
              l.keyPath = c, l.formatContext = y, l.row = T;
            }
          } else {
            c = l.keyPath, d = l.formatContext;
            var L = l.row, Z = l.blockedBoundary;
            A = l.blockedPreamble;
            var en = l.hoistableState;
            I = l.blockedSegment;
            var xn = u.fallback;
            u = u.children;
            var fn = /* @__PURE__ */ new Set(), sn = Dr(e, l.row, fn, null, null);
            e.trackedPostpones !== null && (sn.trackedContentKeyPath = r);
            var un = nl(e, I.chunks.length, sn, l.formatContext, !1, !1);
            I.children.push(un), I.lastPushedText = !1;
            var dn = nl(e, 0, null, l.formatContext, !1, !1);
            if (dn.parentFlushed = !0, e.trackedPostpones !== null) {
              y = l.componentStack, T = [
                r[0],
                "Suspense Fallback",
                r[2]
              ], m = [
                T[1],
                T[2],
                [],
                null
              ], e.trackedPostpones.workingMap.set(T, m), sn.trackedFallbackNode = m, l.blockedSegment = un, l.blockedPreamble = sn.fallbackPreamble, l.keyPath = T, l.formatContext = Ne(e.resumableState, d), l.componentStack = ri(y), un.status = 6;
              try {
                fe(e, l, xn, -1), kt(un.chunks, e.renderState, un.lastPushedText, un.textEmbedded), un.status = 1;
              } catch (Wn) {
                throw un.status = e.status === 12 ? 3 : 4, Wn;
              } finally {
                l.blockedSegment = I, l.blockedPreamble = A, l.keyPath = c, l.formatContext = d;
              }
              l = Ki(e, null, u, -1, sn, dn, sn.contentPreamble, sn.contentState, l.abortSet, r, De(e.resumableState, l.formatContext), l.context, l.treeContext, null, y), Dt(l), e.pingedTasks.push(l);
            } else {
              l.blockedBoundary = sn, l.blockedPreamble = sn.contentPreamble, l.hoistableState = sn.contentState, l.blockedSegment = dn, l.keyPath = r, l.formatContext = De(e.resumableState, d), l.row = null, dn.status = 6;
              try {
                if (fe(e, l, u, -1), kt(dn.chunks, e.renderState, dn.lastPushedText, dn.textEmbedded), dn.status = 1, oi(sn, dn), sn.pendingTasks === 0 && sn.status === 0) {
                  if (sn.status = 1, !Ml(e, sn)) {
                    L !== null && --L.pendingTasks === 0 && Bn(e, L), e.pendingRootTasks === 0 && l.blockedPreamble && ll(e);
                    break n;
                  }
                } else L !== null && L.together && mr(e, L);
              } catch (Wn) {
                sn.status = 4, e.status === 12 ? (dn.status = 3, y = e.fatalError) : (dn.status = 4, y = Wn), T = mt(l.componentStack), m = we(e, y, T), sn.errorDigest = m, nr(e, sn);
              } finally {
                l.blockedBoundary = Z, l.blockedPreamble = A, l.hoistableState = en, l.blockedSegment = I, l.keyPath = c, l.formatContext = d, l.row = L;
              }
              l = Ki(e, null, xn, -1, Z, un, sn.fallbackPreamble, sn.fallbackState, fn, [
                r[0],
                "Suspense Fallback",
                r[2]
              ], Ne(e.resumableState, l.formatContext), l.context, l.treeContext, l.row, ri(l.componentStack)), Dt(l), e.pingedTasks.push(l);
            }
          }
          return;
      }
      if (typeof c == "object" && c !== null) switch (c.$$typeof) {
        case W:
          if ("ref" in u) for (xn in y = {}, u) xn !== "ref" && (y[xn] = u[xn]);
          else y = u;
          c = Br(e, l, r, c.render, y, d), Va(e, l, r, c, ei !== 0, ti, li);
          return;
        case B:
          pi(e, l, r, c.type, u, d);
          return;
        case N:
          if (T = u.children, y = l.keyPath, u = u.value, m = c._currentValue2, c._currentValue2 = u, d = jt, jt = c = {
            parent: d,
            depth: d === null ? 0 : d.depth + 1,
            context: c,
            parentValue: m,
            value: u
          }, l.context = c, l.keyPath = r, Ze(e, l, T, -1), e = jt, e === null) throw Error(s(403));
          e.context._currentValue2 = e.parentValue, e = jt = e.parent, l.context = e, l.keyPath = y;
          return;
        case D:
          u = u.children, c = u(c._context._currentValue2), u = l.keyPath, l.keyPath = r, Ze(e, l, c, -1), l.keyPath = u;
          return;
        case Y:
          if (y = c._init, c = y(c._payload), e.status === 12) throw null;
          pi(e, l, r, c, u, d);
          return;
      }
      throw Error(s(130, c == null ? c : typeof c, ""));
    }
  }
  function qi(e, l, r, c, u) {
    var d = l.replay, y = l.blockedBoundary, I = nl(e, 0, null, l.formatContext, !1, !1);
    I.id = r, I.parentFlushed = !0;
    try {
      l.replay = null, l.blockedSegment = I, fe(e, l, c, u), I.status = 1, y === null ? e.completedRootSegment = I : (oi(y, I), y.parentFlushed && e.partialBoundaries.push(y));
    } finally {
      l.replay = d, l.blockedSegment = null;
    }
  }
  function Ze(e, l, r, c) {
    l.replay !== null && typeof l.replay.slots == "number" ? qi(e, l, l.replay.slots, r, c) : (l.node = r, l.childIndex = c, r = l.componentStack, Dt(l), zr(e, l), l.componentStack = r);
  }
  function zr(e, l) {
    var r = l.node, c = l.childIndex;
    if (r !== null) {
      if (typeof r == "object") {
        switch (r.$$typeof) {
          case x:
            var u = r.type, d = r.key, y = r.props;
            r = y.ref;
            var I = r !== void 0 ? r : null, T = $l(u), A = d ?? (c === -1 ? 0 : c);
            if (d = [
              l.keyPath,
              T,
              A
            ], l.replay !== null) n: {
              var m = l.replay;
              for (c = m.nodes, r = 0; r < c.length; r++) {
                var L = c[r];
                if (A === L[1]) {
                  if (L.length === 4) {
                    if (T !== null && T !== L[0]) throw Error(s(490, L[0], T));
                    var Z = L[2];
                    T = L[3], A = l.node, l.replay = {
                      nodes: Z,
                      slots: T,
                      pendingTasks: 1
                    };
                    try {
                      if (pi(e, l, d, u, y, I), l.replay.pendingTasks === 1 && 0 < l.replay.nodes.length) throw Error(s(488));
                      l.replay.pendingTasks--;
                    } catch (Fn) {
                      if (typeof Fn == "object" && Fn !== null && (Fn === He || typeof Fn.then == "function")) throw l.node === A ? l.replay = m : c.splice(r, 1), Fn;
                      l.replay.pendingTasks--, y = mt(l.componentStack), d = e, e = l.blockedBoundary, u = Fn, y = we(d, u, y), el(d, e, Z, T, u, y);
                    }
                    l.replay = m;
                  } else {
                    if (u !== z) throw Error(s(490, "Suspense", $l(u) || "Unknown"));
                    e: {
                      m = void 0, u = L[5], I = L[2], T = L[3], A = L[4] === null ? [] : L[4][2], L = L[4] === null ? null : L[4][3];
                      var en = l.keyPath, xn = l.formatContext, fn = l.row, sn = l.replay, un = l.blockedBoundary, dn = l.hoistableState, Wn = y.children, Vn = y.fallback, Rn = /* @__PURE__ */ new Set();
                      y = Dr(e, l.row, Rn, null, null), y.parentFlushed = !0, y.rootSegmentID = u, l.blockedBoundary = y, l.hoistableState = y.contentState, l.keyPath = d, l.formatContext = De(e.resumableState, xn), l.row = null, l.replay = {
                        nodes: I,
                        slots: T,
                        pendingTasks: 1
                      };
                      try {
                        if (fe(e, l, Wn, -1), l.replay.pendingTasks === 1 && 0 < l.replay.nodes.length) throw Error(s(488));
                        if (l.replay.pendingTasks--, y.pendingTasks === 0 && y.status === 0) {
                          y.status = 1, e.completedBoundaries.push(y);
                          break e;
                        }
                      } catch (Fn) {
                        y.status = 4, Z = mt(l.componentStack), m = we(e, Fn, Z), y.errorDigest = m, l.replay.pendingTasks--, e.clientRenderedBoundaries.push(y);
                      } finally {
                        l.blockedBoundary = un, l.hoistableState = dn, l.replay = sn, l.keyPath = en, l.formatContext = xn, l.row = fn;
                      }
                      Z = Ja(e, null, {
                        nodes: A,
                        slots: L,
                        pendingTasks: 0
                      }, Vn, -1, un, y.fallbackState, Rn, [
                        d[0],
                        "Suspense Fallback",
                        d[2]
                      ], Ne(e.resumableState, l.formatContext), l.context, l.treeContext, l.row, ri(l.componentStack)), Dt(Z), e.pingedTasks.push(Z);
                    }
                  }
                  c.splice(r, 1);
                  break n;
                }
              }
            }
            else pi(e, l, d, u, y, I);
            return;
          case C:
            throw Error(s(257));
          case Y:
            if (Z = r._init, r = Z(r._payload), e.status === 12) throw null;
            Ze(e, l, r, c);
            return;
        }
        if (ln(r)) {
          ji(e, l, r, c);
          return;
        }
        if ((Z = p(r)) && (Z = Z.call(r))) {
          if (r = Z.next(), !r.done) {
            y = [];
            do
              y.push(r.value), r = Z.next();
            while (!r.done);
            ji(e, l, y, c);
          }
          return;
        }
        if (typeof r.then == "function") return l.thenableState = null, Ze(e, l, Ga(r), c);
        if (r.$$typeof === N) return Ze(e, l, r._currentValue2, c);
        throw c = Object.prototype.toString.call(r), Error(s(31, c === "[object Object]" ? "object with keys {" + Object.keys(r).join(", ") + "}" : c));
      }
      typeof r == "string" ? (c = l.blockedSegment, c !== null && (c.lastPushedText = zi(c.chunks, r, e.renderState, c.lastPushedText))) : (typeof r == "number" || typeof r == "bigint") && (c = l.blockedSegment, c !== null && (c.lastPushedText = zi(c.chunks, "" + r, e.renderState, c.lastPushedText)));
    }
  }
  function ji(e, l, r, c) {
    var u = l.keyPath;
    if (c !== -1 && (l.keyPath = [
      l.keyPath,
      "Fragment",
      c
    ], l.replay !== null)) {
      for (var d = l.replay, y = d.nodes, I = 0; I < y.length; I++) {
        var T = y[I];
        if (T[1] === c) {
          c = T[2], T = T[3], l.replay = {
            nodes: c,
            slots: T,
            pendingTasks: 1
          };
          try {
            if (ji(e, l, r, -1), l.replay.pendingTasks === 1 && 0 < l.replay.nodes.length) throw Error(s(488));
            l.replay.pendingTasks--;
          } catch (L) {
            if (typeof L == "object" && L !== null && (L === He || typeof L.then == "function")) throw L;
            l.replay.pendingTasks--, r = mt(l.componentStack);
            var A = l.blockedBoundary, m = L;
            r = we(e, m, r), el(e, A, c, T, m, r);
          }
          l.replay = d, y.splice(I, 1);
          break;
        }
      }
      l.keyPath = u;
      return;
    }
    if (d = l.treeContext, y = r.length, l.replay !== null && (I = l.replay.slots, I !== null && typeof I == "object")) {
      for (c = 0; c < y; c++) T = r[c], l.treeContext = $t(d, y, c), A = I[c], typeof A == "number" ? (qi(e, l, A, T, c), delete I[c]) : fe(e, l, T, c);
      l.treeContext = d, l.keyPath = u;
      return;
    }
    for (I = 0; I < y; I++) c = r[I], l.treeContext = $t(d, y, I), fe(e, l, c, I);
    l.treeContext = d, l.keyPath = u;
  }
  function ci(e, l, r) {
    if (r.status = 5, r.rootSegmentID = e.nextSegmentId++, e = r.trackedContentKeyPath, e === null) throw Error(s(486));
    var c = r.trackedFallbackNode, u = [], d = l.workingMap.get(e);
    return d === void 0 ? (r = [
      e[1],
      e[2],
      u,
      null,
      c,
      r.rootSegmentID
    ], l.workingMap.set(e, r), ct(r, e[0], l), r) : (d[4] = c, d[5] = r.rootSegmentID, d);
  }
  function $i(e, l, r, c) {
    c.status = 5;
    var u = r.keyPath, d = r.blockedBoundary;
    if (d === null) c.id = e.nextSegmentId++, l.rootSlots = c.id, e.completedRootSegment !== null && (e.completedRootSegment.status = 5);
    else {
      if (d !== null && d.status === 0) {
        var y = ci(e, l, d);
        if (d.trackedContentKeyPath === u && r.childIndex === -1) {
          c.id === -1 && (c.id = c.parentFlushed ? d.rootSegmentID : e.nextSegmentId++), y[3] = c.id;
          return;
        }
      }
      if (c.id === -1 && (c.id = c.parentFlushed && d !== null ? d.rootSegmentID : e.nextSegmentId++), r.childIndex === -1) u === null ? l.rootSlots = c.id : (r = l.workingMap.get(u), r === void 0 ? (r = [
        u[1],
        u[2],
        [],
        c.id
      ], ct(r, u[0], l)) : r[3] = c.id);
      else {
        if (u === null) {
          if (e = l.rootSlots, e === null) e = l.rootSlots = {};
          else if (typeof e == "number") throw Error(s(491));
        } else if (d = l.workingMap, y = d.get(u), y === void 0) e = {}, y = [
          u[1],
          u[2],
          [],
          e
        ], d.set(u, y), ct(y, u[0], l);
        else if (e = y[3], e === null) e = y[3] = {};
        else if (typeof e == "number") throw Error(s(491));
        e[r.childIndex] = c.id;
      }
    }
  }
  function nr(e, l) {
    e = e.trackedPostpones, e !== null && (l = l.trackedContentKeyPath, l !== null && (l = e.workingMap.get(l), l !== void 0 && (l.length = 4, l[2] = [], l[3] = null)));
  }
  function er(e, l, r) {
    return Ja(e, r, l.replay, l.node, l.childIndex, l.blockedBoundary, l.hoistableState, l.abortSet, l.keyPath, l.formatContext, l.context, l.treeContext, l.row, l.componentStack);
  }
  function tr(e, l, r) {
    var c = l.blockedSegment, u = nl(e, c.chunks.length, null, l.formatContext, c.lastPushedText, !0);
    return c.children.push(u), c.lastPushedText = !1, Ki(e, r, l.node, l.childIndex, l.blockedBoundary, u, l.blockedPreamble, l.hoistableState, l.abortSet, l.keyPath, l.formatContext, l.context, l.treeContext, l.row, l.componentStack);
  }
  function fe(e, l, r, c) {
    var u = l.formatContext, d = l.context, y = l.keyPath, I = l.treeContext, T = l.componentStack, A = l.blockedSegment;
    if (A === null) {
      A = l.replay;
      try {
        return Ze(e, l, r, c);
      } catch (Z) {
        if (ii(), r = Z === He ? Gi() : Z, e.status !== 12 && typeof r == "object" && r !== null) {
          if (typeof r.then == "function") {
            c = Z === He ? Rl() : null, e = er(e, l, c).ping, r.then(e, e), l.formatContext = u, l.context = d, l.keyPath = y, l.treeContext = I, l.componentStack = T, l.replay = A, Lt(d);
            return;
          }
          if (r.message === "Maximum call stack size exceeded") {
            r = Z === He ? Rl() : null, r = er(e, l, r), e.pingedTasks.push(r), l.formatContext = u, l.context = d, l.keyPath = y, l.treeContext = I, l.componentStack = T, l.replay = A, Lt(d);
            return;
          }
        }
      }
    } else {
      var m = A.children.length, L = A.chunks.length;
      try {
        return Ze(e, l, r, c);
      } catch (Z) {
        if (ii(), A.children.length = m, A.chunks.length = L, r = Z === He ? Gi() : Z, e.status !== 12 && typeof r == "object" && r !== null) {
          if (typeof r.then == "function") {
            A = r, r = Z === He ? Rl() : null, e = tr(e, l, r).ping, A.then(e, e), l.formatContext = u, l.context = d, l.keyPath = y, l.treeContext = I, l.componentStack = T, Lt(d);
            return;
          }
          if (r.message === "Maximum call stack size exceeded") {
            A = Z === He ? Rl() : null, A = tr(e, l, A), e.pingedTasks.push(A), l.formatContext = u, l.context = d, l.keyPath = y, l.treeContext = I, l.componentStack = T, Lt(d);
            return;
          }
        }
      }
    }
    throw l.formatContext = u, l.context = d, l.keyPath = y, l.treeContext = I, Lt(d), r;
  }
  function Gc(e) {
    var l = e.blockedBoundary, r = e.blockedSegment;
    r !== null && (r.status = 3, Bt(this, l, e.row, r));
  }
  function el(e, l, r, c, u, d) {
    for (var y = 0; y < r.length; y++) {
      var I = r[y];
      if (I.length === 4) el(e, l, I[2], I[3], u, d);
      else {
        I = I[5];
        var T = e, A = d, m = Dr(T, null, /* @__PURE__ */ new Set(), null, null);
        m.parentFlushed = !0, m.rootSegmentID = I, m.status = 4, m.errorDigest = A, m.parentFlushed && T.clientRenderedBoundaries.push(m);
      }
    }
    if (r.length = 0, c !== null) {
      if (l === null) throw Error(s(487));
      if (l.status !== 4 && (l.status = 4, l.errorDigest = d, l.parentFlushed && e.clientRenderedBoundaries.push(l)), typeof c == "object") for (var L in c) delete c[L];
    }
  }
  function Hr(e, l, r) {
    var c = e.blockedBoundary, u = e.blockedSegment;
    if (u !== null) {
      if (u.status === 6) return;
      u.status = 3;
    }
    var d = mt(e.componentStack);
    if (c === null) {
      if (l.status !== 13 && l.status !== 14) {
        if (c = e.replay, c === null) {
          l.trackedPostpones !== null && u !== null ? (c = l.trackedPostpones, we(l, r, d), $i(l, c, e, u), Bt(l, null, e.row, u)) : (we(l, r, d), Il(l, r));
          return;
        }
        c.pendingTasks--, c.pendingTasks === 0 && 0 < c.nodes.length && (u = we(l, r, d), el(l, null, c.nodes, c.slots, r, u)), l.pendingRootTasks--, l.pendingRootTasks === 0 && Ur(l);
      }
    } else {
      var y = l.trackedPostpones;
      if (c.status !== 4) {
        if (y !== null && u !== null) return we(l, r, d), $i(l, y, e, u), c.fallbackAbortableTasks.forEach(function(I) {
          return Hr(I, l, r);
        }), c.fallbackAbortableTasks.clear(), Bt(l, c, e.row, u);
        c.status = 4, u = we(l, r, d), c.status = 4, c.errorDigest = u, nr(l, c), c.parentFlushed && l.clientRenderedBoundaries.push(c);
      }
      c.pendingTasks--, u = c.row, u !== null && --u.pendingTasks === 0 && Bn(l, u), c.fallbackAbortableTasks.forEach(function(I) {
        return Hr(I, l, r);
      }), c.fallbackAbortableTasks.clear();
    }
    e = e.row, e !== null && --e.pendingTasks === 0 && Bn(l, e), l.allPendingTasks--, l.allPendingTasks === 0 && lr(l);
  }
  function Wr(e, l) {
    try {
      var r = e.renderState, c = r.onHeaders;
      if (c) {
        var u = r.headers;
        if (u) {
          r.headers = null;
          var d = u.preconnects;
          if (u.fontPreloads && (d && (d += ", "), d += u.fontPreloads), u.highImagePreloads && (d && (d += ", "), d += u.highImagePreloads), !l) {
            var y = r.styles.values(), I = y.next();
            n: for (; 0 < u.remainingCapacity && !I.done; I = y.next()) for (var T = I.value.sheets.values(), A = T.next(); 0 < u.remainingCapacity && !A.done; A = T.next()) {
              var m = A.value, L = m.props, Z = L.href, en = m.props, xn = ce(en.href, "style", {
                crossOrigin: en.crossOrigin,
                integrity: en.integrity,
                nonce: en.nonce,
                type: en.type,
                fetchPriority: en.fetchPriority,
                referrerPolicy: en.referrerPolicy,
                media: en.media
              });
              if (0 <= (u.remainingCapacity -= xn.length + 2)) r.resets.style[Z] = Yn, d && (d += ", "), d += xn, r.resets.style[Z] = typeof L.crossOrigin == "string" || typeof L.integrity == "string" ? [L.crossOrigin, L.integrity] : Yn;
              else break n;
            }
          }
          c(d ? { Link: d } : {});
        }
      }
    } catch (fn) {
      we(e, fn, {});
    }
  }
  function Ur(e) {
    e.trackedPostpones === null && Wr(e, !0), e.trackedPostpones === null && ll(e), e.onShellError = Ie, e = e.onShellReady, e();
  }
  function lr(e) {
    Wr(e, e.trackedPostpones === null ? !0 : e.completedRootSegment === null || e.completedRootSegment.status !== 5), ll(e), e = e.onAllReady, e();
  }
  function oi(e, l) {
    if (l.chunks.length === 0 && l.children.length === 1 && l.children[0].boundary === null && l.children[0].id === -1) {
      var r = l.children[0];
      r.id = l.id, r.parentFlushed = !0, r.status !== 1 && r.status !== 3 && r.status !== 4 || oi(e, r);
    } else e.completedSegments.push(l);
  }
  function Bt(e, l, r, c) {
    if (r !== null && (--r.pendingTasks === 0 ? Bn(e, r) : r.together && mr(e, r)), e.allPendingTasks--, l === null) {
      if (c !== null && c.parentFlushed) {
        if (e.completedRootSegment !== null) throw Error(s(389));
        e.completedRootSegment = c;
      }
      e.pendingRootTasks--, e.pendingRootTasks === 0 && Ur(e);
    } else if (l.pendingTasks--, l.status !== 4) if (l.pendingTasks === 0) {
      if (l.status === 0 && (l.status = 1), c !== null && c.parentFlushed && (c.status === 1 || c.status === 3) && oi(l, c), l.parentFlushed && e.completedBoundaries.push(l), l.status === 1) r = l.row, r !== null && wl(r.hoistables, l.contentState), Ml(e, l) || (l.fallbackAbortableTasks.forEach(Gc, e), l.fallbackAbortableTasks.clear(), r !== null && --r.pendingTasks === 0 && Bn(e, r)), e.pendingRootTasks === 0 && e.trackedPostpones === null && l.contentPreamble !== null && ll(e);
      else if (l.status === 5 && (l = l.row, l !== null)) {
        if (e.trackedPostpones !== null) {
          r = e.trackedPostpones;
          var u = l.next;
          if (u !== null && (c = u.boundaries, c !== null)) for (u.boundaries = null, u = 0; u < c.length; u++) {
            var d = c[u];
            ci(e, r, d), Bt(e, d, null, null);
          }
        }
        --l.pendingTasks === 0 && Bn(e, l);
      }
    } else c === null || !c.parentFlushed || c.status !== 1 && c.status !== 3 || (oi(l, c), l.completedSegments.length === 1 && l.parentFlushed && e.partialBoundaries.push(l)), l = l.row, l !== null && l.together && mr(e, l);
    e.allPendingTasks === 0 && lr(e);
  }
  function Ka(e) {
    if (e.status !== 14 && e.status !== 13) {
      var l = jt, r = ee.H;
      ee.H = Ya;
      var c = ee.A;
      ee.A = zc;
      var u = ge;
      ge = e;
      var d = Qi;
      Qi = e.resumableState;
      try {
        var y = e.pingedTasks, I;
        for (I = 0; I < y.length; I++) {
          var T = y[I], A = e, m = T.blockedSegment;
          if (m === null) {
            var L = A;
            if (T.replay.pendingTasks !== 0) {
              Lt(T.context);
              try {
                if (typeof T.replay.slots == "number" ? qi(L, T, T.replay.slots, T.node, T.childIndex) : zr(L, T), T.replay.pendingTasks === 1 && 0 < T.replay.nodes.length) throw Error(s(488));
                T.replay.pendingTasks--, T.abortSet.delete(T), Bt(L, T.blockedBoundary, T.row, null);
              } catch (Un) {
                ii();
                var Z = Un === He ? Gi() : Un;
                if (typeof Z == "object" && Z !== null && typeof Z.then == "function") {
                  var en = T.ping;
                  Z.then(en, en), T.thenableState = Un === He ? Rl() : null;
                } else {
                  T.replay.pendingTasks--, T.abortSet.delete(T);
                  var xn = mt(T.componentStack);
                  A = void 0;
                  var fn = L, sn = T.blockedBoundary, un = L.status === 12 ? L.fatalError : Z, dn = T.replay.nodes, Wn = T.replay.slots;
                  A = we(fn, un, xn), el(fn, sn, dn, Wn, un, A), L.pendingRootTasks--, L.pendingRootTasks === 0 && Ur(L), L.allPendingTasks--, L.allPendingTasks === 0 && lr(L);
                }
              }
            }
          } else if (L = void 0, fn = m, fn.status === 0) {
            fn.status = 6, Lt(T.context);
            var Vn = fn.children.length, Rn = fn.chunks.length;
            try {
              zr(A, T), kt(fn.chunks, A.renderState, fn.lastPushedText, fn.textEmbedded), T.abortSet.delete(T), fn.status = 1, Bt(A, T.blockedBoundary, T.row, fn);
            } catch (Un) {
              ii(), fn.children.length = Vn, fn.chunks.length = Rn;
              var Fn = Un === He ? Gi() : A.status === 12 ? A.fatalError : Un;
              if (A.status === 12 && A.trackedPostpones !== null) {
                var wn = A.trackedPostpones, ke = mt(T.componentStack);
                T.abortSet.delete(T), we(A, Fn, ke), $i(A, wn, T, fn), Bt(A, T.blockedBoundary, T.row, fn);
              } else if (typeof Fn == "object" && Fn !== null && typeof Fn.then == "function") {
                fn.status = 0, T.thenableState = Un === He ? Rl() : null;
                var Sn = T.ping;
                Fn.then(Sn, Sn);
              } else {
                var We = mt(T.componentStack);
                T.abortSet.delete(T), fn.status = 4;
                var kn = T.blockedBoundary, re = T.row;
                if (re !== null && --re.pendingTasks === 0 && Bn(A, re), A.allPendingTasks--, L = we(A, Fn, We), kn === null) Il(A, Fn);
                else if (kn.pendingTasks--, kn.status !== 4) {
                  kn.status = 4, kn.errorDigest = L, nr(A, kn);
                  var oe = kn.row;
                  oe !== null && --oe.pendingTasks === 0 && Bn(A, oe), kn.parentFlushed && A.clientRenderedBoundaries.push(kn), A.pendingRootTasks === 0 && A.trackedPostpones === null && kn.contentPreamble !== null && ll(A);
                }
                A.allPendingTasks === 0 && lr(A);
              }
            }
          }
        }
        y.splice(0, I), e.destination !== null && ir(e, e.destination);
      } catch (Un) {
        we(e, Un, {}), Il(e, Un);
      } finally {
        Qi = d, ee.H = r, ee.A = c, r === Ya && Lt(l), ge = u;
      }
    }
  }
  function tl(e, l, r) {
    l.preambleChildren.length && r.push(l.preambleChildren);
    for (var c = !1, u = 0; u < l.children.length; u++) c = ui(e, l.children[u], r) || c;
    return c;
  }
  function ui(e, l, r) {
    var c = l.boundary;
    if (c === null) return tl(e, l, r);
    var u = c.contentPreamble, d = c.fallbackPreamble;
    if (u === null || d === null) return !1;
    switch (c.status) {
      case 1:
        if (xl(e.renderState, u), e.byteSize += c.byteSize, l = c.completedSegments[0], !l) throw Error(s(391));
        return tl(e, l, r);
      case 5:
        if (e.trackedPostpones !== null) return !0;
      case 4:
        if (l.status === 1) return xl(e.renderState, d), tl(e, l, r);
      default:
        return !0;
    }
  }
  function ll(e) {
    if (e.completedRootSegment && e.completedPreambleSegments === null) {
      var l = [], r = e.byteSize, c = ui(e, e.completedRootSegment, l), u = e.renderState.preamble;
      c === !1 || u.headChunks && u.bodyChunks ? e.completedPreambleSegments = l : e.byteSize = r;
    }
  }
  function Al(e, l, r, c) {
    switch (r.parentFlushed = !0, r.status) {
      case 0:
        r.id = e.nextSegmentId++;
      case 5:
        return c = r.id, r.lastPushedText = !1, r.textEmbedded = !1, e = e.renderState, l.push('<template id="'), l.push(e.placeholderPrefix), e = c.toString(16), l.push(e), l.push('"></template>');
      case 1:
        r.status = 2;
        var u = !0, d = r.chunks, y = 0;
        r = r.children;
        for (var I = 0; I < r.length; I++) {
          for (u = r[I]; y < u.index; y++) l.push(d[y]);
          u = rl(e, l, u, c);
        }
        for (; y < d.length - 1; y++) l.push(d[y]);
        return y < d.length && (u = l.push(d[y])), u;
      case 3:
        return !0;
      default:
        throw Error(s(390));
    }
  }
  var il = 0;
  function rl(e, l, r, c) {
    var u = r.boundary;
    if (u === null) return Al(e, l, r, c);
    if (u.parentFlushed = !0, u.status === 4) {
      var d = u.row;
      return d !== null && --d.pendingTasks === 0 && Bn(e, d), e.renderState.generateStaticMarkup || (u = u.errorDigest, l.push("<!--$!-->"), l.push("<template"), u && (l.push(' data-dgst="'), u = V(u), l.push(u), l.push('"')), l.push("></template>")), Al(e, l, r, c), e = e.renderState.generateStaticMarkup ? !0 : l.push("<!--/$-->"), e;
    }
    if (u.status !== 1) return u.status === 0 && (u.rootSegmentID = e.nextSegmentId++), 0 < u.completedSegments.length && e.partialBoundaries.push(u), qt(l, e.renderState, u.rootSegmentID), c && wl(c, u.fallbackState), Al(e, l, r, c), l.push("<!--/$-->");
    if (!fi && Ml(e, u) && il + u.byteSize > e.progressiveChunkSize) return u.rootSegmentID = e.nextSegmentId++, e.completedBoundaries.push(u), qt(l, e.renderState, u.rootSegmentID), Al(e, l, r, c), l.push("<!--/$-->");
    if (il += u.byteSize, c && wl(c, u.contentState), r = u.row, r !== null && Ml(e, u) && --r.pendingTasks === 0 && Bn(e, r), e.renderState.generateStaticMarkup || l.push("<!--$-->"), r = u.completedSegments, r.length !== 1) throw Error(s(391));
    return rl(e, l, r[0], c), e = e.renderState.generateStaticMarkup ? !0 : l.push("<!--/$-->"), e;
  }
  function Gr(e, l, r, c) {
    return $e(l, e.renderState, r.parentFormatContext, r.id), rl(e, l, r, c), Ia(l, r.parentFormatContext);
  }
  function pa(e, l, r) {
    il = r.byteSize;
    for (var c = r.completedSegments, u = 0; u < c.length; u++) al(e, l, r, c[u]);
    c.length = 0, c = r.row, c !== null && Ml(e, r) && --c.pendingTasks === 0 && Bn(e, c), Li(l, r.contentState, e.renderState), c = e.resumableState, e = e.renderState, u = r.rootSegmentID, r = r.contentState;
    var d = e.stylesToHoist;
    return e.stylesToHoist = !1, l.push(e.startInlineScript), l.push(">"), d ? ((c.instructions & 4) === 0 && (c.instructions |= 4, l.push('$RX=function(b,c,d,e,f){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),f&&(a.cstck=f),b._reactRetry&&b._reactRetry())};')), (c.instructions & 2) === 0 && (c.instructions |= 2, l.push(`$RB=[];$RV=function(a){$RT=performance.now();for(var b=0;b<a.length;b+=2){var c=a[b],e=a[b+1];null!==e.parentNode&&e.parentNode.removeChild(e);var f=c.parentNode;if(f){var g=c.previousSibling,h=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d||"/&"===d)if(0===h)break;else h--;else"$"!==d&&"$?"!==d&&"$~"!==d&&"$!"!==d&&"&"!==d||h++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;e.firstChild;)f.insertBefore(e.firstChild,c);g.data="$";g._reactRetry&&requestAnimationFrame(g._reactRetry)}}a.length=0};
$RC=function(a,b){if(b=document.getElementById(b))(a=document.getElementById(a))?(a.previousSibling.data="$~",$RB.push(a,b),2===$RB.length&&("number"!==typeof $RT?requestAnimationFrame($RV.bind(null,$RB)):(a=performance.now(),setTimeout($RV.bind(null,$RB),2300>a&&2E3<a?2300-a:$RT+300-a)))):b.parentNode.removeChild(b)};`)), (c.instructions & 8) === 0 ? (c.instructions |= 8, l.push(`$RM=new Map;$RR=function(n,w,p){function u(q){this._p=null;q()}for(var r=new Map,t=document,h,b,e=t.querySelectorAll("link[data-precedence],style[data-precedence]"),v=[],k=0;b=e[k++];)"not all"===b.getAttribute("media")?v.push(b):("LINK"===b.tagName&&$RM.set(b.getAttribute("href"),b),r.set(b.dataset.precedence,h=b));e=0;b=[];var l,a;for(k=!0;;){if(k){var f=p[e++];if(!f){k=!1;e=0;continue}var c=!1,m=0;var d=f[m++];if(a=$RM.get(d)){var g=a._p;c=!0}else{a=t.createElement("link");a.href=d;a.rel=
"stylesheet";for(a.dataset.precedence=l=f[m++];g=f[m++];)a.setAttribute(g,f[m++]);g=a._p=new Promise(function(q,x){a.onload=u.bind(a,q);a.onerror=u.bind(a,x)});$RM.set(d,a)}d=a.getAttribute("media");!g||d&&!matchMedia(d).matches||b.push(g);if(c)continue}else{a=v[e++];if(!a)break;l=a.getAttribute("data-precedence");a.removeAttribute("media")}c=r.get(l)||h;c===h&&(h=a);r.set(l,a);c?c.parentNode.insertBefore(a,c.nextSibling):(c=t.head,c.insertBefore(a,c.firstChild))}if(p=document.getElementById(n))p.previousSibling.data=
"$~";Promise.all(b).then($RC.bind(null,n,w),$RX.bind(null,n,"CSS failed to load"))};$RR("`)) : l.push('$RR("')) : ((c.instructions & 2) === 0 && (c.instructions |= 2, l.push(`$RB=[];$RV=function(a){$RT=performance.now();for(var b=0;b<a.length;b+=2){var c=a[b],e=a[b+1];null!==e.parentNode&&e.parentNode.removeChild(e);var f=c.parentNode;if(f){var g=c.previousSibling,h=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d||"/&"===d)if(0===h)break;else h--;else"$"!==d&&"$?"!==d&&"$~"!==d&&"$!"!==d&&"&"!==d||h++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;e.firstChild;)f.insertBefore(e.firstChild,c);g.data="$";g._reactRetry&&requestAnimationFrame(g._reactRetry)}}a.length=0};
$RC=function(a,b){if(b=document.getElementById(b))(a=document.getElementById(a))?(a.previousSibling.data="$~",$RB.push(a,b),2===$RB.length&&("number"!==typeof $RT?requestAnimationFrame($RV.bind(null,$RB)):(a=performance.now(),setTimeout($RV.bind(null,$RB),2300>a&&2E3<a?2300-a:$RT+300-a)))):b.parentNode.removeChild(b)};`)), l.push('$RC("')), c = u.toString(16), l.push(e.boundaryPrefix), l.push(c), l.push('","'), l.push(e.segmentPrefix), l.push(c), d ? (l.push('",'), La(l, r)) : l.push('"'), r = l.push(")<\/script>"), pt(l, e) && r;
  }
  function al(e, l, r, c) {
    if (c.status === 2) return !0;
    var u = r.contentState, d = c.id;
    if (d === -1) {
      if ((c.id = r.rootSegmentID) === -1) throw Error(s(392));
      return Gr(e, l, c, u);
    }
    return d === r.rootSegmentID ? Gr(e, l, c, u) : (Gr(e, l, c, u), r = e.resumableState, e = e.renderState, l.push(e.startInlineScript), l.push(">"), (r.instructions & 1) === 0 ? (r.instructions |= 1, l.push('$RS=function(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("')) : l.push('$RS("'), l.push(e.segmentPrefix), d = d.toString(16), l.push(d), l.push('","'), l.push(e.placeholderPrefix), l.push(d), l = l.push('")<\/script>'), l);
  }
  var fi = !1;
  function ir(e, l) {
    try {
      if (!(0 < e.pendingRootTasks)) {
        var r, c = e.completedRootSegment;
        if (c !== null) {
          if (c.status === 5) return;
          var u = e.completedPreambleSegments;
          if (u === null) return;
          il = e.byteSize;
          var d = e.resumableState, y = e.renderState, I = y.preamble, T = I.htmlChunks, A = I.headChunks, m;
          if (T) {
            for (m = 0; m < T.length; m++) l.push(T[m]);
            if (A) for (m = 0; m < A.length; m++) l.push(A[m]);
            else {
              var L = Dn("head");
              l.push(L), l.push(">");
            }
          } else if (A) for (m = 0; m < A.length; m++) l.push(A[m]);
          var Z = y.charsetChunks;
          for (m = 0; m < Z.length; m++) l.push(Z[m]);
          Z.length = 0, y.preconnects.forEach(Be, l), y.preconnects.clear();
          var en = y.viewportChunks;
          for (m = 0; m < en.length; m++) l.push(en[m]);
          en.length = 0, y.fontPreloads.forEach(Be, l), y.fontPreloads.clear(), y.highImagePreloads.forEach(Be, l), y.highImagePreloads.clear(), Xn = y, y.styles.forEach(ka, l), Xn = null;
          var xn = y.importMapChunks;
          for (m = 0; m < xn.length; m++) l.push(xn[m]);
          xn.length = 0, y.bootstrapScripts.forEach(Be, l), y.scripts.forEach(Be, l), y.scripts.clear(), y.bulkPreloads.forEach(Be, l), y.bulkPreloads.clear(), d.instructions |= 32;
          var fn = y.hoistableChunks;
          for (m = 0; m < fn.length; m++) l.push(fn[m]);
          for (d = fn.length = 0; d < u.length; d++) {
            var sn = u[d];
            for (y = 0; y < sn.length; y++) rl(e, l, sn[y], null);
          }
          var un = e.renderState.preamble, dn = un.headChunks;
          if (un.htmlChunks || dn) {
            var Wn = rt("head");
            l.push(Wn);
          }
          var Vn = un.bodyChunks;
          if (Vn) for (u = 0; u < Vn.length; u++) l.push(Vn[u]);
          rl(e, l, c, null), e.completedRootSegment = null;
          var Rn = e.renderState;
          if (e.allPendingTasks !== 0 || e.clientRenderedBoundaries.length !== 0 || e.completedBoundaries.length !== 0 || e.trackedPostpones !== null && (e.trackedPostpones.rootNodes.length !== 0 || e.trackedPostpones.rootSlots !== null)) {
            var Fn = e.resumableState;
            if ((Fn.instructions & 64) === 0) {
              if (Fn.instructions |= 64, l.push(Rn.startInlineScript), (Fn.instructions & 32) === 0) {
                Fn.instructions |= 32;
                var wn = "_" + Fn.idPrefix + "R_";
                l.push(' id="');
                var ke = V(wn);
                l.push(ke), l.push('"');
              }
              l.push(">"), l.push("requestAnimationFrame(function(){$RT=performance.now()});"), l.push("<\/script>");
            }
          }
          pt(l, Rn);
        }
        var Sn = e.renderState;
        c = 0;
        var We = Sn.viewportChunks;
        for (c = 0; c < We.length; c++) l.push(We[c]);
        We.length = 0, Sn.preconnects.forEach(Be, l), Sn.preconnects.clear(), Sn.fontPreloads.forEach(Be, l), Sn.fontPreloads.clear(), Sn.highImagePreloads.forEach(Be, l), Sn.highImagePreloads.clear(), Sn.styles.forEach(Oa, l), Sn.scripts.forEach(Be, l), Sn.scripts.clear(), Sn.bulkPreloads.forEach(Be, l), Sn.bulkPreloads.clear();
        var kn = Sn.hoistableChunks;
        for (c = 0; c < kn.length; c++) l.push(kn[c]);
        kn.length = 0;
        var re = e.clientRenderedBoundaries;
        for (r = 0; r < re.length; r++) {
          var oe = re[r];
          Sn = l;
          var Un = e.resumableState, Ae = e.renderState, ol = oe.rootSegmentID, Ue = oe.errorDigest;
          Sn.push(Ae.startInlineScript), Sn.push(">"), (Un.instructions & 4) === 0 ? (Un.instructions |= 4, Sn.push('$RX=function(b,c,d,e,f){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),f&&(a.cstck=f),b._reactRetry&&b._reactRetry())};;$RX("')) : Sn.push('$RX("'), Sn.push(Ae.boundaryPrefix);
          var si = ol.toString(16);
          if (Sn.push(si), Sn.push('"'), Ue) {
            Sn.push(",");
            var _l = wc(Ue || "");
            Sn.push(_l);
          }
          var Ce = Sn.push(")<\/script>");
          if (!Ce) {
            e.destination = null, r++, re.splice(0, r);
            return;
          }
        }
        re.splice(0, r);
        var Je = e.completedBoundaries;
        for (r = 0; r < Je.length; r++) if (!pa(e, l, Je[r])) {
          e.destination = null, r++, Je.splice(0, r);
          return;
        }
        Je.splice(0, r), fi = !0;
        var nt = e.partialBoundaries;
        for (r = 0; r < nt.length; r++) {
          var et = nt[r];
          n: {
            re = e, oe = l, il = et.byteSize;
            var dt = et.completedSegments;
            for (Ce = 0; Ce < dt.length; Ce++) if (!al(re, oe, et, dt[Ce])) {
              Ce++, dt.splice(0, Ce);
              var zt = !1;
              break n;
            }
            dt.splice(0, Ce);
            var se = et.row;
            se !== null && se.together && et.pendingTasks === 1 && (se.pendingTasks === 1 ? at(re, se, se.hoistables) : se.pendingTasks--), zt = Li(oe, et.contentState, re.renderState);
          }
          if (!zt) {
            e.destination = null, r++, nt.splice(0, r);
            return;
          }
        }
        nt.splice(0, r), fi = !1;
        var Pl = e.completedBoundaries;
        for (r = 0; r < Pl.length; r++) if (!pa(e, l, Pl[r])) {
          e.destination = null, r++, Pl.splice(0, r);
          return;
        }
        Pl.splice(0, r);
      }
    } finally {
      fi = !1, e.allPendingTasks === 0 && e.clientRenderedBoundaries.length === 0 && e.completedBoundaries.length === 0 && (e.flushScheduled = !1, r = e.resumableState, r.hasBody && (nt = rt("body"), l.push(nt)), r.hasHtml && (r = rt("html"), l.push(r)), e.status = 14, l.push(null), e.destination = null);
    }
  }
  function cl(e) {
    if (e.flushScheduled === !1 && e.pingedTasks.length === 0 && e.destination !== null) {
      e.flushScheduled = !0;
      var l = e.destination;
      l ? ir(e, l) : e.flushScheduled = !1;
    }
  }
  function rr(e, l) {
    if (e.status === 13) e.status = 14, l.destroy(e.fatalError);
    else if (e.status !== 14 && e.destination === null) {
      e.destination = l;
      try {
        ir(e, l);
      } catch (r) {
        we(e, r, {}), Il(e, r);
      }
    }
  }
  function qa(e, l) {
    (e.status === 11 || e.status === 10) && (e.status = 12);
    try {
      var r = e.abortableTasks;
      if (0 < r.size) {
        var c = l === void 0 ? Error(s(432)) : typeof l == "object" && l !== null && typeof l.then == "function" ? Error(s(530)) : l;
        e.fatalError = c, r.forEach(function(u) {
          return Hr(u, e, c);
        }), r.clear();
      }
      e.destination !== null && ir(e, e.destination);
    } catch (u) {
      we(e, u, {}), Il(e, u);
    }
  }
  function ct(e, l, r) {
    if (l === null) r.rootNodes.push(e);
    else {
      var c = r.workingMap, u = c.get(l);
      u === void 0 && (u = [
        l[1],
        l[2],
        [],
        null
      ], c.set(l, u), ct(u, l[0], r)), u[2].push(e);
    }
  }
  function ar() {
  }
  function Yr(e, l, r, c) {
    var u = !1, d = null, y = "", I = !1;
    if (l = q(l ? l.identifierPrefix : void 0), e = Uc(e, l, Bi(l, r), tn(0, null, 0, null), 1 / 0, ar, void 0, function() {
      I = !0;
    }, void 0, void 0, void 0), e.flushScheduled = e.destination !== null, Ka(e), e.status === 10 && (e.status = 11), e.trackedPostpones === null && Wr(e, e.pendingRootTasks === 0), qa(e, c), rr(e, {
      push: function(T) {
        return T !== null && (y += T), !0;
      },
      destroy: function(T) {
        u = !0, d = T;
      }
    }), u && d !== c) throw d;
    if (!I) throw Error(s(426));
    return y;
  }
  h.renderToStaticMarkup = function(e, l) {
    return Yr(e, l, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
  }, h.renderToString = function(e, l) {
    return Yr(e, l, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
  }, h.version = "19.2.5";
})), xs = /* @__PURE__ */ yo(((h) => {
  var g = bo(), b = ou();
  function s(n) {
    var t = "https://react.dev/errors/" + n;
    if (1 < arguments.length) {
      t += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var i = 2; i < arguments.length; i++) t += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + n + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var x = /* @__PURE__ */ Symbol.for("react.transitional.element"), C = /* @__PURE__ */ Symbol.for("react.portal"), S = /* @__PURE__ */ Symbol.for("react.fragment"), M = /* @__PURE__ */ Symbol.for("react.strict_mode"), O = /* @__PURE__ */ Symbol.for("react.profiler"), D = /* @__PURE__ */ Symbol.for("react.consumer"), N = /* @__PURE__ */ Symbol.for("react.context"), W = /* @__PURE__ */ Symbol.for("react.forward_ref"), z = /* @__PURE__ */ Symbol.for("react.suspense"), U = /* @__PURE__ */ Symbol.for("react.suspense_list"), B = /* @__PURE__ */ Symbol.for("react.memo"), Y = /* @__PURE__ */ Symbol.for("react.lazy"), J = /* @__PURE__ */ Symbol.for("react.scope"), H = /* @__PURE__ */ Symbol.for("react.activity"), $ = /* @__PURE__ */ Symbol.for("react.legacy_hidden"), bn = /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel"), En = /* @__PURE__ */ Symbol.for("react.view_transition"), hn = Symbol.iterator;
  function p(n) {
    return n === null || typeof n != "object" ? null : (n = hn && n[hn] || n["@@iterator"], typeof n == "function" ? n : null);
  }
  var ln = Array.isArray;
  function on(n, t) {
    var i = n.length & 3, a = n.length - i, o = t;
    for (t = 0; t < a; ) {
      var f = n.charCodeAt(t) & 255 | (n.charCodeAt(++t) & 255) << 8 | (n.charCodeAt(++t) & 255) << 16 | (n.charCodeAt(++t) & 255) << 24;
      ++t, f = 3432918353 * (f & 65535) + ((3432918353 * (f >>> 16) & 65535) << 16) & 4294967295, f = f << 15 | f >>> 17, f = 461845907 * (f & 65535) + ((461845907 * (f >>> 16) & 65535) << 16) & 4294967295, o ^= f, o = o << 13 | o >>> 19, o = 5 * (o & 65535) + ((5 * (o >>> 16) & 65535) << 16) & 4294967295, o = (o & 65535) + 27492 + (((o >>> 16) + 58964 & 65535) << 16);
    }
    switch (f = 0, i) {
      case 3:
        f ^= (n.charCodeAt(t + 2) & 255) << 16;
      case 2:
        f ^= (n.charCodeAt(t + 1) & 255) << 8;
      case 1:
        f ^= n.charCodeAt(t) & 255, f = 3432918353 * (f & 65535) + ((3432918353 * (f >>> 16) & 65535) << 16) & 4294967295, f = f << 15 | f >>> 17, o ^= 461845907 * (f & 65535) + ((461845907 * (f >>> 16) & 65535) << 16) & 4294967295;
    }
    return o ^= n.length, o ^= o >>> 16, o = 2246822507 * (o & 65535) + ((2246822507 * (o >>> 16) & 65535) << 16) & 4294967295, o ^= o >>> 13, o = 3266489909 * (o & 65535) + ((3266489909 * (o >>> 16) & 65535) << 16) & 4294967295, (o ^ o >>> 16) >>> 0;
  }
  var cn = new MessageChannel(), nn = [];
  cn.port1.onmessage = function() {
    var n = nn.shift();
    n && n();
  };
  function An(n) {
    nn.push(n), cn.port2.postMessage(null);
  }
  function ae(n) {
    setTimeout(function() {
      throw n;
    });
  }
  var _n = Promise, Kn = typeof queueMicrotask == "function" ? queueMicrotask : function(n) {
    _n.resolve(null).then(n).catch(ae);
  }, In = null, On = 0;
  function _(n, t) {
    if (t.byteLength !== 0) if (2048 < t.byteLength) 0 < On && (n.enqueue(new Uint8Array(In.buffer, 0, On)), In = new Uint8Array(2048), On = 0), n.enqueue(t);
    else {
      var i = In.length - On;
      i < t.byteLength && (i === 0 ? n.enqueue(In) : (In.set(t.subarray(0, i), On), n.enqueue(In), t = t.subarray(i)), In = new Uint8Array(2048), On = 0), In.set(t, On), On += t.byteLength;
    }
  }
  function V(n, t) {
    return _(n, t), !0;
  }
  function gn(n) {
    In && 0 < On && (n.enqueue(new Uint8Array(In.buffer, 0, On)), In = null, On = 0);
  }
  var Nn = new TextEncoder();
  function G(n) {
    return Nn.encode(n);
  }
  function k(n) {
    return Nn.encode(n);
  }
  function ee(n) {
    return n.byteLength;
  }
  function ft(n, t) {
    typeof n.error == "function" ? n.error(t) : n.close();
  }
  var te = Object.assign, rn = Object.prototype.hasOwnProperty, Yn = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), Xn = {}, tt = {};
  function he(n) {
    return rn.call(tt, n) ? !0 : rn.call(Xn, n) ? !1 : Yn.test(n) ? tt[n] = !0 : (Xn[n] = !0, !1);
  }
  var q = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" ")), tn = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), Mn = /["'&<>]/;
  function j(n) {
    if (typeof n == "boolean" || typeof n == "number" || typeof n == "bigint") return "" + n;
    n = "" + n;
    var t = Mn.exec(n);
    if (t) {
      var i = "", a, o = 0;
      for (a = t.index; a < n.length; a++) {
        switch (n.charCodeAt(a)) {
          case 34:
            t = "&quot;";
            break;
          case 38:
            t = "&amp;";
            break;
          case 39:
            t = "&#x27;";
            break;
          case 60:
            t = "&lt;";
            break;
          case 62:
            t = "&gt;";
            break;
          default:
            continue;
        }
        o !== a && (i += n.slice(o, a)), o = a + 1, i += t;
      }
      n = o !== a ? i + n.slice(o, a) : i;
    }
    return n;
  }
  var Ne = /([A-Z])/g, De = /^ms-/, Ft = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function me(n) {
    return Ft.test("" + n) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : n;
  }
  var Te = g.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Zn = b.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, bl = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, Me = Zn.d;
  Zn.d = {
    f: Me.f,
    r: Me.r,
    D: Hr,
    C: Wr,
    L: Ur,
    m: lr,
    X: Bt,
    S: oi,
    M: Ka
  };
  var xe = [], lt = null;
  k('"></template>');
  var Oi = k("<script"), Tn = k("<\/script>"), Fe = k('<script src="'), Zl = k('<script type="module" src="'), it = k(' nonce="'), jn = k(' integrity="'), Vt = k(' crossorigin="'), It = k(' async=""><\/script>'), At = k("<style"), yl = /(<\/|<)(s)(cript)/gi;
  function _t(n, t, i, a) {
    return "" + t + (i === "s" ? "\\u0073" : "\\u0053") + a;
  }
  var Jl = k('<script type="importmap">'), El = k("<\/script>");
  function Kt(n, t, i, a, o, f) {
    i = typeof t == "string" ? t : t && t.script;
    var v = i === void 0 ? Oi : k('<script nonce="' + j(i) + '"'), R = typeof t == "string" ? void 0 : t && t.style, E = R === void 0 ? At : k('<style nonce="' + j(R) + '"'), w = n.idPrefix, F = [], P = n.bootstrapScriptContent, X = n.bootstrapScripts, Q = n.bootstrapModules;
    if (P !== void 0 && (F.push(v), ci(F, n), F.push(zn, G(("" + P).replace(yl, _t)), Tn)), P = [], a !== void 0 && (P.push(Jl), P.push(G(("" + JSON.stringify(a)).replace(yl, _t))), P.push(El)), a = o ? {
      preconnects: "",
      fontPreloads: "",
      highImagePreloads: "",
      remainingCapacity: 2 + (typeof f == "number" ? f : 2e3)
    } : null, o = {
      placeholderPrefix: k(w + "P:"),
      segmentPrefix: k(w + "S:"),
      boundaryPrefix: k(w + "B:"),
      startInlineScript: v,
      startInlineStyle: E,
      preamble: Dn(),
      externalRuntimeScript: null,
      bootstrapChunks: F,
      importMapChunks: P,
      onHeaders: o,
      headers: a,
      resets: {
        font: {},
        dns: {},
        connect: {
          default: {},
          anonymous: {},
          credentials: {}
        },
        image: {},
        style: {}
      },
      charsetChunks: [],
      viewportChunks: [],
      hoistableChunks: [],
      preconnects: /* @__PURE__ */ new Set(),
      fontPreloads: /* @__PURE__ */ new Set(),
      highImagePreloads: /* @__PURE__ */ new Set(),
      styles: /* @__PURE__ */ new Map(),
      bootstrapScripts: /* @__PURE__ */ new Set(),
      scripts: /* @__PURE__ */ new Set(),
      bulkPreloads: /* @__PURE__ */ new Set(),
      preloads: {
        images: /* @__PURE__ */ new Map(),
        stylesheets: /* @__PURE__ */ new Map(),
        scripts: /* @__PURE__ */ new Map(),
        moduleScripts: /* @__PURE__ */ new Map()
      },
      nonce: {
        script: i,
        style: R
      },
      hoistableState: null,
      stylesToHoist: !1
    }, X !== void 0) for (a = 0; a < X.length; a++) w = X[a], R = v = void 0, E = {
      rel: "preload",
      as: "script",
      fetchPriority: "low",
      nonce: t
    }, typeof w == "string" ? E.href = f = w : (E.href = f = w.src, E.integrity = R = typeof w.integrity == "string" ? w.integrity : void 0, E.crossOrigin = v = typeof w == "string" || w.crossOrigin == null ? void 0 : w.crossOrigin === "use-credentials" ? "use-credentials" : ""), w = n, P = f, w.scriptResources[P] = null, w.moduleScriptResources[P] = null, w = [], ce(w, E), o.bootstrapScripts.add(w), F.push(Fe, G(j(f)), Jn), i && F.push(it, G(j(i)), Jn), typeof R == "string" && F.push(jn, G(j(R)), Jn), typeof v == "string" && F.push(Vt, G(j(v)), Jn), ci(F, n), F.push(It);
    if (Q !== void 0) for (t = 0; t < Q.length; t++) R = Q[t], f = a = void 0, v = {
      rel: "modulepreload",
      fetchPriority: "low",
      nonce: i
    }, typeof R == "string" ? v.href = X = R : (v.href = X = R.src, v.integrity = f = typeof R.integrity == "string" ? R.integrity : void 0, v.crossOrigin = a = typeof R == "string" || R.crossOrigin == null ? void 0 : R.crossOrigin === "use-credentials" ? "use-credentials" : ""), R = n, E = X, R.scriptResources[E] = null, R.moduleScriptResources[E] = null, R = [], ce(R, v), o.bootstrapScripts.add(R), F.push(Zl, G(j(X)), Jn), i && F.push(it, G(j(i)), Jn), typeof f == "string" && F.push(jn, G(j(f)), Jn), typeof a == "string" && F.push(Vt, G(j(a)), Jn), ci(F, n), F.push(It);
    return o;
  }
  function Ql(n, t, i, a, o) {
    return {
      idPrefix: n === void 0 ? "" : n,
      nextFormID: 0,
      streamingFormat: 0,
      bootstrapScriptContent: i,
      bootstrapScripts: a,
      bootstrapModules: o,
      instructions: 0,
      hasBody: !1,
      hasHtml: !1,
      unknownResources: {},
      dnsResources: {},
      connectResources: {
        default: {},
        anonymous: {},
        credentials: {}
      },
      imageResources: {},
      styleResources: {},
      scriptResources: {},
      moduleUnknownResources: {},
      moduleScriptResources: {}
    };
  }
  function Dn() {
    return {
      htmlChunks: null,
      headChunks: null,
      bodyChunks: null
    };
  }
  function le(n, t, i, a) {
    return {
      insertionMode: n,
      selectedValue: t,
      tagScope: i,
      viewTransition: a
    };
  }
  function Tl(n) {
    return le(n === "http://www.w3.org/2000/svg" ? 4 : n === "http://www.w3.org/1998/Math/MathML" ? 5 : 0, null, 0, null);
  }
  function rt(n, t, i) {
    var a = n.tagScope & -25;
    switch (t) {
      case "noscript":
        return le(2, null, a | 1, null);
      case "select":
        return le(2, i.value != null ? i.value : i.defaultValue, a, null);
      case "svg":
        return le(4, null, a, null);
      case "picture":
        return le(2, null, a | 2, null);
      case "math":
        return le(5, null, a, null);
      case "foreignObject":
        return le(2, null, a, null);
      case "table":
        return le(6, null, a, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return le(7, null, a, null);
      case "colgroup":
        return le(9, null, a, null);
      case "tr":
        return le(8, null, a, null);
      case "head":
        if (2 > n.insertionMode) return le(3, null, a, null);
        break;
      case "html":
        if (n.insertionMode === 0) return le(1, null, a, null);
    }
    return 6 <= n.insertionMode || 2 > n.insertionMode ? le(2, null, a, null) : n.tagScope !== a ? le(n.insertionMode, n.selectedValue, a, null) : n;
  }
  function xl(n) {
    return n === null ? null : {
      update: n.update,
      enter: "none",
      exit: "none",
      share: n.update,
      name: n.autoName,
      autoName: n.autoName,
      nameIdx: 0
    };
  }
  function pt(n, t) {
    return t.tagScope & 32 && (n.instructions |= 128), le(t.insertionMode, t.selectedValue, t.tagScope | 12, xl(t.viewTransition));
  }
  function qt(n, t) {
    n = xl(t.viewTransition);
    var i = t.tagScope | 16;
    return n !== null && n.share !== "none" && (i |= 64), le(t.insertionMode, t.selectedValue, i, n);
  }
  var $e = k("<!-- -->");
  function Ia(n, t, i, a) {
    return t === "" ? a : (a && n.push($e), n.push(G(j(t))), !0);
  }
  var Aa = /* @__PURE__ */ new Map(), wc = k(' style="'), _a = k(":"), Vl = k(";");
  function Kl(n, t) {
    if (typeof t != "object") throw Error(s(62));
    var i = !0, a;
    for (a in t) if (rn.call(t, a)) {
      var o = t[a];
      if (o != null && typeof o != "boolean" && o !== "") {
        if (a.indexOf("--") === 0) {
          var f = G(j(a));
          o = G(j(("" + o).trim()));
        } else f = Aa.get(a), f === void 0 && (f = k(j(a.replace(Ne, "-$1").toLowerCase().replace(De, "-ms-"))), Aa.set(a, f)), o = typeof o == "number" ? o === 0 || q.has(a) ? G("" + o) : G(o + "px") : G(j(("" + o).trim()));
        i ? (i = !1, n.push(wc, f, _a, o)) : n.push(Vl, f, _a, o);
      }
    }
    i || n.push(Jn);
  }
  var de = k(" "), Xe = k('="'), Jn = k('"'), Li = k('=""');
  function Be(n, t, i) {
    i && typeof i != "function" && typeof i != "symbol" && n.push(de, G(t), Li);
  }
  function Qn(n, t, i) {
    typeof i != "function" && typeof i != "symbol" && typeof i != "boolean" && n.push(de, G(t), Xe, G(j(i)), Jn);
  }
  var Pa = k(j("javascript:throw new Error('React form unexpectedly submitted.')")), ka = k('<input type="hidden"');
  function Cr(n, t) {
    this.push(ka), Oa(n), Qn(this, "name", t), Qn(this, "value", n), this.push(ql);
  }
  function Oa(n) {
    if (typeof n != "string") throw Error(s(480));
  }
  function pl(n, t) {
    if (typeof t.$$FORM_ACTION == "function") {
      var i = n.nextFormID++;
      n = n.idPrefix + i;
      try {
        var a = t.$$FORM_ACTION(n);
        return a && a.data?.forEach(Oa), a;
      } catch (o) {
        if (typeof o == "object" && o !== null && typeof o.then == "function") throw o;
      }
    }
    return null;
  }
  function La(n, t, i, a, o, f, v, R) {
    var E = null;
    if (typeof a == "function") {
      var w = pl(t, a);
      w !== null ? (R = w.name, a = w.action || "", o = w.encType, f = w.method, v = w.target, E = w.data) : (n.push(de, G("formAction"), Xe, Pa, Jn), v = f = o = a = R = null, Da(t, i));
    }
    return R != null && Pn(n, "name", R), a != null && Pn(n, "formAction", a), o != null && Pn(n, "formEncType", o), f != null && Pn(n, "formMethod", f), v != null && Pn(n, "formTarget", v), E;
  }
  function Pn(n, t, i) {
    switch (t) {
      case "className":
        Qn(n, "class", i);
        break;
      case "tabIndex":
        Qn(n, "tabindex", i);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        Qn(n, t, i);
        break;
      case "style":
        Kl(n, i);
        break;
      case "src":
      case "href":
        if (i === "") break;
      case "action":
      case "formAction":
        if (i == null || typeof i == "function" || typeof i == "symbol" || typeof i == "boolean") break;
        i = me("" + i), n.push(de, G(t), Xe, G(j(i)), Jn);
        break;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "ref":
        break;
      case "autoFocus":
      case "multiple":
      case "muted":
        Be(n, t.toLowerCase(), i);
        break;
      case "xlinkHref":
        if (typeof i == "function" || typeof i == "symbol" || typeof i == "boolean") break;
        i = me("" + i), n.push(de, G("xlink:href"), Xe, G(j(i)), Jn);
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        typeof i != "function" && typeof i != "symbol" && n.push(de, G(t), Xe, G(j(i)), Jn);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        i && typeof i != "function" && typeof i != "symbol" && n.push(de, G(t), Li);
        break;
      case "capture":
      case "download":
        i === !0 ? n.push(de, G(t), Li) : i !== !1 && typeof i != "function" && typeof i != "symbol" && n.push(de, G(t), Xe, G(j(i)), Jn);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        typeof i != "function" && typeof i != "symbol" && !isNaN(i) && 1 <= i && n.push(de, G(t), Xe, G(j(i)), Jn);
        break;
      case "rowSpan":
      case "start":
        typeof i == "function" || typeof i == "symbol" || isNaN(i) || n.push(de, G(t), Xe, G(j(i)), Jn);
        break;
      case "xlinkActuate":
        Qn(n, "xlink:actuate", i);
        break;
      case "xlinkArcrole":
        Qn(n, "xlink:arcrole", i);
        break;
      case "xlinkRole":
        Qn(n, "xlink:role", i);
        break;
      case "xlinkShow":
        Qn(n, "xlink:show", i);
        break;
      case "xlinkTitle":
        Qn(n, "xlink:title", i);
        break;
      case "xlinkType":
        Qn(n, "xlink:type", i);
        break;
      case "xmlBase":
        Qn(n, "xml:base", i);
        break;
      case "xmlLang":
        Qn(n, "xml:lang", i);
        break;
      case "xmlSpace":
        Qn(n, "xml:space", i);
        break;
      default:
        if ((!(2 < t.length) || t[0] !== "o" && t[0] !== "O" || t[1] !== "n" && t[1] !== "N") && (t = tn.get(t) || t, he(t))) {
          switch (typeof i) {
            case "function":
            case "symbol":
              return;
            case "boolean":
              var a = t.toLowerCase().slice(0, 5);
              if (a !== "data-" && a !== "aria-") return;
          }
          n.push(de, G(t), Xe, G(j(i)), Jn);
        }
    }
  }
  var zn = k(">"), ql = k("/>");
  function ze(n, t, i) {
    if (t != null) {
      if (i != null) throw Error(s(60));
      if (typeof t != "object" || !("__html" in t)) throw Error(s(61));
      t = t.__html, t != null && n.push(G("" + t));
    }
  }
  function Cc(n) {
    var t = "";
    return g.Children.forEach(n, function(i) {
      i != null && (t += i);
    }), t;
  }
  var Rr = k(' selected=""'), Na = k(`addEventListener("submit",function(a){if(!a.defaultPrevented){var c=a.target,d=a.submitter,e=c.action,b=d;if(d){var f=d.getAttribute("formAction");null!=f&&(e=f,b=null)}"javascript:throw new Error('React form unexpectedly submitted.')"===e&&(a.preventDefault(),b?(a=document.createElement("input"),a.name=b.name,a.value=b.value,b.parentNode.insertBefore(a,b),b=new FormData(c),a.parentNode.removeChild(a)):b=new FormData(c),a=c.ownerDocument||c,(a.$$reactFormReplay=a.$$reactFormReplay||[]).push(c,d,b))}});`);
  function Da(n, t) {
    if ((n.instructions & 16) === 0) {
      n.instructions |= 16;
      var i = t.preamble, a = t.bootstrapChunks;
      (i.htmlChunks || i.headChunks) && a.length === 0 ? (a.push(t.startInlineScript), ci(a, n), a.push(zn, Na, Tn)) : a.unshift(t.startInlineScript, zn, Na, Tn);
    }
  }
  var Rc = k("<!--F!-->"), jl = k("<!--F-->");
  function ce(n, t) {
    n.push(ie("link"));
    for (var i in t) if (rn.call(t, i)) {
      var a = t[i];
      if (a != null) switch (i) {
        case "children":
        case "dangerouslySetInnerHTML":
          throw Error(s(399, "link"));
        default:
          Pn(n, i, a);
      }
    }
    return n.push(ql), null;
  }
  var Ni = /(<\/|<)(s)(tyle)/gi;
  function Di(n, t, i, a) {
    return "" + t + (i === "s" ? "\\73 " : "\\53 ") + a;
  }
  function Pt(n, t, i) {
    n.push(ie(i));
    for (var a in t) if (rn.call(t, a)) {
      var o = t[a];
      if (o != null) switch (a) {
        case "children":
        case "dangerouslySetInnerHTML":
          throw Error(s(399, i));
        default:
          Pn(n, a, o);
      }
    }
    return n.push(ql), null;
  }
  function mi(n, t) {
    n.push(ie("title"));
    var i = null, a = null, o;
    for (o in t) if (rn.call(t, o)) {
      var f = t[o];
      if (f != null) switch (o) {
        case "children":
          i = f;
          break;
        case "dangerouslySetInnerHTML":
          a = f;
          break;
        default:
          Pn(n, o, f);
      }
    }
    return n.push(zn), t = Array.isArray(i) ? 2 > i.length ? i[0] : null : i, typeof t != "function" && typeof t != "symbol" && t !== null && t !== void 0 && n.push(G(j("" + t))), ze(n, a, i), n.push(Ot("title")), null;
  }
  var Sc = k("<!--head-->"), Mc = k("<!--body-->"), wl = k("<!--html-->");
  function Bi(n, t) {
    n.push(ie("script"));
    var i = null, a = null, o;
    for (o in t) if (rn.call(t, o)) {
      var f = t[o];
      if (f != null) switch (o) {
        case "children":
          i = f;
          break;
        case "dangerouslySetInnerHTML":
          a = f;
          break;
        default:
          Pn(n, o, f);
      }
    }
    return n.push(zn), ze(n, a, i), typeof i == "string" && n.push(G(("" + i).replace(yl, _t))), n.push(Ot("script")), null;
  }
  function zi(n, t, i) {
    n.push(ie(i));
    var a = i = null, o;
    for (o in t) if (rn.call(t, o)) {
      var f = t[o];
      if (f != null) switch (o) {
        case "children":
          i = f;
          break;
        case "dangerouslySetInnerHTML":
          a = f;
          break;
        default:
          Pn(n, o, f);
      }
    }
    return n.push(zn), ze(n, a, i), i;
  }
  function kt(n, t, i) {
    n.push(ie(i));
    var a = i = null, o;
    for (o in t) if (rn.call(t, o)) {
      var f = t[o];
      if (f != null) switch (o) {
        case "children":
          i = f;
          break;
        case "dangerouslySetInnerHTML":
          a = f;
          break;
        default:
          Pn(n, o, f);
      }
    }
    return n.push(zn), ze(n, a, i), typeof i == "string" ? (n.push(G(j(i))), null) : i;
  }
  var Sr = k(`
`), Fc = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $l = /* @__PURE__ */ new Map();
  function ie(n) {
    var t = $l.get(n);
    if (t === void 0) {
      if (!Fc.test(n)) throw Error(s(65, n));
      t = k("<" + n), $l.set(n, t);
    }
    return t;
  }
  var jt = k("<!DOCTYPE html>");
  function Hi(n, t, i, a, o, f, v, R, E) {
    switch (t) {
      case "div":
      case "span":
      case "svg":
      case "path":
        break;
      case "a":
        n.push(ie("a"));
        var w = null, F = null, P;
        for (P in i) if (rn.call(i, P)) {
          var X = i[P];
          if (X != null) switch (P) {
            case "children":
              w = X;
              break;
            case "dangerouslySetInnerHTML":
              F = X;
              break;
            case "href":
              X === "" ? Qn(n, "href", "") : Pn(n, P, X);
              break;
            default:
              Pn(n, P, X);
          }
        }
        if (n.push(zn), ze(n, F, w), typeof w == "string") {
          n.push(G(j(w)));
          var Q = null;
        } else Q = w;
        return Q;
      case "g":
      case "p":
      case "li":
        break;
      case "select":
        n.push(ie("select"));
        var Cn = null, vn = null, yn;
        for (yn in i) if (rn.call(i, yn)) {
          var Hn = i[yn];
          if (Hn != null) switch (yn) {
            case "children":
              Cn = Hn;
              break;
            case "dangerouslySetInnerHTML":
              vn = Hn;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              Pn(n, yn, Hn);
          }
        }
        return n.push(zn), ze(n, vn, Cn), Cn;
      case "option":
        var Ln = R.selectedValue;
        n.push(ie("option"));
        var ye = null, Oe = null, qe = null, an = null, Se;
        for (Se in i) if (rn.call(i, Se)) {
          var pn = i[Se];
          if (pn != null) switch (Se) {
            case "children":
              ye = pn;
              break;
            case "selected":
              qe = pn;
              break;
            case "dangerouslySetInnerHTML":
              an = pn;
              break;
            case "value":
              Oe = pn;
            default:
              Pn(n, Se, pn);
          }
        }
        if (Ln != null) {
          var _e = Oe !== null ? "" + Oe : Cc(ye);
          if (ln(Ln)) {
            for (var Ct = 0; Ct < Ln.length; Ct++) if ("" + Ln[Ct] === _e) {
              n.push(Rr);
              break;
            }
          } else "" + Ln === _e && n.push(Rr);
        } else qe && n.push(Rr);
        return n.push(zn), ze(n, an, ye), ye;
      case "textarea":
        n.push(ie("textarea"));
        var qn = null, Jt = null, ut = null, Ee;
        for (Ee in i) if (rn.call(i, Ee)) {
          var je = i[Ee];
          if (je != null) switch (Ee) {
            case "children":
              ut = je;
              break;
            case "value":
              qn = je;
              break;
            case "defaultValue":
              Jt = je;
              break;
            case "dangerouslySetInnerHTML":
              throw Error(s(91));
            default:
              Pn(n, Ee, je);
          }
        }
        if (qn === null && Jt !== null && (qn = Jt), n.push(zn), ut != null) {
          if (qn != null) throw Error(s(92));
          if (ln(ut)) {
            if (1 < ut.length) throw Error(s(93));
            qn = "" + ut[0];
          }
          qn = "" + ut;
        }
        return typeof qn == "string" && qn[0] === `
` && n.push(Sr), qn !== null && n.push(G(j("" + qn))), null;
      case "input":
        n.push(ie("input"));
        var Ci = null, Ri = null, gl = null, Si = null, ta = null, Qt = null, Gl = null, Yc = null, Xc = null, la;
        for (la in i) if (rn.call(i, la)) {
          var Rt = i[la];
          if (Rt != null) switch (la) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(s(399, "input"));
            case "name":
              Ci = Rt;
              break;
            case "formAction":
              Ri = Rt;
              break;
            case "formEncType":
              gl = Rt;
              break;
            case "formMethod":
              Si = Rt;
              break;
            case "formTarget":
              ta = Rt;
              break;
            case "defaultChecked":
              Xc = Rt;
              break;
            case "defaultValue":
              Gl = Rt;
              break;
            case "checked":
              Yc = Rt;
              break;
            case "value":
              Qt = Rt;
              break;
            default:
              Pn(n, la, Rt);
          }
        }
        var yu = La(n, a, o, Ri, gl, Si, ta, Ci);
        return Yc !== null ? Be(n, "checked", Yc) : Xc !== null && Be(n, "checked", Xc), Qt !== null ? Pn(n, "value", Qt) : Gl !== null && Pn(n, "value", Gl), n.push(ql), yu?.forEach(Cr, n), null;
      case "button":
        n.push(ie("button"));
        var ia = null, Ro = null, So = null, Mo = null, Fo = null, Io = null, Ao = null, ra;
        for (ra in i) if (rn.call(i, ra)) {
          var vl = i[ra];
          if (vl != null) switch (ra) {
            case "children":
              ia = vl;
              break;
            case "dangerouslySetInnerHTML":
              Ro = vl;
              break;
            case "name":
              So = vl;
              break;
            case "formAction":
              Mo = vl;
              break;
            case "formEncType":
              Fo = vl;
              break;
            case "formMethod":
              Io = vl;
              break;
            case "formTarget":
              Ao = vl;
              break;
            default:
              Pn(n, ra, vl);
          }
        }
        var Eu = La(n, a, o, Mo, Fo, Io, Ao, So);
        if (n.push(zn), Eu?.forEach(Cr, n), ze(n, Ro, ia), typeof ia == "string") {
          n.push(G(j(ia)));
          var _o = null;
        } else _o = ia;
        return _o;
      case "form":
        n.push(ie("form"));
        var aa = null, Po = null, Mi = null, ca = null, oa = null, ua = null, fa;
        for (fa in i) if (rn.call(i, fa)) {
          var Yl = i[fa];
          if (Yl != null) switch (fa) {
            case "children":
              aa = Yl;
              break;
            case "dangerouslySetInnerHTML":
              Po = Yl;
              break;
            case "action":
              Mi = Yl;
              break;
            case "encType":
              ca = Yl;
              break;
            case "method":
              oa = Yl;
              break;
            case "target":
              ua = Yl;
              break;
            default:
              Pn(n, fa, Yl);
          }
        }
        var ko = null, Zc = null;
        if (typeof Mi == "function") {
          var Fi = pl(a, Mi);
          Fi !== null ? (Mi = Fi.action || "", ca = Fi.encType, oa = Fi.method, ua = Fi.target, ko = Fi.data, Zc = Fi.name) : (n.push(de, G("action"), Xe, Pa, Jn), ua = oa = ca = Mi = null, Da(a, o));
        }
        if (Mi != null && Pn(n, "action", Mi), ca != null && Pn(n, "encType", ca), oa != null && Pn(n, "method", oa), ua != null && Pn(n, "target", ua), n.push(zn), Zc !== null && (n.push(ka), Qn(n, "name", Zc), n.push(ql), ko?.forEach(Cr, n)), ze(n, Po, aa), typeof aa == "string") {
          n.push(G(j(aa)));
          var Oo = null;
        } else Oo = aa;
        return Oo;
      case "menuitem":
        n.push(ie("menuitem"));
        for (var lc in i) if (rn.call(i, lc)) {
          var Lo = i[lc];
          if (Lo != null) switch (lc) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(s(400));
            default:
              Pn(n, lc, Lo);
          }
        }
        return n.push(zn), null;
      case "object":
        n.push(ie("object"));
        var sa = null, No = null, ha;
        for (ha in i) if (rn.call(i, ha)) {
          var da = i[ha];
          if (da != null) switch (ha) {
            case "children":
              sa = da;
              break;
            case "dangerouslySetInnerHTML":
              No = da;
              break;
            case "data":
              var Do = me("" + da);
              if (Do === "") break;
              n.push(de, G("data"), Xe, G(j(Do)), Jn);
              break;
            default:
              Pn(n, ha, da);
          }
        }
        if (n.push(zn), ze(n, No, sa), typeof sa == "string") {
          n.push(G(j(sa)));
          var mo = null;
        } else mo = sa;
        return mo;
      case "title":
        var Tu = R.tagScope & 1, xu = R.tagScope & 4;
        if (R.insertionMode === 4 || Tu || i.itemProp != null) var Jc = mi(n, i);
        else xu ? Jc = null : (mi(o.hoistableChunks, i), Jc = void 0);
        return Jc;
      case "link":
        var wu = R.tagScope & 1, Cu = R.tagScope & 4, Ru = i.rel, Xl = i.href, ic = i.precedence;
        if (R.insertionMode === 4 || wu || i.itemProp != null || typeof Ru != "string" || typeof Xl != "string" || Xl === "") {
          ce(n, i);
          var ga = null;
        } else if (i.rel === "stylesheet") if (typeof ic != "string" || i.disabled != null || i.onLoad || i.onError) ga = ce(n, i);
        else {
          var vr = o.styles.get(ic), rc = a.styleResources.hasOwnProperty(Xl) ? a.styleResources[Xl] : void 0;
          if (rc !== null) {
            a.styleResources[Xl] = null, vr || (vr = {
              precedence: G(j(ic)),
              rules: [],
              hrefs: [],
              sheets: /* @__PURE__ */ new Map()
            }, o.styles.set(ic, vr));
            var ac = {
              state: 0,
              props: te({}, i, {
                "data-precedence": i.precedence,
                precedence: null
              })
            };
            if (rc) {
              rc.length === 2 && tl(ac.props, rc);
              var Qc = o.preloads.stylesheets.get(Xl);
              Qc && 0 < Qc.length ? Qc.length = 0 : ac.state = 1;
            }
            vr.sheets.set(Xl, ac), v && v.stylesheets.add(ac);
          } else if (vr) {
            var Bo = vr.sheets.get(Xl);
            Bo && v && v.stylesheets.add(Bo);
          }
          E && n.push($e), ga = null;
        }
        else i.onLoad || i.onError ? ga = ce(n, i) : (E && n.push($e), ga = Cu ? null : ce(o.hoistableChunks, i));
        return ga;
      case "script":
        var Su = R.tagScope & 1, Vc = i.async;
        if (typeof i.src != "string" || !i.src || !Vc || typeof Vc == "function" || typeof Vc == "symbol" || i.onLoad || i.onError || R.insertionMode === 4 || Su || i.itemProp != null) var zo = Bi(n, i);
        else {
          var cc = i.src;
          if (i.type === "module")
            var oc = a.moduleScriptResources, Ho = o.preloads.moduleScripts;
          else oc = a.scriptResources, Ho = o.preloads.scripts;
          var uc = oc.hasOwnProperty(cc) ? oc[cc] : void 0;
          if (uc !== null) {
            oc[cc] = null;
            var Kc = i;
            if (uc) {
              uc.length === 2 && (Kc = te({}, i), tl(Kc, uc));
              var Wo = Ho.get(cc);
              Wo && (Wo.length = 0);
            }
            var Uo = [];
            o.scripts.add(Uo), Bi(Uo, Kc);
          }
          E && n.push($e), zo = null;
        }
        return zo;
      case "style":
        var Mu = R.tagScope & 1, fc = i.precedence, br = i.href, Fu = i.nonce;
        if (R.insertionMode === 4 || Mu || i.itemProp != null || typeof fc != "string" || typeof br != "string" || br === "") {
          n.push(ie("style"));
          var yr = null, Go = null, va;
          for (va in i) if (rn.call(i, va)) {
            var sc = i[va];
            if (sc != null) switch (va) {
              case "children":
                yr = sc;
                break;
              case "dangerouslySetInnerHTML":
                Go = sc;
                break;
              default:
                Pn(n, va, sc);
            }
          }
          n.push(zn);
          var ba = Array.isArray(yr) ? 2 > yr.length ? yr[0] : null : yr;
          typeof ba != "function" && typeof ba != "symbol" && ba !== null && ba !== void 0 && n.push(G(("" + ba).replace(Ni, Di))), ze(n, Go, yr), n.push(Ot("style"));
          var Yo = null;
        } else {
          var Ii = o.styles.get(fc);
          if ((a.styleResources.hasOwnProperty(br) ? a.styleResources[br] : void 0) !== null) {
            a.styleResources[br] = null, Ii || (Ii = {
              precedence: G(j(fc)),
              rules: [],
              hrefs: [],
              sheets: /* @__PURE__ */ new Map()
            }, o.styles.set(fc, Ii));
            var Xo = o.nonce.style;
            if (!Xo || Xo === Fu) {
              Ii.hrefs.push(G(j(br)));
              var Zo = Ii.rules, Er = null, Jo = null, hc;
              for (hc in i) if (rn.call(i, hc)) {
                var pc = i[hc];
                if (pc != null) switch (hc) {
                  case "children":
                    Er = pc;
                    break;
                  case "dangerouslySetInnerHTML":
                    Jo = pc;
                }
              }
              var ya = Array.isArray(Er) ? 2 > Er.length ? Er[0] : null : Er;
              typeof ya != "function" && typeof ya != "symbol" && ya !== null && ya !== void 0 && Zo.push(G(("" + ya).replace(Ni, Di))), ze(Zo, Jo, Er);
            }
          }
          Ii && v && v.styles.add(Ii), E && n.push($e), Yo = void 0;
        }
        return Yo;
      case "meta":
        var Iu = R.tagScope & 1, Au = R.tagScope & 4;
        if (R.insertionMode === 4 || Iu || i.itemProp != null) var Qo = Pt(n, i, "meta");
        else E && n.push($e), Qo = Au ? null : typeof i.charSet == "string" ? Pt(o.charsetChunks, i, "meta") : i.name === "viewport" ? Pt(o.viewportChunks, i, "meta") : Pt(o.hoistableChunks, i, "meta");
        return Qo;
      case "listing":
      case "pre":
        n.push(ie(t));
        var Ea = null, Ta = null, xa;
        for (xa in i) if (rn.call(i, xa)) {
          var dc = i[xa];
          if (dc != null) switch (xa) {
            case "children":
              Ea = dc;
              break;
            case "dangerouslySetInnerHTML":
              Ta = dc;
              break;
            default:
              Pn(n, xa, dc);
          }
        }
        if (n.push(zn), Ta != null) {
          if (Ea != null) throw Error(s(60));
          if (typeof Ta != "object" || !("__html" in Ta)) throw Error(s(61));
          var Ai = Ta.__html;
          Ai != null && (typeof Ai == "string" && 0 < Ai.length && Ai[0] === `
` ? n.push(Sr, G(Ai)) : n.push(G("" + Ai)));
        }
        return typeof Ea == "string" && Ea[0] === `
` && n.push(Sr), Ea;
      case "img":
        var _u = R.tagScope & 3, Le = i.src, Pe = i.srcSet;
        if (!(i.loading === "lazy" || !Le && !Pe || typeof Le != "string" && Le != null || typeof Pe != "string" && Pe != null || i.fetchPriority === "low" || _u) && (typeof Le != "string" || Le[4] !== ":" || Le[0] !== "d" && Le[0] !== "D" || Le[1] !== "a" && Le[1] !== "A" || Le[2] !== "t" && Le[2] !== "T" || Le[3] !== "a" && Le[3] !== "A") && (typeof Pe != "string" || Pe[4] !== ":" || Pe[0] !== "d" && Pe[0] !== "D" || Pe[1] !== "a" && Pe[1] !== "A" || Pe[2] !== "t" && Pe[2] !== "T" || Pe[3] !== "a" && Pe[3] !== "A")) {
          v !== null && R.tagScope & 64 && (v.suspenseyImages = !0);
          var Vo = typeof i.sizes == "string" ? i.sizes : void 0, Tr = Pe ? Pe + `
` + (Vo || "") : Le, qc = o.preloads.images, _i = qc.get(Tr);
          if (_i)
            (i.fetchPriority === "high" || 10 > o.highImagePreloads.size) && (qc.delete(Tr), o.highImagePreloads.add(_i));
          else if (!a.imageResources.hasOwnProperty(Tr)) {
            a.imageResources[Tr] = xe;
            var jc = i.crossOrigin, Ko = typeof jc == "string" ? jc === "use-credentials" ? jc : "" : void 0, Pi = o.headers, $c;
            Pi && 0 < Pi.remainingCapacity && typeof i.srcSet != "string" && (i.fetchPriority === "high" || 500 > Pi.highImagePreloads.length) && ($c = ui(Le, "image", {
              imageSrcSet: i.srcSet,
              imageSizes: i.sizes,
              crossOrigin: Ko,
              integrity: i.integrity,
              nonce: i.nonce,
              type: i.type,
              fetchPriority: i.fetchPriority,
              referrerPolicy: i.refererPolicy
            }), 0 <= (Pi.remainingCapacity -= $c.length + 2)) ? (o.resets.image[Tr] = xe, Pi.highImagePreloads && (Pi.highImagePreloads += ", "), Pi.highImagePreloads += $c) : (_i = [], ce(_i, {
              rel: "preload",
              as: "image",
              href: Pe ? void 0 : Le,
              imageSrcSet: Pe,
              imageSizes: Vo,
              crossOrigin: Ko,
              integrity: i.integrity,
              type: i.type,
              fetchPriority: i.fetchPriority,
              referrerPolicy: i.referrerPolicy
            }), i.fetchPriority === "high" || 10 > o.highImagePreloads.size ? o.highImagePreloads.add(_i) : (o.bulkPreloads.add(_i), qc.set(Tr, _i)));
          }
        }
        return Pt(n, i, "img");
      case "base":
      case "area":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "param":
      case "source":
      case "track":
      case "wbr":
        return Pt(n, i, t);
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        break;
      case "head":
        if (2 > R.insertionMode) {
          var no = f || o.preamble;
          if (no.headChunks) throw Error(s(545, "`<head>`"));
          f !== null && n.push(Sc), no.headChunks = [];
          var po = zi(no.headChunks, i, "head");
        } else po = kt(n, i, "head");
        return po;
      case "body":
        if (2 > R.insertionMode) {
          var eo = f || o.preamble;
          if (eo.bodyChunks) throw Error(s(545, "`<body>`"));
          f !== null && n.push(Mc), eo.bodyChunks = [];
          var qo = zi(eo.bodyChunks, i, "body");
        } else qo = kt(n, i, "body");
        return qo;
      case "html":
        if (R.insertionMode === 0) {
          var to = f || o.preamble;
          if (to.htmlChunks) throw Error(s(545, "`<html>`"));
          f !== null && n.push(wl), to.htmlChunks = [jt];
          var jo = zi(to.htmlChunks, i, "html");
        } else jo = kt(n, i, "html");
        return jo;
      default:
        if (t.indexOf("-") !== -1) {
          n.push(ie(t));
          var lo = null, $o = null, xr;
          for (xr in i) if (rn.call(i, xr)) {
            var St = i[xr];
            if (St != null) {
              var nu = xr;
              switch (xr) {
                case "children":
                  lo = St;
                  break;
                case "dangerouslySetInnerHTML":
                  $o = St;
                  break;
                case "style":
                  Kl(n, St);
                  break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                case "ref":
                  break;
                case "className":
                  nu = "class";
                default:
                  if (he(xr) && typeof St != "function" && typeof St != "symbol" && St !== !1) {
                    if (St === !0) St = "";
                    else if (typeof St == "object") continue;
                    n.push(de, G(nu), Xe, G(j(St)), Jn);
                  }
              }
            }
          }
          return n.push(zn), ze(n, $o, lo), lo;
        }
    }
    return kt(n, i, t);
  }
  var Mr = /* @__PURE__ */ new Map();
  function Ot(n) {
    var t = Mr.get(n);
    return t === void 0 && (t = k("</" + n + ">"), Mr.set(n, t)), t;
  }
  function Fr(n, t) {
    n = n.preamble, n.htmlChunks === null && t.htmlChunks && (n.htmlChunks = t.htmlChunks), n.headChunks === null && t.headChunks && (n.headChunks = t.headChunks), n.bodyChunks === null && t.bodyChunks && (n.bodyChunks = t.bodyChunks);
  }
  function Ir(n, t) {
    t = t.bootstrapChunks;
    for (var i = 0; i < t.length - 1; i++) _(n, t[i]);
    return i < t.length ? (i = t[i], t.length = 0, V(n, i)) : !0;
  }
  var Lt = k("requestAnimationFrame(function(){$RT=performance.now()});"), ma = k('<template id="'), Ic = k('"></template>'), $t = k("<!--&-->"), Wi = k("<!--/&-->"), Ac = k("<!--$-->"), _c = k('<!--$?--><template id="'), Pc = k('"></template>'), Ie = k("<!--$!-->"), He = k("<!--/$-->"), kc = k("<template"), Ui = k('"'), Gi = k(' data-dgst="');
  k(' data-msg="'), k(' data-stck="'), k(' data-cstck="');
  var Oc = k("></template>");
  function Ba(n, t, i) {
    if (_(n, _c), i === null) throw Error(s(395));
    return _(n, t.boundaryPrefix), _(n, G(i.toString(16))), V(n, Pc);
  }
  var st = k('<div hidden id="'), Ar = k('">'), _r = k("</div>"), Pr = k('<svg aria-hidden="true" style="display:none" id="'), Yi = k('">'), mn = k("</svg>"), ni = k('<math aria-hidden="true" style="display:none" id="'), Xi = k('">'), ei = k("</math>"), ti = k('<table hidden id="'), li = k('">'), Zi = k("</table>"), Cl = k('<table hidden><tbody id="'), Nt = k('">'), Ji = k("</tbody></table>"), ht = k('<table hidden><tr id="'), za = k('">'), kr = k("</tr></table>"), Rl = k('<table hidden><colgroup id="'), ii = k('">'), Ha = k("</colgroup></table>");
  function Wa(n, t, i, a) {
    switch (i.insertionMode) {
      case 0:
      case 1:
      case 3:
      case 2:
        return _(n, st), _(n, t.segmentPrefix), _(n, G(a.toString(16))), V(n, Ar);
      case 4:
        return _(n, Pr), _(n, t.segmentPrefix), _(n, G(a.toString(16))), V(n, Yi);
      case 5:
        return _(n, ni), _(n, t.segmentPrefix), _(n, G(a.toString(16))), V(n, Xi);
      case 6:
        return _(n, ti), _(n, t.segmentPrefix), _(n, G(a.toString(16))), V(n, li);
      case 7:
        return _(n, Cl), _(n, t.segmentPrefix), _(n, G(a.toString(16))), V(n, Nt);
      case 8:
        return _(n, ht), _(n, t.segmentPrefix), _(n, G(a.toString(16))), V(n, za);
      case 9:
        return _(n, Rl), _(n, t.segmentPrefix), _(n, G(a.toString(16))), V(n, ii);
      default:
        throw Error(s(397));
    }
  }
  function Ua(n, t) {
    switch (t.insertionMode) {
      case 0:
      case 1:
      case 3:
      case 2:
        return V(n, _r);
      case 4:
        return V(n, mn);
      case 5:
        return V(n, ei);
      case 6:
        return V(n, Zi);
      case 7:
        return V(n, Ji);
      case 8:
        return V(n, kr);
      case 9:
        return V(n, Ha);
      default:
        throw Error(s(397));
    }
  }
  var Lc = k('$RS=function(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), Nc = k('$RS("'), Dc = k('","'), mc = k('")<\/script>');
  k('<template data-rsi="" data-sid="'), k('" data-pid="');
  var Or = k(`$RB=[];$RV=function(a){$RT=performance.now();for(var b=0;b<a.length;b+=2){var c=a[b],e=a[b+1];null!==e.parentNode&&e.parentNode.removeChild(e);var f=c.parentNode;if(f){var g=c.previousSibling,h=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d||"/&"===d)if(0===h)break;else h--;else"$"!==d&&"$?"!==d&&"$~"!==d&&"$!"!==d&&"&"!==d||h++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;e.firstChild;)f.insertBefore(e.firstChild,c);g.data="$";g._reactRetry&&requestAnimationFrame(g._reactRetry)}}a.length=0};
$RC=function(a,b){if(b=document.getElementById(b))(a=document.getElementById(a))?(a.previousSibling.data="$~",$RB.push(a,b),2===$RB.length&&("number"!==typeof $RT?requestAnimationFrame($RV.bind(null,$RB)):(a=performance.now(),setTimeout($RV.bind(null,$RB),2300>a&&2E3<a?2300-a:$RT+300-a)))):b.parentNode.removeChild(b)};`);
  G(`$RV=function(A,g){function k(a,b){var e=a.getAttribute(b);e&&(b=a.style,l.push(a,b.viewTransitionName,b.viewTransitionClass),"auto"!==e&&(b.viewTransitionClass=e),(a=a.getAttribute("vt-name"))||(a="_T_"+K++ +"_"),b.viewTransitionName=a,B=!0)}var B=!1,K=0,l=[];try{var f=document.__reactViewTransition;if(f){f.finished.finally($RV.bind(null,g));return}var m=new Map;for(f=1;f<g.length;f+=2)for(var h=g[f].querySelectorAll("[vt-share]"),d=0;d<h.length;d++){var c=h[d];m.set(c.getAttribute("vt-name"),c)}var u=[];for(h=0;h<g.length;h+=2){var C=g[h],x=C.parentNode;if(x){var v=x.getBoundingClientRect();if(v.left||v.top||v.width||v.height){c=C;for(f=0;c;){if(8===c.nodeType){var r=c.data;if("/$"===r)if(0===f)break;else f--;else"$"!==r&&"$?"!==r&&"$~"!==r&&"$!"!==r||f++}else if(1===c.nodeType){d=c;var D=d.getAttribute("vt-name"),y=m.get(D);k(d,y?"vt-share":"vt-exit");y&&(k(y,"vt-share"),m.set(D,null));var E=d.querySelectorAll("[vt-share]");for(d=0;d<E.length;d++){var F=E[d],G=F.getAttribute("vt-name"),
H=m.get(G);H&&(k(F,"vt-share"),k(H,"vt-share"),m.set(G,null))}}c=c.nextSibling}for(var I=g[h+1],t=I.firstElementChild;t;)null!==m.get(t.getAttribute("vt-name"))&&k(t,"vt-enter"),t=t.nextElementSibling;c=x;do for(var n=c.firstElementChild;n;){var J=n.getAttribute("vt-update");J&&"none"!==J&&!l.includes(n)&&k(n,"vt-update");n=n.nextElementSibling}while((c=c.parentNode)&&1===c.nodeType&&"none"!==c.getAttribute("vt-update"));u.push.apply(u,I.querySelectorAll('img[src]:not([loading="lazy"])'))}}}if(B){var z=
document.__reactViewTransition=document.startViewTransition({update:function(){A(g);for(var a=[document.documentElement.clientHeight,document.fonts.ready],b={},e=0;e<u.length;b={g:b.g},e++)if(b.g=u[e],!b.g.complete){var p=b.g.getBoundingClientRect();0<p.bottom&&0<p.right&&p.top<window.innerHeight&&p.left<window.innerWidth&&(p=new Promise(function(w){return function(q){w.g.addEventListener("load",q);w.g.addEventListener("error",q)}}(b)),a.push(p))}return Promise.race([Promise.all(a),new Promise(function(w){var q=
performance.now();setTimeout(w,2300>q&&2E3<q?2300-q:500)})])},types:[]});z.ready.finally(function(){for(var a=l.length-3;0<=a;a-=3){var b=l[a],e=b.style;e.viewTransitionName=l[a+1];e.viewTransitionClass=l[a+1];""===b.getAttribute("style")&&b.removeAttribute("style")}});z.finished.finally(function(){document.__reactViewTransition===z&&(document.__reactViewTransition=null)});$RB=[];return}}catch(a){}A(g)}.bind(null,$RV);`);
  var Ga = k('$RC("'), Bc = k(`$RM=new Map;$RR=function(n,w,p){function u(q){this._p=null;q()}for(var r=new Map,t=document,h,b,e=t.querySelectorAll("link[data-precedence],style[data-precedence]"),v=[],k=0;b=e[k++];)"not all"===b.getAttribute("media")?v.push(b):("LINK"===b.tagName&&$RM.set(b.getAttribute("href"),b),r.set(b.dataset.precedence,h=b));e=0;b=[];var l,a;for(k=!0;;){if(k){var f=p[e++];if(!f){k=!1;e=0;continue}var c=!1,m=0;var d=f[m++];if(a=$RM.get(d)){var g=a._p;c=!0}else{a=t.createElement("link");a.href=d;a.rel=
"stylesheet";for(a.dataset.precedence=l=f[m++];g=f[m++];)a.setAttribute(g,f[m++]);g=a._p=new Promise(function(q,x){a.onload=u.bind(a,q);a.onerror=u.bind(a,x)});$RM.set(d,a)}d=a.getAttribute("media");!g||d&&!matchMedia(d).matches||b.push(g);if(c)continue}else{a=v[e++];if(!a)break;l=a.getAttribute("data-precedence");a.removeAttribute("media")}c=r.get(l)||h;c===h&&(h=a);r.set(l,a);c?c.parentNode.insertBefore(a,c.nextSibling):(c=t.head,c.insertBefore(a,c.firstChild))}if(p=document.getElementById(n))p.previousSibling.data=
"$~";Promise.all(b).then($RC.bind(null,n,w),$RX.bind(null,n,"CSS failed to load"))};$RR("`), Ya = k('$RR("'), Qi = k('","'), zc = k('",'), Lr = k('"'), Xa = k(")<\/script>");
  k('<template data-rci="" data-bid="'), k('<template data-rri="" data-bid="'), k('" data-sid="'), k('" data-sty="');
  var Sl = k('$RX=function(b,c,d,e,f){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),f&&(a.cstck=f),b._reactRetry&&b._reactRetry())};'), Nr = k('$RX=function(b,c,d,e,f){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),f&&(a.cstck=f),b._reactRetry&&b._reactRetry())};;$RX("'), Vi = k('$RX("'), Za = k('"'), Ml = k(","), Hc = k(")<\/script>");
  k('<template data-rxi="" data-bid="'), k('" data-dgst="'), k('" data-msg="'), k('" data-stck="'), k('" data-cstck="');
  var Wc = /[<\u2028\u2029]/g;
  function Uc(n) {
    return JSON.stringify(n).replace(Wc, function(t) {
      switch (t) {
        case "<":
          return "\\u003c";
        case "\u2028":
          return "\\u2028";
        case "\u2029":
          return "\\u2029";
        default:
          throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
      }
    });
  }
  var ge = /[&><\u2028\u2029]/g;
  function Fl(n) {
    return JSON.stringify(n).replace(ge, function(t) {
      switch (t) {
        case "&":
          return "\\u0026";
        case ">":
          return "\\u003e";
        case "<":
          return "\\u003c";
        case "\u2028":
          return "\\u2028";
        case "\u2029":
          return "\\u2029";
        default:
          throw Error("escapeJSObjectForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
      }
    });
  }
  var Dr = k(' media="not all" data-precedence="'), Ki = k('" data-href="'), Ja = k('">'), nl = k("</style>"), Dt = !1, ri = !0;
  function mt(n) {
    var t = n.rules, i = n.hrefs, a = 0;
    if (i.length) {
      for (_(this, lt.startInlineStyle), _(this, Dr), _(this, n.precedence), _(this, Ki); a < i.length - 1; a++) _(this, i[a]), _(this, Br);
      for (_(this, i[a]), _(this, Ja), a = 0; a < t.length; a++) _(this, t[a]);
      ri = V(this, nl), Dt = !0, t.length = 0, i.length = 0;
    }
  }
  function we(n) {
    return n.state !== 2 ? Dt = !0 : !1;
  }
  function Il(n, t, i) {
    return Dt = !1, ri = !0, lt = i, t.styles.forEach(mt, n), lt = null, t.stylesheets.forEach(we), Dt && (i.stylesToHoist = !0), ri;
  }
  function Bn(n) {
    for (var t = 0; t < n.length; t++) _(this, n[t]);
    n.length = 0;
  }
  var at = [];
  function mr(n) {
    ce(at, n.props);
    for (var t = 0; t < at.length; t++) _(this, at[t]);
    at.length = 0, n.state = 2;
  }
  var ai = k(' data-precedence="'), Qa = k('" data-href="'), Br = k(" "), Va = k('">'), pi = k("</style>");
  function qi(n) {
    var t = 0 < n.sheets.size;
    n.sheets.forEach(mr, this), n.sheets.clear();
    var i = n.rules, a = n.hrefs;
    if (!t || a.length) {
      if (_(this, lt.startInlineStyle), _(this, ai), _(this, n.precedence), n = 0, a.length) {
        for (_(this, Qa); n < a.length - 1; n++) _(this, a[n]), _(this, Br);
        _(this, a[n]);
      }
      for (_(this, Va), n = 0; n < i.length; n++) _(this, i[n]);
      _(this, pi), i.length = 0, a.length = 0;
    }
  }
  function Ze(n) {
    if (n.state === 0) {
      n.state = 1;
      var t = n.props;
      for (ce(at, {
        rel: "preload",
        as: "style",
        href: n.props.href,
        crossOrigin: t.crossOrigin,
        fetchPriority: t.fetchPriority,
        integrity: t.integrity,
        media: t.media,
        hrefLang: t.hrefLang,
        referrerPolicy: t.referrerPolicy
      }), n = 0; n < at.length; n++) _(this, at[n]);
      at.length = 0;
    }
  }
  function zr(n) {
    n.sheets.forEach(Ze, this), n.sheets.clear();
  }
  k('<link rel="expect" href="#'), k('" blocking="render"/>');
  var ji = k(' id="');
  function ci(n, t) {
    (t.instructions & 32) === 0 && (t.instructions |= 32, n.push(ji, G(j("_" + t.idPrefix + "R_")), Jn));
  }
  var $i = k("["), nr = k(",["), er = k(","), tr = k("]");
  function fe(n, t) {
    _(n, $i);
    var i = $i;
    t.stylesheets.forEach(function(a) {
      if (a.state !== 2) if (a.state === 3) _(n, i), _(n, G(Fl("" + a.props.href))), _(n, tr), i = nr;
      else {
        _(n, i);
        var o = a.props["data-precedence"], f = a.props;
        _(n, G(Fl(me("" + a.props.href)))), o = "" + o, _(n, er), _(n, G(Fl(o)));
        for (var v in f) if (rn.call(f, v) && (o = f[v], o != null)) switch (v) {
          case "href":
          case "rel":
          case "precedence":
          case "data-precedence":
            break;
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(s(399, "link"));
          default:
            Gc(n, v, o);
        }
        _(n, tr), i = nr, a.state = 3;
      }
    }), _(n, tr);
  }
  function Gc(n, t, i) {
    var a = t.toLowerCase();
    switch (typeof i) {
      case "function":
      case "symbol":
        return;
    }
    switch (t) {
      case "innerHTML":
      case "dangerouslySetInnerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "style":
      case "ref":
        return;
      case "className":
        a = "class", t = "" + i;
        break;
      case "hidden":
        if (i === !1) return;
        t = "";
        break;
      case "src":
      case "href":
        i = me(i), t = "" + i;
        break;
      default:
        if (2 < t.length && (t[0] === "o" || t[0] === "O") && (t[1] === "n" || t[1] === "N") || !he(t)) return;
        t = "" + i;
    }
    _(n, er), _(n, G(Fl(a))), _(n, er), _(n, G(Fl(t)));
  }
  function el() {
    return {
      styles: /* @__PURE__ */ new Set(),
      stylesheets: /* @__PURE__ */ new Set(),
      suspenseyImages: !1
    };
  }
  function Hr(n) {
    var t = ue || null;
    if (t) {
      var i = t.resumableState, a = t.renderState;
      if (typeof n == "string" && n) {
        if (!i.dnsResources.hasOwnProperty(n)) {
          i.dnsResources[n] = null, i = a.headers;
          var o, f;
          (f = i && 0 < i.remainingCapacity) && (f = (o = "<" + ("" + n).replace(ll, Al) + ">; rel=dns-prefetch", 0 <= (i.remainingCapacity -= o.length + 2))), f ? (a.resets.dns[n] = null, i.preconnects && (i.preconnects += ", "), i.preconnects += o) : (o = [], ce(o, {
            href: n,
            rel: "dns-prefetch"
          }), a.preconnects.add(o));
        }
        wt(t);
      }
    } else Me.D(n);
  }
  function Wr(n, t) {
    var i = ue || null;
    if (i) {
      var a = i.resumableState, o = i.renderState;
      if (typeof n == "string" && n) {
        var f = t === "use-credentials" ? "credentials" : typeof t == "string" ? "anonymous" : "default";
        if (!a.connectResources[f].hasOwnProperty(n)) {
          a.connectResources[f][n] = null, a = o.headers;
          var v, R;
          if (R = a && 0 < a.remainingCapacity) {
            if (R = "<" + ("" + n).replace(ll, Al) + ">; rel=preconnect", typeof t == "string") {
              var E = ("" + t).replace(il, rl);
              R += '; crossorigin="' + E + '"';
            }
            R = (v = R, 0 <= (a.remainingCapacity -= v.length + 2));
          }
          R ? (o.resets.connect[f][n] = null, a.preconnects && (a.preconnects += ", "), a.preconnects += v) : (f = [], ce(f, {
            rel: "preconnect",
            href: n,
            crossOrigin: t
          }), o.preconnects.add(f));
        }
        wt(i);
      }
    } else Me.C(n, t);
  }
  function Ur(n, t, i) {
    var a = ue || null;
    if (a) {
      var o = a.resumableState, f = a.renderState;
      if (t && n) {
        switch (t) {
          case "image":
            if (i)
              var v = i.imageSrcSet, R = i.imageSizes, E = i.fetchPriority;
            var w = v ? v + `
` + (R || "") : n;
            if (o.imageResources.hasOwnProperty(w)) return;
            o.imageResources[w] = xe, o = f.headers;
            var F;
            o && 0 < o.remainingCapacity && typeof v != "string" && E === "high" && (F = ui(n, t, i), 0 <= (o.remainingCapacity -= F.length + 2)) ? (f.resets.image[w] = xe, o.highImagePreloads && (o.highImagePreloads += ", "), o.highImagePreloads += F) : (o = [], ce(o, te({
              rel: "preload",
              href: v ? void 0 : n,
              as: t
            }, i)), E === "high" ? f.highImagePreloads.add(o) : (f.bulkPreloads.add(o), f.preloads.images.set(w, o)));
            break;
          case "style":
            if (o.styleResources.hasOwnProperty(n)) return;
            v = [], ce(v, te({
              rel: "preload",
              href: n,
              as: t
            }, i)), o.styleResources[n] = !i || typeof i.crossOrigin != "string" && typeof i.integrity != "string" ? xe : [i.crossOrigin, i.integrity], f.preloads.stylesheets.set(n, v), f.bulkPreloads.add(v);
            break;
          case "script":
            if (o.scriptResources.hasOwnProperty(n)) return;
            v = [], f.preloads.scripts.set(n, v), f.bulkPreloads.add(v), ce(v, te({
              rel: "preload",
              href: n,
              as: t
            }, i)), o.scriptResources[n] = !i || typeof i.crossOrigin != "string" && typeof i.integrity != "string" ? xe : [i.crossOrigin, i.integrity];
            break;
          default:
            if (o.unknownResources.hasOwnProperty(t)) {
              if (v = o.unknownResources[t], v.hasOwnProperty(n)) return;
            } else v = {}, o.unknownResources[t] = v;
            v[n] = xe, (o = f.headers) && 0 < o.remainingCapacity && t === "font" && (w = ui(n, t, i), 0 <= (o.remainingCapacity -= w.length + 2)) ? (f.resets.font[n] = xe, o.fontPreloads && (o.fontPreloads += ", "), o.fontPreloads += w) : (o = [], n = te({
              rel: "preload",
              href: n,
              as: t
            }, i), ce(o, n), t) === "font" ? f.fontPreloads.add(o) : f.bulkPreloads.add(o);
        }
        wt(a);
      }
    } else Me.L(n, t, i);
  }
  function lr(n, t) {
    var i = ue || null;
    if (i) {
      var a = i.resumableState, o = i.renderState;
      if (n) {
        var f = t && typeof t.as == "string" ? t.as : "script";
        switch (f) {
          case "script":
            if (a.moduleScriptResources.hasOwnProperty(n)) return;
            f = [], a.moduleScriptResources[n] = !t || typeof t.crossOrigin != "string" && typeof t.integrity != "string" ? xe : [t.crossOrigin, t.integrity], o.preloads.moduleScripts.set(n, f);
            break;
          default:
            if (a.moduleUnknownResources.hasOwnProperty(f)) {
              var v = a.unknownResources[f];
              if (v.hasOwnProperty(n)) return;
            } else v = {}, a.moduleUnknownResources[f] = v;
            f = [], v[n] = xe;
        }
        ce(f, te({
          rel: "modulepreload",
          href: n
        }, t)), o.bulkPreloads.add(f), wt(i);
      }
    } else Me.m(n, t);
  }
  function oi(n, t, i) {
    var a = ue || null;
    if (a) {
      var o = a.resumableState, f = a.renderState;
      if (n) {
        t = t || "default";
        var v = f.styles.get(t), R = o.styleResources.hasOwnProperty(n) ? o.styleResources[n] : void 0;
        R !== null && (o.styleResources[n] = null, v || (v = {
          precedence: G(j(t)),
          rules: [],
          hrefs: [],
          sheets: /* @__PURE__ */ new Map()
        }, f.styles.set(t, v)), t = {
          state: 0,
          props: te({
            rel: "stylesheet",
            href: n,
            "data-precedence": t
          }, i)
        }, R && (R.length === 2 && tl(t.props, R), (f = f.preloads.stylesheets.get(n)) && 0 < f.length ? f.length = 0 : t.state = 1), v.sheets.set(n, t), wt(a));
      }
    } else Me.S(n, t, i);
  }
  function Bt(n, t) {
    var i = ue || null;
    if (i) {
      var a = i.resumableState, o = i.renderState;
      if (n) {
        var f = a.scriptResources.hasOwnProperty(n) ? a.scriptResources[n] : void 0;
        f !== null && (a.scriptResources[n] = null, t = te({
          src: n,
          async: !0
        }, t), f && (f.length === 2 && tl(t, f), n = o.preloads.scripts.get(n)) && (n.length = 0), n = [], o.scripts.add(n), Bi(n, t), wt(i));
      }
    } else Me.X(n, t);
  }
  function Ka(n, t) {
    var i = ue || null;
    if (i) {
      var a = i.resumableState, o = i.renderState;
      if (n) {
        var f = a.moduleScriptResources.hasOwnProperty(n) ? a.moduleScriptResources[n] : void 0;
        f !== null && (a.moduleScriptResources[n] = null, t = te({
          src: n,
          type: "module",
          async: !0
        }, t), f && (f.length === 2 && tl(t, f), n = o.preloads.moduleScripts.get(n)) && (n.length = 0), n = [], o.scripts.add(n), Bi(n, t), wt(i));
      }
    } else Me.M(n, t);
  }
  function tl(n, t) {
    n.crossOrigin ?? (n.crossOrigin = t[0]), n.integrity ?? (n.integrity = t[1]);
  }
  function ui(n, t, i) {
    n = ("" + n).replace(ll, Al), t = ("" + t).replace(il, rl), t = "<" + n + '>; rel=preload; as="' + t + '"';
    for (var a in i) rn.call(i, a) && (n = i[a], typeof n == "string" && (t += "; " + a.toLowerCase() + '="' + ("" + n).replace(il, rl) + '"'));
    return t;
  }
  var ll = /[<>\r\n]/g;
  function Al(n) {
    switch (n) {
      case "<":
        return "%3C";
      case ">":
        return "%3E";
      case `
`:
        return "%0A";
      case "\r":
        return "%0D";
      default:
        throw Error("escapeLinkHrefForHeaderContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
    }
  }
  var il = /["';,\r\n]/g;
  function rl(n) {
    switch (n) {
      case '"':
        return "%22";
      case "'":
        return "%27";
      case ";":
        return "%3B";
      case ",":
        return "%2C";
      case `
`:
        return "%0A";
      case "\r":
        return "%0D";
      default:
        throw Error("escapeStringForLinkHeaderQuotedParamValueContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
    }
  }
  function Gr(n) {
    this.styles.add(n);
  }
  function pa(n) {
    this.stylesheets.add(n);
  }
  function al(n, t) {
    t.styles.forEach(Gr, n), t.stylesheets.forEach(pa, n), t.suspenseyImages && (n.suspenseyImages = !0);
  }
  function fi(n) {
    return 0 < n.stylesheets.size || n.suspenseyImages;
  }
  var ir = Function.prototype.bind, cl = /* @__PURE__ */ Symbol.for("react.client.reference");
  function rr(n) {
    if (n == null) return null;
    if (typeof n == "function") return n.$$typeof === cl ? null : n.displayName || n.name || null;
    if (typeof n == "string") return n;
    switch (n) {
      case S:
        return "Fragment";
      case O:
        return "Profiler";
      case M:
        return "StrictMode";
      case z:
        return "Suspense";
      case U:
        return "SuspenseList";
      case H:
        return "Activity";
    }
    if (typeof n == "object") switch (n.$$typeof) {
      case C:
        return "Portal";
      case N:
        return n.displayName || "Context";
      case D:
        return (n._context.displayName || "Context") + ".Consumer";
      case W:
        var t = n.render;
        return n = n.displayName, n || (n = t.displayName || t.name || "", n = n !== "" ? "ForwardRef(" + n + ")" : "ForwardRef"), n;
      case B:
        return t = n.displayName || null, t !== null ? t : rr(n.type) || "Memo";
      case Y:
        t = n._payload, n = n._init;
        try {
          return rr(n(t));
        } catch {
        }
    }
    return null;
  }
  var qa = {}, ct = null;
  function ar(n, t) {
    if (n !== t) {
      n.context._currentValue = n.parentValue, n = n.parent;
      var i = t.parent;
      if (n === null) {
        if (i !== null) throw Error(s(401));
      } else {
        if (i === null) throw Error(s(401));
        ar(n, i);
      }
      t.context._currentValue = t.value;
    }
  }
  function Yr(n) {
    n.context._currentValue = n.parentValue, n = n.parent, n !== null && Yr(n);
  }
  function e(n) {
    var t = n.parent;
    t !== null && e(t), n.context._currentValue = n.value;
  }
  function l(n, t) {
    if (n.context._currentValue = n.parentValue, n = n.parent, n === null) throw Error(s(402));
    n.depth === t.depth ? ar(n, t) : l(n, t);
  }
  function r(n, t) {
    var i = t.parent;
    if (i === null) throw Error(s(402));
    n.depth === i.depth ? ar(n, i) : r(n, i), t.context._currentValue = t.value;
  }
  function c(n) {
    var t = ct;
    t !== n && (t === null ? e(n) : n === null ? Yr(t) : t.depth === n.depth ? ar(t, n) : t.depth > n.depth ? l(t, n) : r(t, n), ct = n);
  }
  var u = {
    enqueueSetState: function(n, t) {
      n = n._reactInternals, n.queue !== null && n.queue.push(t);
    },
    enqueueReplaceState: function(n, t) {
      n = n._reactInternals, n.replace = !0, n.queue = [t];
    },
    enqueueForceUpdate: function() {
    }
  }, d = {
    id: 1,
    overflow: ""
  };
  function y(n, t, i) {
    var a = n.id;
    n = n.overflow;
    var o = 32 - I(a) - 1;
    a &= ~(1 << o), i += 1;
    var f = 32 - I(t) + o;
    if (30 < f) {
      var v = o - o % 5;
      return f = (a & (1 << v) - 1).toString(32), a >>= v, o -= v, {
        id: 1 << 32 - I(t) + o | i << o | a,
        overflow: f + n
      };
    }
    return {
      id: 1 << f | i << o | a,
      overflow: n
    };
  }
  var I = Math.clz32 ? Math.clz32 : m, T = Math.log, A = Math.LN2;
  function m(n) {
    return n >>>= 0, n === 0 ? 32 : 31 - (T(n) / A | 0) | 0;
  }
  function L() {
  }
  var Z = Error(s(460));
  function en(n, t, i) {
    switch (i = n[i], i === void 0 ? n.push(t) : i !== t && (t.then(L, L), t = i), t.status) {
      case "fulfilled":
        return t.value;
      case "rejected":
        throw t.reason;
      default:
        switch (typeof t.status == "string" ? t.then(L, L) : (n = t, n.status = "pending", n.then(function(a) {
          if (t.status === "pending") {
            var o = t;
            o.status = "fulfilled", o.value = a;
          }
        }, function(a) {
          if (t.status === "pending") {
            var o = t;
            o.status = "rejected", o.reason = a;
          }
        })), t.status) {
          case "fulfilled":
            return t.value;
          case "rejected":
            throw t.reason;
        }
        throw xn = t, Z;
    }
  }
  var xn = null;
  function fn() {
    if (xn === null) throw Error(s(459));
    var n = xn;
    return xn = null, n;
  }
  function sn(n, t) {
    return n === t && (n !== 0 || 1 / n === 1 / t) || n !== n && t !== t;
  }
  var un = typeof Object.is == "function" ? Object.is : sn, dn = null, Wn = null, Vn = null, Rn = null, Fn = null, wn = null, ke = !1, Sn = !1, We = 0, kn = 0, re = -1, oe = 0, Un = null, Ae = null, ol = 0;
  function Ue() {
    if (dn === null) throw Error(s(321));
    return dn;
  }
  function si() {
    if (0 < ol) throw Error(s(312));
    return {
      memoizedState: null,
      queue: null,
      next: null
    };
  }
  function _l() {
    return wn === null ? Fn === null ? (ke = !1, Fn = wn = si()) : (ke = !0, wn = Fn) : wn.next === null ? (ke = !1, wn = wn.next = si()) : (ke = !0, wn = wn.next), wn;
  }
  function Ce() {
    var n = Un;
    return Un = null, n;
  }
  function Je() {
    Rn = Vn = Wn = dn = null, Sn = !1, Fn = null, ol = 0, wn = Ae = null;
  }
  function nt(n, t) {
    return typeof t == "function" ? t(n) : t;
  }
  function et(n, t, i) {
    if (dn = Ue(), wn = _l(), ke) {
      var a = wn.queue;
      if (t = a.dispatch, Ae !== null && (i = Ae.get(a), i !== void 0)) {
        Ae.delete(a), a = wn.memoizedState;
        do
          a = n(a, i.action), i = i.next;
        while (i !== null);
        return wn.memoizedState = a, [a, t];
      }
      return [wn.memoizedState, t];
    }
    return n = n === nt ? typeof t == "function" ? t() : t : i !== void 0 ? i(t) : t, wn.memoizedState = n, n = wn.queue = {
      last: null,
      dispatch: null
    }, n = n.dispatch = zt.bind(null, dn, n), [wn.memoizedState, n];
  }
  function dt(n, t) {
    if (dn = Ue(), wn = _l(), t = t === void 0 ? null : t, wn !== null) {
      var i = wn.memoizedState;
      if (i !== null && t !== null) {
        var a = i[1];
        n: if (a === null) a = !1;
        else {
          for (var o = 0; o < a.length && o < t.length; o++) if (!un(t[o], a[o])) {
            a = !1;
            break n;
          }
          a = !0;
        }
        if (a) return i[0];
      }
    }
    return n = n(), wn.memoizedState = [n, t], n;
  }
  function zt(n, t, i) {
    if (25 <= ol) throw Error(s(301));
    if (n === dn) if (Sn = !0, n = {
      action: i,
      next: null
    }, Ae === null && (Ae = /* @__PURE__ */ new Map()), i = Ae.get(t), i === void 0) Ae.set(t, n);
    else {
      for (t = i; t.next !== null; ) t = t.next;
      t.next = n;
    }
  }
  function se() {
    throw Error(s(440));
  }
  function Pl() {
    throw Error(s(394));
  }
  function hi() {
    throw Error(s(479));
  }
  function Xr(n, t, i) {
    Ue();
    var a = kn++, o = Vn;
    if (typeof n.$$FORM_ACTION == "function") {
      var f = null, v = Rn;
      o = o.formState;
      var R = n.$$IS_SIGNATURE_EQUAL;
      if (o !== null && typeof R == "function") {
        var E = o[1];
        R.call(n, o[2], o[3]) && (f = i !== void 0 ? "p" + i : "k" + on(JSON.stringify([
          v,
          null,
          a
        ]), 0), E === f && (re = a, t = o[0]));
      }
      var w = n.bind(null, t);
      return n = function(P) {
        w(P);
      }, typeof w.$$FORM_ACTION == "function" && (n.$$FORM_ACTION = function(P) {
        P = w.$$FORM_ACTION(P), i !== void 0 && (i += "", P.action = i);
        var X = P.data;
        return X && (f === null && (f = i !== void 0 ? "p" + i : "k" + on(JSON.stringify([
          v,
          null,
          a
        ]), 0)), X.append("$ACTION_KEY", f)), P;
      }), [
        t,
        n,
        !1
      ];
    }
    var F = n.bind(null, t);
    return [
      t,
      function(P) {
        F(P);
      },
      !1
    ];
  }
  function Zr(n) {
    var t = oe;
    return oe += 1, Un === null && (Un = []), en(Un, n, t);
  }
  function ja() {
    throw Error(s(393));
  }
  var Jr = {
    readContext: function(n) {
      return n._currentValue;
    },
    use: function(n) {
      if (n !== null && typeof n == "object") {
        if (typeof n.then == "function") return Zr(n);
        if (n.$$typeof === N) return n._currentValue;
      }
      throw Error(s(438, String(n)));
    },
    useContext: function(n) {
      return Ue(), n._currentValue;
    },
    useMemo: dt,
    useReducer: et,
    useRef: function(n) {
      dn = Ue(), wn = _l();
      var t = wn.memoizedState;
      return t === null ? (n = { current: n }, wn.memoizedState = n) : t;
    },
    useState: function(n) {
      return et(nt, n);
    },
    useInsertionEffect: L,
    useLayoutEffect: L,
    useCallback: function(n, t) {
      return dt(function() {
        return n;
      }, t);
    },
    useImperativeHandle: L,
    useEffect: L,
    useDebugValue: L,
    useDeferredValue: function(n, t) {
      return Ue(), t !== void 0 ? t : n;
    },
    useTransition: function() {
      return Ue(), [!1, Pl];
    },
    useId: function() {
      var n = Wn.treeContext, t = n.overflow;
      n = n.id, n = (n & ~(1 << 32 - I(n) - 1)).toString(32) + t;
      var i = di;
      if (i === null) throw Error(s(404));
      return t = We++, n = "_" + i.idPrefix + "R_" + n, 0 < t && (n += "H" + t.toString(32)), n + "_";
    },
    useSyncExternalStore: function(n, t, i) {
      if (i === void 0) throw Error(s(407));
      return i();
    },
    useOptimistic: function(n) {
      return Ue(), [n, hi];
    },
    useActionState: Xr,
    useFormState: Xr,
    useHostTransitionStatus: function() {
      return Ue(), bl;
    },
    useMemoCache: function(n) {
      for (var t = Array(n), i = 0; i < n; i++) t[i] = bn;
      return t;
    },
    useCacheRefresh: function() {
      return ja;
    },
    useEffectEvent: function() {
      return se;
    }
  }, di = null, $a = {
    getCacheForType: function() {
      throw Error(s(248));
    },
    cacheSignal: function() {
      throw Error(s(248));
    }
  }, ul, ot;
  function kl(n) {
    if (ul === void 0) try {
      throw Error();
    } catch (i) {
      var t = i.stack.trim().match(/\n( *(at )?)/);
      ul = t && t[1] || "", ot = -1 < i.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < i.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return `
` + ul + n + ot;
  }
  var cr = !1;
  function Ht(n, t) {
    if (!n || cr) return "";
    cr = !0;
    var i = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var a = { DetermineComponentFrameRoot: function() {
        try {
          if (t) {
            var P = function() {
              throw Error();
            };
            if (Object.defineProperty(P.prototype, "props", { set: function() {
              throw Error();
            } }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(P, []);
              } catch (Q) {
                var X = Q;
              }
              Reflect.construct(n, [], P);
            } else {
              try {
                P.call();
              } catch (Q) {
                X = Q;
              }
              n.call(P.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (Q) {
              X = Q;
            }
            (P = n()) && typeof P.catch == "function" && P.catch(function() {
            });
          }
        } catch (Q) {
          if (Q && X && typeof Q.stack == "string") return [Q.stack, X.stack];
        }
        return [null, null];
      } };
      a.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var o = Object.getOwnPropertyDescriptor(a.DetermineComponentFrameRoot, "name");
      o && o.configurable && Object.defineProperty(a.DetermineComponentFrameRoot, "name", { value: "DetermineComponentFrameRoot" });
      var f = a.DetermineComponentFrameRoot(), v = f[0], R = f[1];
      if (v && R) {
        var E = v.split(`
`), w = R.split(`
`);
        for (o = a = 0; a < E.length && !E[a].includes("DetermineComponentFrameRoot"); ) a++;
        for (; o < w.length && !w[o].includes("DetermineComponentFrameRoot"); ) o++;
        if (a === E.length || o === w.length) for (a = E.length - 1, o = w.length - 1; 1 <= a && 0 <= o && E[a] !== w[o]; ) o--;
        for (; 1 <= a && 0 <= o; a--, o--) if (E[a] !== w[o]) {
          if (a !== 1 || o !== 1) do
            if (a--, o--, 0 > o || E[a] !== w[o]) {
              var F = `
` + E[a].replace(" at new ", " at ");
              return n.displayName && F.includes("<anonymous>") && (F = F.replace("<anonymous>", n.displayName)), F;
            }
          while (1 <= a && 0 <= o);
          break;
        }
      }
    } finally {
      cr = !1, Error.prepareStackTrace = i;
    }
    return (i = n ? n.displayName || n.name : "") ? kl(i) : "";
  }
  function Qr(n) {
    if (typeof n == "string") return kl(n);
    if (typeof n == "function") return n.prototype && n.prototype.isReactComponent ? Ht(n, !0) : Ht(n, !1);
    if (typeof n == "object" && n !== null) {
      switch (n.$$typeof) {
        case W:
          return Ht(n.render, !1);
        case B:
          return Ht(n.type, !1);
        case Y:
          var t = n, i = t._payload;
          t = t._init;
          try {
            n = t(i);
          } catch {
            return kl("Lazy");
          }
          return Qr(n);
      }
      if (typeof n.name == "string") {
        n: {
          i = n.name, t = n.env;
          var a = n.debugLocation;
          if (a != null && (n = Error.prepareStackTrace, Error.prepareStackTrace = void 0, a = a.stack, Error.prepareStackTrace = n, a.startsWith(`Error: react-stack-top-frame
`) && (a = a.slice(29)), n = a.indexOf(`
`), n !== -1 && (a = a.slice(n + 1)), n = a.indexOf("react_stack_bottom_frame"), n !== -1 && (n = a.lastIndexOf(`
`, n)), n = n !== -1 ? a = a.slice(0, n) : "", a = n.lastIndexOf(`
`), n = a === -1 ? n : n.slice(a + 1), n.indexOf(i) !== -1)) {
            i = `
` + n;
            break n;
          }
          i = kl(i + (t ? " [" + t + "]" : ""));
        }
        return i;
      }
    }
    switch (n) {
      case U:
        return kl("SuspenseList");
      case z:
        return kl("Suspense");
    }
    return "";
  }
  function Qe(n, t) {
    return (500 < t.byteSize || fi(t.contentState)) && t.contentPreamble === null;
  }
  function gi(n) {
    if (typeof n == "object" && n !== null && typeof n.environmentName == "string") {
      var t = n.environmentName;
      n = [n].slice(0), typeof n[0] == "string" ? n.splice(0, 1, "%c%s%c " + n[0], "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px", " " + t + " ", "") : n.splice(0, 0, "%c%s%c", "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px", " " + t + " ", ""), n.unshift(console), t = ir.apply(console.error, n), t();
    } else console.error(n);
    return null;
  }
  function Ol(n, t, i, a, o, f, v, R, E, w, F) {
    var P = /* @__PURE__ */ new Set();
    this.destination = null, this.flushScheduled = !1, this.resumableState = n, this.renderState = t, this.rootFormatContext = i, this.progressiveChunkSize = a === void 0 ? 12800 : a, this.status = 10, this.fatalError = null, this.pendingRootTasks = this.allPendingTasks = this.nextSegmentId = 0, this.completedPreambleSegments = this.completedRootSegment = null, this.byteSize = 0, this.abortableTasks = P, this.pingedTasks = [], this.clientRenderedBoundaries = [], this.completedBoundaries = [], this.partialBoundaries = [], this.trackedPostpones = null, this.onError = o === void 0 ? gi : o, this.onPostpone = w === void 0 ? L : w, this.onAllReady = f === void 0 ? L : f, this.onShellReady = v === void 0 ? L : v, this.onShellError = R === void 0 ? L : R, this.onFatalError = E === void 0 ? L : E, this.formState = F === void 0 ? null : F;
  }
  function Ll(n, t, i, a, o, f, v, R, E, w, F, P) {
    return t = new Ol(t, i, a, o, f, v, R, E, w, F, P), i = Ve(t, 0, null, a, !1, !1), i.parentFlushed = !0, n = Ut(t, null, n, -1, null, i, null, null, t.abortableTasks, null, a, null, d, null, null), Gt(n), t.pingedTasks.push(n), t;
  }
  function vi(n, t, i, a, o, f, v, R, E, w, F) {
    return n = Ll(n, t, i, a, o, f, v, R, E, w, F, void 0), n.trackedPostpones = {
      workingMap: /* @__PURE__ */ new Map(),
      rootNodes: [],
      rootSlots: null
    }, n;
  }
  function gt(n, t, i, a, o, f, v, R, E) {
    return i = new Ol(t.resumableState, i, t.rootFormatContext, t.progressiveChunkSize, a, o, f, v, R, E, null), i.nextSegmentId = t.nextSegmentId, typeof t.replaySlots == "number" ? (a = Ve(i, 0, null, t.rootFormatContext, !1, !1), a.parentFlushed = !0, n = Ut(i, null, n, -1, null, a, null, null, i.abortableTasks, null, t.rootFormatContext, null, d, null, null), Gt(n), i.pingedTasks.push(n), i) : (n = or(i, null, {
      nodes: t.replayNodes,
      slots: t.replaySlots,
      pendingTasks: 0
    }, n, -1, null, null, i.abortableTasks, null, t.rootFormatContext, null, d, null, null), Gt(n), i.pingedTasks.push(n), i);
  }
  function nc(n, t, i, a, o, f, v, R, E) {
    return n = gt(n, t, i, a, o, f, v, R, E), n.trackedPostpones = {
      workingMap: /* @__PURE__ */ new Map(),
      rootNodes: [],
      rootSlots: null
    }, n;
  }
  var ue = null;
  function Wt(n, t) {
    n.pingedTasks.push(t), n.pingedTasks.length === 1 && (n.flushScheduled = n.destination !== null, n.trackedPostpones !== null || n.status === 10 ? Kn(function() {
      return qr(n);
    }) : An(function() {
      return qr(n);
    }));
  }
  function Nl(n, t, i, a, o) {
    return i = {
      status: 0,
      rootSegmentID: -1,
      parentFlushed: !1,
      pendingTasks: 0,
      row: t,
      completedSegments: [],
      byteSize: 0,
      fallbackAbortableTasks: i,
      errorDigest: null,
      contentState: el(),
      fallbackState: el(),
      contentPreamble: a,
      fallbackPreamble: o,
      trackedContentKeyPath: null,
      trackedFallbackNode: null
    }, t !== null && (t.pendingTasks++, a = t.boundaries, a !== null && (n.allPendingTasks++, i.pendingTasks++, a.push(i)), n = t.inheritedHoistables, n !== null && al(i.contentState, n)), i;
  }
  function Ut(n, t, i, a, o, f, v, R, E, w, F, P, X, Q, Cn) {
    n.allPendingTasks++, o === null ? n.pendingRootTasks++ : o.pendingTasks++, Q !== null && Q.pendingTasks++;
    var vn = {
      replay: null,
      node: i,
      childIndex: a,
      ping: function() {
        return Wt(n, vn);
      },
      blockedBoundary: o,
      blockedSegment: f,
      blockedPreamble: v,
      hoistableState: R,
      abortSet: E,
      keyPath: w,
      formatContext: F,
      context: P,
      treeContext: X,
      row: Q,
      componentStack: Cn,
      thenableState: t
    };
    return E.add(vn), vn;
  }
  function or(n, t, i, a, o, f, v, R, E, w, F, P, X, Q) {
    n.allPendingTasks++, f === null ? n.pendingRootTasks++ : f.pendingTasks++, X !== null && X.pendingTasks++, i.pendingTasks++;
    var Cn = {
      replay: i,
      node: a,
      childIndex: o,
      ping: function() {
        return Wt(n, Cn);
      },
      blockedBoundary: f,
      blockedSegment: null,
      blockedPreamble: null,
      hoistableState: v,
      abortSet: R,
      keyPath: E,
      formatContext: w,
      context: F,
      treeContext: P,
      row: X,
      componentStack: Q,
      thenableState: t
    };
    return R.add(Cn), Cn;
  }
  function Ve(n, t, i, a, o, f) {
    return {
      status: 0,
      parentFlushed: !1,
      id: -1,
      index: t,
      chunks: [],
      children: [],
      preambleChildren: [],
      parentFormatContext: a,
      boundary: i,
      lastPushedText: o,
      textEmbedded: f
    };
  }
  function Gt(n) {
    var t = n.node;
    typeof t == "object" && t !== null && t.$$typeof === x && (n.componentStack = {
      parent: n.componentStack,
      type: t.type
    });
  }
  function fl(n) {
    return n === null ? null : {
      parent: n.parent,
      type: "Suspense Fallback"
    };
  }
  function Ke(n) {
    var t = {};
    return n && Object.defineProperty(t, "componentStack", {
      configurable: !0,
      enumerable: !0,
      get: function() {
        try {
          var i = "", a = n;
          do
            i += Qr(a.type), a = a.parent;
          while (a);
          var o = i;
        } catch (f) {
          o = `
Error generating stack: ` + f.message + `
` + f.stack;
        }
        return Object.defineProperty(t, "componentStack", { value: o }), o;
      }
    }), t;
  }
  function ve(n, t, i) {
    if (n = n.onError, t = n(t, i), t == null || typeof t == "string") return t;
  }
  function Dl(n, t) {
    var i = n.onShellError, a = n.onFatalError;
    i(t), a(t), n.destination !== null ? (n.status = 14, ft(n.destination, t)) : (n.status = 13, n.fatalError = t);
  }
  function Re(n, t) {
    Vr(n, t.next, t.hoistables);
  }
  function Vr(n, t, i) {
    for (; t !== null; ) {
      i !== null && (al(t.hoistables, i), t.inheritedHoistables = i);
      var a = t.boundaries;
      if (a !== null) {
        t.boundaries = null;
        for (var o = 0; o < a.length; o++) {
          var f = a[o];
          i !== null && al(f.contentState, i), Ge(n, f, null, null);
        }
      }
      if (t.pendingTasks--, 0 < t.pendingTasks) break;
      i = t.hoistables, t = t.next;
    }
  }
  function bi(n, t) {
    var i = t.boundaries;
    if (i !== null && t.pendingTasks === i.length) {
      for (var a = !0, o = 0; o < i.length; o++) {
        var f = i[o];
        if (f.pendingTasks !== 1 || f.parentFlushed || Qe(n, f)) {
          a = !1;
          break;
        }
      }
      a && Vr(n, t, t.hoistables);
    }
  }
  function yi(n) {
    var t = {
      pendingTasks: 1,
      boundaries: null,
      hoistables: el(),
      inheritedHoistables: null,
      together: !1,
      next: null
    };
    return n !== null && 0 < n.pendingTasks && (t.pendingTasks++, t.boundaries = [], n.next = t), t;
  }
  function ec(n, t, i, a, o) {
    var f = t.keyPath, v = t.treeContext, R = t.row;
    t.keyPath = i, i = a.length;
    var E = null;
    if (t.replay !== null) {
      var w = t.replay.slots;
      if (w !== null && typeof w == "object") for (var F = 0; F < i; F++) {
        var P = o !== "backwards" && o !== "unstable_legacy-backwards" ? F : i - 1 - F, X = a[P];
        t.row = E = yi(E), t.treeContext = y(v, i, P);
        var Q = w[P];
        typeof Q == "number" ? (Yt(n, t, Q, X, P), delete w[P]) : $n(n, t, X, P), --E.pendingTasks === 0 && Re(n, E);
      }
      else for (w = 0; w < i; w++) F = o !== "backwards" && o !== "unstable_legacy-backwards" ? w : i - 1 - w, P = a[F], t.row = E = yi(E), t.treeContext = y(v, i, F), $n(n, t, P, F), --E.pendingTasks === 0 && Re(n, E);
    } else if (o !== "backwards" && o !== "unstable_legacy-backwards") for (o = 0; o < i; o++) w = a[o], t.row = E = yi(E), t.treeContext = y(v, i, o), $n(n, t, w, o), --E.pendingTasks === 0 && Re(n, E);
    else {
      for (o = t.blockedSegment, w = o.children.length, F = o.chunks.length, P = i - 1; 0 <= P; P--) {
        X = a[P], t.row = E = yi(E), t.treeContext = y(v, i, P), Q = Ve(n, F, null, t.formatContext, P === 0 ? o.lastPushedText : !0, !0), o.children.splice(w, 0, Q), t.blockedSegment = Q;
        try {
          $n(n, t, X, P), Q.lastPushedText && Q.textEmbedded && Q.chunks.push($e), Q.status = 1, bt(n, t.blockedBoundary, Q), --E.pendingTasks === 0 && Re(n, E);
        } catch (Cn) {
          throw Q.status = n.status === 12 ? 3 : 4, Cn;
        }
      }
      t.blockedSegment = o, o.lastPushedText = !1;
    }
    R !== null && E !== null && 0 < E.pendingTasks && (R.pendingTasks++, E.next = R), t.treeContext = v, t.row = R, t.keyPath = f;
  }
  function tc(n, t, i, a, o, f) {
    var v = t.thenableState;
    for (t.thenableState = null, dn = {}, Wn = t, Vn = n, Rn = i, kn = We = 0, re = -1, oe = 0, Un = v, n = a(o, f); Sn; ) Sn = !1, kn = We = 0, re = -1, oe = 0, ol += 1, wn = null, n = a(o, f);
    return Je(), n;
  }
  function vt(n, t, i, a, o, f, v) {
    var R = !1;
    if (f !== 0 && n.formState !== null) {
      var E = t.blockedSegment;
      if (E !== null) {
        R = !0, E = E.chunks;
        for (var w = 0; w < f; w++) w === v ? E.push(Rc) : E.push(jl);
      }
    }
    f = t.keyPath, t.keyPath = i, o ? (i = t.treeContext, t.treeContext = y(i, 1, 0), $n(n, t, a, -1), t.treeContext = i) : R ? $n(n, t, a, -1) : be(n, t, a, -1), t.keyPath = f;
  }
  function sl(n, t, i, a, o, f) {
    if (typeof a == "function") if (a.prototype && a.prototype.isReactComponent) {
      var v = o;
      if ("ref" in o) {
        v = {};
        for (var R in o) R !== "ref" && (v[R] = o[R]);
      }
      var E = a.defaultProps;
      if (E) {
        v === o && (v = te({}, v, o));
        for (var w in E) v[w] === void 0 && (v[w] = E[w]);
      }
      o = v, v = qa, E = a.contextType, typeof E == "object" && E !== null && (v = E._currentValue), v = new a(o, v);
      var F = v.state !== void 0 ? v.state : null;
      if (v.updater = u, v.props = o, v.state = F, E = {
        queue: [],
        replace: !1
      }, v._reactInternals = E, f = a.contextType, v.context = typeof f == "object" && f !== null ? f._currentValue : qa, f = a.getDerivedStateFromProps, typeof f == "function" && (f = f(o, F), F = f == null ? F : te({}, F, f), v.state = F), typeof a.getDerivedStateFromProps != "function" && typeof v.getSnapshotBeforeUpdate != "function" && (typeof v.UNSAFE_componentWillMount == "function" || typeof v.componentWillMount == "function")) if (a = v.state, typeof v.componentWillMount == "function" && v.componentWillMount(), typeof v.UNSAFE_componentWillMount == "function" && v.UNSAFE_componentWillMount(), a !== v.state && u.enqueueReplaceState(v, v.state, null), E.queue !== null && 0 < E.queue.length) if (a = E.queue, f = E.replace, E.queue = null, E.replace = !1, f && a.length === 1) v.state = a[0];
      else {
        for (E = f ? a[0] : v.state, F = !0, f = f ? 1 : 0; f < a.length; f++) w = a[f], w = typeof w == "function" ? w.call(v, E, o, void 0) : w, w != null && (F ? (F = !1, E = te({}, E, w)) : te(E, w));
        v.state = E;
      }
      else E.queue = null;
      if (a = v.render(), n.status === 12) throw null;
      o = t.keyPath, t.keyPath = i, be(n, t, a, -1), t.keyPath = o;
    } else {
      if (a = tc(n, t, i, a, o, void 0), n.status === 12) throw null;
      vt(n, t, i, a, We !== 0, kn, re);
    }
    else if (typeof a == "string") if (v = t.blockedSegment, v === null) v = o.children, E = t.formatContext, F = t.keyPath, t.formatContext = rt(E, a, o), t.keyPath = i, $n(n, t, v, -1), t.formatContext = E, t.keyPath = F;
    else {
      if (F = Hi(v.chunks, a, o, n.resumableState, n.renderState, t.blockedPreamble, t.hoistableState, t.formatContext, v.lastPushedText), v.lastPushedText = !1, E = t.formatContext, f = t.keyPath, t.keyPath = i, (t.formatContext = rt(E, a, o)).insertionMode === 3) {
        i = Ve(n, 0, null, t.formatContext, !1, !1), v.preambleChildren.push(i), t.blockedSegment = i;
        try {
          i.status = 6, $n(n, t, F, -1), i.lastPushedText && i.textEmbedded && i.chunks.push($e), i.status = 1, bt(n, t.blockedBoundary, i);
        } finally {
          t.blockedSegment = v;
        }
      } else $n(n, t, F, -1);
      t.formatContext = E, t.keyPath = f;
      n: {
        switch (t = v.chunks, n = n.resumableState, a) {
          case "title":
          case "style":
          case "script":
          case "area":
          case "base":
          case "br":
          case "col":
          case "embed":
          case "hr":
          case "img":
          case "input":
          case "keygen":
          case "link":
          case "meta":
          case "param":
          case "source":
          case "track":
          case "wbr":
            break n;
          case "body":
            if (1 >= E.insertionMode) {
              n.hasBody = !0;
              break n;
            }
            break;
          case "html":
            if (E.insertionMode === 0) {
              n.hasHtml = !0;
              break n;
            }
            break;
          case "head":
            if (1 >= E.insertionMode) break n;
        }
        t.push(Ot(a));
      }
      v.lastPushedText = !1;
    }
    else {
      switch (a) {
        case $:
        case M:
        case O:
        case S:
          a = t.keyPath, t.keyPath = i, be(n, t, o.children, -1), t.keyPath = a;
          return;
        case H:
          a = t.blockedSegment, a === null ? o.mode !== "hidden" && (a = t.keyPath, t.keyPath = i, $n(n, t, o.children, -1), t.keyPath = a) : o.mode !== "hidden" && (a.chunks.push($t), a.lastPushedText = !1, v = t.keyPath, t.keyPath = i, $n(n, t, o.children, -1), t.keyPath = v, a.chunks.push(Wi), a.lastPushedText = !1);
          return;
        case U:
          n: {
            if (a = o.children, o = o.revealOrder, o === "forwards" || o === "backwards" || o === "unstable_legacy-backwards") {
              if (ln(a)) {
                ec(n, t, i, a, o);
                break n;
              }
              if ((v = p(a)) && (v = v.call(a))) {
                if (E = v.next(), !E.done) {
                  do
                    E = v.next();
                  while (!E.done);
                  ec(n, t, i, a, o);
                }
                break n;
              }
            }
            o === "together" ? (o = t.keyPath, v = t.row, E = t.row = yi(null), E.boundaries = [], E.together = !0, t.keyPath = i, be(n, t, a, -1), --E.pendingTasks === 0 && Re(n, E), t.keyPath = o, t.row = v, v !== null && 0 < E.pendingTasks && (v.pendingTasks++, E.next = v)) : (o = t.keyPath, t.keyPath = i, be(n, t, a, -1), t.keyPath = o);
          }
          return;
        case En:
        case J:
          throw Error(s(343));
        case z:
          n: if (t.replay !== null) {
            a = t.keyPath, v = t.formatContext, E = t.row, t.keyPath = i, t.formatContext = qt(n.resumableState, v), t.row = null, i = o.children;
            try {
              $n(n, t, i, -1);
            } finally {
              t.keyPath = a, t.formatContext = v, t.row = E;
            }
          } else {
            a = t.keyPath, f = t.formatContext;
            var P = t.row;
            w = t.blockedBoundary, R = t.blockedPreamble;
            var X = t.hoistableState, Q = t.blockedSegment, Cn = o.fallback;
            o = o.children;
            var vn = /* @__PURE__ */ new Set(), yn = 2 > t.formatContext.insertionMode ? Nl(n, t.row, vn, Dn(), Dn()) : Nl(n, t.row, vn, null, null);
            n.trackedPostpones !== null && (yn.trackedContentKeyPath = i);
            var Hn = Ve(n, Q.chunks.length, yn, t.formatContext, !1, !1);
            Q.children.push(Hn), Q.lastPushedText = !1;
            var Ln = Ve(n, 0, null, t.formatContext, !1, !1);
            if (Ln.parentFlushed = !0, n.trackedPostpones !== null) {
              v = t.componentStack, E = [
                i[0],
                "Suspense Fallback",
                i[2]
              ], F = [
                E[1],
                E[2],
                [],
                null
              ], n.trackedPostpones.workingMap.set(E, F), yn.trackedFallbackNode = F, t.blockedSegment = Hn, t.blockedPreamble = yn.fallbackPreamble, t.keyPath = E, t.formatContext = pt(n.resumableState, f), t.componentStack = fl(v), Hn.status = 6;
              try {
                $n(n, t, Cn, -1), Hn.lastPushedText && Hn.textEmbedded && Hn.chunks.push($e), Hn.status = 1, bt(n, w, Hn);
              } catch (ye) {
                throw Hn.status = n.status === 12 ? 3 : 4, ye;
              } finally {
                t.blockedSegment = Q, t.blockedPreamble = R, t.keyPath = a, t.formatContext = f;
              }
              t = Ut(n, null, o, -1, yn, Ln, yn.contentPreamble, yn.contentState, t.abortSet, i, qt(n.resumableState, t.formatContext), t.context, t.treeContext, null, v), Gt(t), n.pingedTasks.push(t);
            } else {
              t.blockedBoundary = yn, t.blockedPreamble = yn.contentPreamble, t.hoistableState = yn.contentState, t.blockedSegment = Ln, t.keyPath = i, t.formatContext = qt(n.resumableState, f), t.row = null, Ln.status = 6;
              try {
                if ($n(n, t, o, -1), Ln.lastPushedText && Ln.textEmbedded && Ln.chunks.push($e), Ln.status = 1, bt(n, yn, Ln), xi(yn, Ln), yn.pendingTasks === 0 && yn.status === 0) {
                  if (yn.status = 1, !Qe(n, yn)) {
                    P !== null && --P.pendingTasks === 0 && Re(n, P), n.pendingRootTasks === 0 && t.blockedPreamble && yt(n);
                    break n;
                  }
                } else P !== null && P.together && bi(n, P);
              } catch (ye) {
                yn.status = 4, n.status === 12 ? (Ln.status = 3, v = n.fatalError) : (Ln.status = 4, v = ye), E = Ke(t.componentStack), F = ve(n, v, E), yn.errorDigest = F, Kr(n, yn);
              } finally {
                t.blockedBoundary = w, t.blockedPreamble = R, t.hoistableState = X, t.blockedSegment = Q, t.keyPath = a, t.formatContext = f, t.row = P;
              }
              t = Ut(n, null, Cn, -1, w, Hn, yn.fallbackPreamble, yn.fallbackState, vn, [
                i[0],
                "Suspense Fallback",
                i[2]
              ], pt(n.resumableState, t.formatContext), t.context, t.treeContext, t.row, fl(t.componentStack)), Gt(t), n.pingedTasks.push(t);
            }
          }
          return;
      }
      if (typeof a == "object" && a !== null) switch (a.$$typeof) {
        case W:
          if ("ref" in o) for (Q in v = {}, o) Q !== "ref" && (v[Q] = o[Q]);
          else v = o;
          a = tc(n, t, i, a.render, v, f), vt(n, t, i, a, We !== 0, kn, re);
          return;
        case B:
          sl(n, t, i, a.type, o, f);
          return;
        case N:
          if (E = o.children, v = t.keyPath, o = o.value, F = a._currentValue, a._currentValue = o, f = ct, ct = a = {
            parent: f,
            depth: f === null ? 0 : f.depth + 1,
            context: a,
            parentValue: F,
            value: o
          }, t.context = a, t.keyPath = i, be(n, t, E, -1), n = ct, n === null) throw Error(s(403));
          n.context._currentValue = n.parentValue, n = ct = n.parent, t.context = n, t.keyPath = v;
          return;
        case D:
          o = o.children, a = o(a._context._currentValue), o = t.keyPath, t.keyPath = i, be(n, t, a, -1), t.keyPath = o;
          return;
        case Y:
          if (v = a._init, a = v(a._payload), n.status === 12) throw null;
          sl(n, t, i, a, o, f);
          return;
      }
      throw Error(s(130, a == null ? a : typeof a, ""));
    }
  }
  function Yt(n, t, i, a, o) {
    var f = t.replay, v = t.blockedBoundary, R = Ve(n, 0, null, t.formatContext, !1, !1);
    R.id = i, R.parentFlushed = !0;
    try {
      t.replay = null, t.blockedSegment = R, $n(n, t, a, o), R.status = 1, bt(n, v, R), v === null ? n.completedRootSegment = R : (xi(v, R), v.parentFlushed && n.partialBoundaries.push(v));
    } finally {
      t.replay = f, t.blockedSegment = null;
    }
  }
  function be(n, t, i, a) {
    t.replay !== null && typeof t.replay.slots == "number" ? Yt(n, t, t.replay.slots, i, a) : (t.node = i, t.childIndex = a, i = t.componentStack, Gt(t), ml(n, t), t.componentStack = i);
  }
  function ml(n, t) {
    var i = t.node, a = t.childIndex;
    if (i !== null) {
      if (typeof i == "object") {
        switch (i.$$typeof) {
          case x:
            var o = i.type, f = i.key, v = i.props;
            i = v.ref;
            var R = i !== void 0 ? i : null, E = rr(o), w = f ?? (a === -1 ? 0 : a);
            if (f = [
              t.keyPath,
              E,
              w
            ], t.replay !== null) n: {
              var F = t.replay;
              for (a = F.nodes, i = 0; i < a.length; i++) {
                var P = a[i];
                if (w === P[1]) {
                  if (P.length === 4) {
                    if (E !== null && E !== P[0]) throw Error(s(490, P[0], E));
                    var X = P[2];
                    E = P[3], w = t.node, t.replay = {
                      nodes: X,
                      slots: E,
                      pendingTasks: 1
                    };
                    try {
                      if (sl(n, t, f, o, v, R), t.replay.pendingTasks === 1 && 0 < t.replay.nodes.length) throw Error(s(488));
                      t.replay.pendingTasks--;
                    } catch (an) {
                      if (typeof an == "object" && an !== null && (an === Z || typeof an.then == "function")) throw t.node === w ? t.replay = F : a.splice(i, 1), an;
                      t.replay.pendingTasks--, v = Ke(t.componentStack), f = n, n = t.blockedBoundary, o = an, v = ve(f, o, v), zl(f, n, X, E, o, v);
                    }
                    t.replay = F;
                  } else {
                    if (o !== z) throw Error(s(490, "Suspense", rr(o) || "Unknown"));
                    e: {
                      F = void 0, o = P[5], R = P[2], E = P[3], w = P[4] === null ? [] : P[4][2], P = P[4] === null ? null : P[4][3];
                      var Q = t.keyPath, Cn = t.formatContext, vn = t.row, yn = t.replay, Hn = t.blockedBoundary, Ln = t.hoistableState, ye = v.children, Oe = v.fallback, qe = /* @__PURE__ */ new Set();
                      v = 2 > t.formatContext.insertionMode ? Nl(n, t.row, qe, Dn(), Dn()) : Nl(n, t.row, qe, null, null), v.parentFlushed = !0, v.rootSegmentID = o, t.blockedBoundary = v, t.hoistableState = v.contentState, t.keyPath = f, t.formatContext = qt(n.resumableState, Cn), t.row = null, t.replay = {
                        nodes: R,
                        slots: E,
                        pendingTasks: 1
                      };
                      try {
                        if ($n(n, t, ye, -1), t.replay.pendingTasks === 1 && 0 < t.replay.nodes.length) throw Error(s(488));
                        if (t.replay.pendingTasks--, v.pendingTasks === 0 && v.status === 0) {
                          v.status = 1, n.completedBoundaries.push(v);
                          break e;
                        }
                      } catch (an) {
                        v.status = 4, X = Ke(t.componentStack), F = ve(n, an, X), v.errorDigest = F, t.replay.pendingTasks--, n.clientRenderedBoundaries.push(v);
                      } finally {
                        t.blockedBoundary = Hn, t.hoistableState = Ln, t.replay = yn, t.keyPath = Q, t.formatContext = Cn, t.row = vn;
                      }
                      X = or(n, null, {
                        nodes: w,
                        slots: P,
                        pendingTasks: 0
                      }, Oe, -1, Hn, v.fallbackState, qe, [
                        f[0],
                        "Suspense Fallback",
                        f[2]
                      ], pt(n.resumableState, t.formatContext), t.context, t.treeContext, t.row, fl(t.componentStack)), Gt(X), n.pingedTasks.push(X);
                    }
                  }
                  a.splice(i, 1);
                  break n;
                }
              }
            }
            else sl(n, t, f, o, v, R);
            return;
          case C:
            throw Error(s(257));
          case Y:
            if (X = i._init, i = X(i._payload), n.status === 12) throw null;
            be(n, t, i, a);
            return;
        }
        if (ln(i)) {
          Bl(n, t, i, a);
          return;
        }
        if ((X = p(i)) && (X = X.call(i))) {
          if (i = X.next(), !i.done) {
            v = [];
            do
              v.push(i.value), i = X.next();
            while (!i.done);
            Bl(n, t, v, a);
          }
          return;
        }
        if (typeof i.then == "function") return t.thenableState = null, be(n, t, Zr(i), a);
        if (i.$$typeof === N) return be(n, t, i._currentValue, a);
        throw a = Object.prototype.toString.call(i), Error(s(31, a === "[object Object]" ? "object with keys {" + Object.keys(i).join(", ") + "}" : a));
      }
      typeof i == "string" ? (a = t.blockedSegment, a !== null && (a.lastPushedText = Ia(a.chunks, i, n.renderState, a.lastPushedText))) : (typeof i == "number" || typeof i == "bigint") && (a = t.blockedSegment, a !== null && (a.lastPushedText = Ia(a.chunks, "" + i, n.renderState, a.lastPushedText)));
    }
  }
  function Bl(n, t, i, a) {
    var o = t.keyPath;
    if (a !== -1 && (t.keyPath = [
      t.keyPath,
      "Fragment",
      a
    ], t.replay !== null)) {
      for (var f = t.replay, v = f.nodes, R = 0; R < v.length; R++) {
        var E = v[R];
        if (E[1] === a) {
          a = E[2], E = E[3], t.replay = {
            nodes: a,
            slots: E,
            pendingTasks: 1
          };
          try {
            if (Bl(n, t, i, -1), t.replay.pendingTasks === 1 && 0 < t.replay.nodes.length) throw Error(s(488));
            t.replay.pendingTasks--;
          } catch (P) {
            if (typeof P == "object" && P !== null && (P === Z || typeof P.then == "function")) throw P;
            t.replay.pendingTasks--, i = Ke(t.componentStack);
            var w = t.blockedBoundary, F = P;
            i = ve(n, F, i), zl(n, w, a, E, F, i);
          }
          t.replay = f, v.splice(R, 1);
          break;
        }
      }
      t.keyPath = o;
      return;
    }
    if (f = t.treeContext, v = i.length, t.replay !== null && (R = t.replay.slots, R !== null && typeof R == "object")) {
      for (a = 0; a < v; a++) E = i[a], t.treeContext = y(f, v, a), w = R[a], typeof w == "number" ? (Yt(n, t, w, E, a), delete R[a]) : $n(n, t, E, a);
      t.treeContext = f, t.keyPath = o;
      return;
    }
    for (R = 0; R < v; R++) a = i[R], t.treeContext = y(f, v, R), $n(n, t, a, R);
    t.treeContext = f, t.keyPath = o;
  }
  function ur(n, t, i) {
    if (i.status = 5, i.rootSegmentID = n.nextSegmentId++, n = i.trackedContentKeyPath, n === null) throw Error(s(486));
    var a = i.trackedFallbackNode, o = [], f = t.workingMap.get(n);
    return f === void 0 ? (i = [
      n[1],
      n[2],
      o,
      null,
      a,
      i.rootSegmentID
    ], t.workingMap.set(n, i), gr(i, n[0], t), i) : (f[4] = a, f[5] = i.rootSegmentID, f);
  }
  function fr(n, t, i, a) {
    a.status = 5;
    var o = i.keyPath, f = i.blockedBoundary;
    if (f === null) a.id = n.nextSegmentId++, t.rootSlots = a.id, n.completedRootSegment !== null && (n.completedRootSegment.status = 5);
    else {
      if (f !== null && f.status === 0) {
        var v = ur(n, t, f);
        if (f.trackedContentKeyPath === o && i.childIndex === -1) {
          a.id === -1 && (a.id = a.parentFlushed ? f.rootSegmentID : n.nextSegmentId++), v[3] = a.id;
          return;
        }
      }
      if (a.id === -1 && (a.id = a.parentFlushed && f !== null ? f.rootSegmentID : n.nextSegmentId++), i.childIndex === -1) o === null ? t.rootSlots = a.id : (i = t.workingMap.get(o), i === void 0 ? (i = [
        o[1],
        o[2],
        [],
        a.id
      ], gr(i, o[0], t)) : i[3] = a.id);
      else {
        if (o === null) {
          if (n = t.rootSlots, n === null) n = t.rootSlots = {};
          else if (typeof n == "number") throw Error(s(491));
        } else if (f = t.workingMap, v = f.get(o), v === void 0) n = {}, v = [
          o[1],
          o[2],
          [],
          n
        ], f.set(o, v), gr(v, o[0], t);
        else if (n = v[3], n === null) n = v[3] = {};
        else if (typeof n == "number") throw Error(s(491));
        n[i.childIndex] = a.id;
      }
    }
  }
  function Kr(n, t) {
    n = n.trackedPostpones, n !== null && (t = t.trackedContentKeyPath, t !== null && (t = n.workingMap.get(t), t !== void 0 && (t.length = 4, t[2] = [], t[3] = null)));
  }
  function sr(n, t, i) {
    return or(n, i, t.replay, t.node, t.childIndex, t.blockedBoundary, t.hoistableState, t.abortSet, t.keyPath, t.formatContext, t.context, t.treeContext, t.row, t.componentStack);
  }
  function pr(n, t, i) {
    var a = t.blockedSegment, o = Ve(n, a.chunks.length, null, t.formatContext, a.lastPushedText, !0);
    return a.children.push(o), a.lastPushedText = !1, Ut(n, i, t.node, t.childIndex, t.blockedBoundary, o, t.blockedPreamble, t.hoistableState, t.abortSet, t.keyPath, t.formatContext, t.context, t.treeContext, t.row, t.componentStack);
  }
  function $n(n, t, i, a) {
    var o = t.formatContext, f = t.context, v = t.keyPath, R = t.treeContext, E = t.componentStack, w = t.blockedSegment;
    if (w === null) {
      w = t.replay;
      try {
        return be(n, t, i, a);
      } catch (X) {
        if (Je(), i = X === Z ? fn() : X, n.status !== 12 && typeof i == "object" && i !== null) {
          if (typeof i.then == "function") {
            a = X === Z ? Ce() : null, n = sr(n, t, a).ping, i.then(n, n), t.formatContext = o, t.context = f, t.keyPath = v, t.treeContext = R, t.componentStack = E, t.replay = w, c(f);
            return;
          }
          if (i.message === "Maximum call stack size exceeded") {
            i = X === Z ? Ce() : null, i = sr(n, t, i), n.pingedTasks.push(i), t.formatContext = o, t.context = f, t.keyPath = v, t.treeContext = R, t.componentStack = E, t.replay = w, c(f);
            return;
          }
        }
      }
    } else {
      var F = w.children.length, P = w.chunks.length;
      try {
        return be(n, t, i, a);
      } catch (X) {
        if (Je(), w.children.length = F, w.chunks.length = P, i = X === Z ? fn() : X, n.status !== 12 && typeof i == "object" && i !== null) {
          if (typeof i.then == "function") {
            w = i, i = X === Z ? Ce() : null, n = pr(n, t, i).ping, w.then(n, n), t.formatContext = o, t.context = f, t.keyPath = v, t.treeContext = R, t.componentStack = E, c(f);
            return;
          }
          if (i.message === "Maximum call stack size exceeded") {
            w = X === Z ? Ce() : null, w = pr(n, t, w), n.pingedTasks.push(w), t.formatContext = o, t.context = f, t.keyPath = v, t.treeContext = R, t.componentStack = E, c(f);
            return;
          }
        }
      }
    }
    throw t.formatContext = o, t.context = f, t.keyPath = v, t.treeContext = R, c(f), i;
  }
  function hr(n) {
    var t = n.blockedBoundary, i = n.blockedSegment;
    i !== null && (i.status = 3, Ge(this, t, n.row, i));
  }
  function zl(n, t, i, a, o, f) {
    for (var v = 0; v < i.length; v++) {
      var R = i[v];
      if (R.length === 4) zl(n, t, R[2], R[3], o, f);
      else {
        R = R[5];
        var E = n, w = f, F = Nl(E, null, /* @__PURE__ */ new Set(), null, null);
        F.parentFlushed = !0, F.rootSegmentID = R, F.status = 4, F.errorDigest = w, F.parentFlushed && E.clientRenderedBoundaries.push(F);
      }
    }
    if (i.length = 0, a !== null) {
      if (t === null) throw Error(s(487));
      if (t.status !== 4 && (t.status = 4, t.errorDigest = f, t.parentFlushed && n.clientRenderedBoundaries.push(t)), typeof a == "object") for (var P in a) delete a[P];
    }
  }
  function Hl(n, t, i) {
    var a = n.blockedBoundary, o = n.blockedSegment;
    if (o !== null) {
      if (o.status === 6) return;
      o.status = 3;
    }
    var f = Ke(n.componentStack);
    if (a === null) {
      if (t.status !== 13 && t.status !== 14) {
        if (a = n.replay, a === null) {
          t.trackedPostpones !== null && o !== null ? (a = t.trackedPostpones, ve(t, i, f), fr(t, a, n, o), Ge(t, null, n.row, o)) : (ve(t, i, f), Dl(t, i));
          return;
        }
        a.pendingTasks--, a.pendingTasks === 0 && 0 < a.nodes.length && (o = ve(t, i, f), zl(t, null, a.nodes, a.slots, i, o)), t.pendingRootTasks--, t.pendingRootTasks === 0 && dr(t);
      }
    } else {
      var v = t.trackedPostpones;
      if (a.status !== 4) {
        if (v !== null && o !== null) return ve(t, i, f), fr(t, v, n, o), a.fallbackAbortableTasks.forEach(function(R) {
          return Hl(R, t, i);
        }), a.fallbackAbortableTasks.clear(), Ge(t, a, n.row, o);
        a.status = 4, o = ve(t, i, f), a.status = 4, a.errorDigest = o, Kr(t, a), a.parentFlushed && t.clientRenderedBoundaries.push(a);
      }
      a.pendingTasks--, o = a.row, o !== null && --o.pendingTasks === 0 && Re(t, o), a.fallbackAbortableTasks.forEach(function(R) {
        return Hl(R, t, i);
      }), a.fallbackAbortableTasks.clear();
    }
    n = n.row, n !== null && --n.pendingTasks === 0 && Re(t, n), t.allPendingTasks--, t.allPendingTasks === 0 && Ti(t);
  }
  function Ei(n, t) {
    try {
      var i = n.renderState, a = i.onHeaders;
      if (a) {
        var o = i.headers;
        if (o) {
          i.headers = null;
          var f = o.preconnects;
          if (o.fontPreloads && (f && (f += ", "), f += o.fontPreloads), o.highImagePreloads && (f && (f += ", "), f += o.highImagePreloads), !t) {
            var v = i.styles.values(), R = v.next();
            n: for (; 0 < o.remainingCapacity && !R.done; R = v.next()) for (var E = R.value.sheets.values(), w = E.next(); 0 < o.remainingCapacity && !w.done; w = E.next()) {
              var F = w.value, P = F.props, X = P.href, Q = F.props, Cn = ui(Q.href, "style", {
                crossOrigin: Q.crossOrigin,
                integrity: Q.integrity,
                nonce: Q.nonce,
                type: Q.type,
                fetchPriority: Q.fetchPriority,
                referrerPolicy: Q.referrerPolicy,
                media: Q.media
              });
              if (0 <= (o.remainingCapacity -= Cn.length + 2)) i.resets.style[X] = xe, f && (f += ", "), f += Cn, i.resets.style[X] = typeof P.crossOrigin == "string" || typeof P.integrity == "string" ? [P.crossOrigin, P.integrity] : xe;
              else break n;
            }
          }
          a(f ? { Link: f } : {});
        }
      }
    } catch (vn) {
      ve(n, vn, {});
    }
  }
  function dr(n) {
    n.trackedPostpones === null && Ei(n, !0), n.trackedPostpones === null && yt(n), n.onShellError = L, n = n.onShellReady, n();
  }
  function Ti(n) {
    Ei(n, n.trackedPostpones === null ? !0 : n.completedRootSegment === null || n.completedRootSegment.status !== 5), yt(n), n = n.onAllReady, n();
  }
  function xi(n, t) {
    if (t.chunks.length === 0 && t.children.length === 1 && t.children[0].boundary === null && t.children[0].id === -1) {
      var i = t.children[0];
      i.id = t.id, i.parentFlushed = !0, i.status !== 1 && i.status !== 3 && i.status !== 4 || xi(n, i);
    } else n.completedSegments.push(t);
  }
  function bt(n, t, i) {
    if (ee !== null) {
      i = i.chunks;
      for (var a = 0, o = 0; o < i.length; o++) a += i[o].byteLength;
      t === null ? n.byteSize += a : t.byteSize += a;
    }
  }
  function Ge(n, t, i, a) {
    if (i !== null && (--i.pendingTasks === 0 ? Re(n, i) : i.together && bi(n, i)), n.allPendingTasks--, t === null) {
      if (a !== null && a.parentFlushed) {
        if (n.completedRootSegment !== null) throw Error(s(389));
        n.completedRootSegment = a;
      }
      n.pendingRootTasks--, n.pendingRootTasks === 0 && dr(n);
    } else if (t.pendingTasks--, t.status !== 4) if (t.pendingTasks === 0) {
      if (t.status === 0 && (t.status = 1), a !== null && a.parentFlushed && (a.status === 1 || a.status === 3) && xi(t, a), t.parentFlushed && n.completedBoundaries.push(t), t.status === 1) i = t.row, i !== null && al(i.hoistables, t.contentState), Qe(n, t) || (t.fallbackAbortableTasks.forEach(hr, n), t.fallbackAbortableTasks.clear(), i !== null && --i.pendingTasks === 0 && Re(n, i)), n.pendingRootTasks === 0 && n.trackedPostpones === null && t.contentPreamble !== null && yt(n);
      else if (t.status === 5 && (t = t.row, t !== null)) {
        if (n.trackedPostpones !== null) {
          i = n.trackedPostpones;
          var o = t.next;
          if (o !== null && (a = o.boundaries, a !== null)) for (o.boundaries = null, o = 0; o < a.length; o++) {
            var f = a[o];
            ur(n, i, f), Ge(n, f, null, null);
          }
        }
        --t.pendingTasks === 0 && Re(n, t);
      }
    } else a === null || !a.parentFlushed || a.status !== 1 && a.status !== 3 || (xi(t, a), t.completedSegments.length === 1 && t.parentFlushed && n.partialBoundaries.push(t)), t = t.row, t !== null && t.together && bi(n, t);
    n.allPendingTasks === 0 && Ti(n);
  }
  function qr(n) {
    if (n.status !== 14 && n.status !== 13) {
      var t = ct, i = Te.H;
      Te.H = Jr;
      var a = Te.A;
      Te.A = $a;
      var o = ue;
      ue = n;
      var f = di;
      di = n.resumableState;
      try {
        var v = n.pingedTasks, R;
        for (R = 0; R < v.length; R++) {
          var E = v[R], w = n, F = E.blockedSegment;
          if (F === null) {
            var P = w;
            if (E.replay.pendingTasks !== 0) {
              c(E.context);
              try {
                if (typeof E.replay.slots == "number" ? Yt(P, E, E.replay.slots, E.node, E.childIndex) : ml(P, E), E.replay.pendingTasks === 1 && 0 < E.replay.nodes.length) throw Error(s(488));
                E.replay.pendingTasks--, E.abortSet.delete(E), Ge(P, E.blockedBoundary, E.row, null);
              } catch (Ee) {
                Je();
                var X = Ee === Z ? fn() : Ee;
                if (typeof X == "object" && X !== null && typeof X.then == "function") {
                  var Q = E.ping;
                  X.then(Q, Q), E.thenableState = Ee === Z ? Ce() : null;
                } else {
                  E.replay.pendingTasks--, E.abortSet.delete(E);
                  var Cn = Ke(E.componentStack);
                  w = void 0;
                  var vn = P, yn = E.blockedBoundary, Hn = P.status === 12 ? P.fatalError : X, Ln = E.replay.nodes, ye = E.replay.slots;
                  w = ve(vn, Hn, Cn), zl(vn, yn, Ln, ye, Hn, w), P.pendingRootTasks--, P.pendingRootTasks === 0 && dr(P), P.allPendingTasks--, P.allPendingTasks === 0 && Ti(P);
                }
              }
            }
          } else if (P = void 0, vn = F, vn.status === 0) {
            vn.status = 6, c(E.context);
            var Oe = vn.children.length, qe = vn.chunks.length;
            try {
              ml(w, E), vn.lastPushedText && vn.textEmbedded && vn.chunks.push($e), E.abortSet.delete(E), vn.status = 1, bt(w, E.blockedBoundary, vn), Ge(w, E.blockedBoundary, E.row, vn);
            } catch (Ee) {
              Je(), vn.children.length = Oe, vn.chunks.length = qe;
              var an = Ee === Z ? fn() : w.status === 12 ? w.fatalError : Ee;
              if (w.status === 12 && w.trackedPostpones !== null) {
                var Se = w.trackedPostpones, pn = Ke(E.componentStack);
                E.abortSet.delete(E), ve(w, an, pn), fr(w, Se, E, vn), Ge(w, E.blockedBoundary, E.row, vn);
              } else if (typeof an == "object" && an !== null && typeof an.then == "function") {
                vn.status = 0, E.thenableState = Ee === Z ? Ce() : null;
                var _e = E.ping;
                an.then(_e, _e);
              } else {
                var Ct = Ke(E.componentStack);
                E.abortSet.delete(E), vn.status = 4;
                var qn = E.blockedBoundary, Jt = E.row;
                if (Jt !== null && --Jt.pendingTasks === 0 && Re(w, Jt), w.allPendingTasks--, P = ve(w, an, Ct), qn === null) Dl(w, an);
                else if (qn.pendingTasks--, qn.status !== 4) {
                  qn.status = 4, qn.errorDigest = P, Kr(w, qn);
                  var ut = qn.row;
                  ut !== null && --ut.pendingTasks === 0 && Re(w, ut), qn.parentFlushed && w.clientRenderedBoundaries.push(qn), w.pendingRootTasks === 0 && w.trackedPostpones === null && qn.contentPreamble !== null && yt(w);
                }
                w.allPendingTasks === 0 && Ti(w);
              }
            }
          }
        }
        v.splice(0, R), n.destination !== null && wi(n, n.destination);
      } catch (Ee) {
        ve(n, Ee, {}), Dl(n, Ee);
      } finally {
        di = f, Te.H = i, Te.A = a, i === Jr && c(t), ue = o;
      }
    }
  }
  function Xt(n, t, i) {
    t.preambleChildren.length && i.push(t.preambleChildren);
    for (var a = !1, o = 0; o < t.children.length; o++) a = jr(n, t.children[o], i) || a;
    return a;
  }
  function jr(n, t, i) {
    var a = t.boundary;
    if (a === null) return Xt(n, t, i);
    var o = a.contentPreamble, f = a.fallbackPreamble;
    if (o === null || f === null) return !1;
    switch (a.status) {
      case 1:
        if (Fr(n.renderState, o), n.byteSize += a.byteSize, t = a.completedSegments[0], !t) throw Error(s(391));
        return Xt(n, t, i);
      case 5:
        if (n.trackedPostpones !== null) return !0;
      case 4:
        if (t.status === 1) return Fr(n.renderState, f), Xt(n, t, i);
      default:
        return !0;
    }
  }
  function yt(n) {
    if (n.completedRootSegment && n.completedPreambleSegments === null) {
      var t = [], i = n.byteSize, a = jr(n, n.completedRootSegment, t), o = n.renderState.preamble;
      a === !1 || o.headChunks && o.bodyChunks ? n.completedPreambleSegments = t : n.byteSize = i;
    }
  }
  function hl(n, t, i, a) {
    switch (i.parentFlushed = !0, i.status) {
      case 0:
        i.id = n.nextSegmentId++;
      case 5:
        return a = i.id, i.lastPushedText = !1, i.textEmbedded = !1, n = n.renderState, _(t, ma), _(t, n.placeholderPrefix), n = G(a.toString(16)), _(t, n), V(t, Ic);
      case 1:
        i.status = 2;
        var o = !0, f = i.chunks, v = 0;
        i = i.children;
        for (var R = 0; R < i.length; R++) {
          for (o = i[R]; v < o.index; v++) _(t, f[v]);
          o = Wl(n, t, o, a);
        }
        for (; v < f.length - 1; v++) _(t, f[v]);
        return v < f.length && (o = V(t, f[v])), o;
      case 3:
        return !0;
      default:
        throw Error(s(390));
    }
  }
  var Et = 0;
  function Wl(n, t, i, a) {
    var o = i.boundary;
    if (o === null) return hl(n, t, i, a);
    if (o.parentFlushed = !0, o.status === 4) {
      var f = o.row;
      f !== null && --f.pendingTasks === 0 && Re(n, f), o = o.errorDigest, V(t, Ie), _(t, kc), o && (_(t, Gi), _(t, G(j(o))), _(t, Ui)), V(t, Oc), hl(n, t, i, a);
    } else if (o.status !== 1) o.status === 0 && (o.rootSegmentID = n.nextSegmentId++), 0 < o.completedSegments.length && n.partialBoundaries.push(o), Ba(t, n.renderState, o.rootSegmentID), a && al(a, o.fallbackState), hl(n, t, i, a);
    else if (!xt && Qe(n, o) && (Et + o.byteSize > n.progressiveChunkSize || fi(o.contentState))) o.rootSegmentID = n.nextSegmentId++, n.completedBoundaries.push(o), Ba(t, n.renderState, o.rootSegmentID), hl(n, t, i, a);
    else {
      if (Et += o.byteSize, a && al(a, o.contentState), i = o.row, i !== null && Qe(n, o) && --i.pendingTasks === 0 && Re(n, i), V(t, Ac), i = o.completedSegments, i.length !== 1) throw Error(s(391));
      Wl(n, t, i[0], a);
    }
    return V(t, He);
  }
  function Tt(n, t, i, a) {
    return Wa(t, n.renderState, i.parentFormatContext, i.id), Wl(n, t, i, a), Ua(t, i.parentFormatContext);
  }
  function $r(n, t, i) {
    Et = i.byteSize;
    for (var a = i.completedSegments, o = 0; o < a.length; o++) na(n, t, i, a[o]);
    a.length = 0, a = i.row, a !== null && Qe(n, i) && --a.pendingTasks === 0 && Re(n, a), Il(t, i.contentState, n.renderState), a = n.resumableState, n = n.renderState, o = i.rootSegmentID, i = i.contentState;
    var f = n.stylesToHoist;
    return n.stylesToHoist = !1, _(t, n.startInlineScript), _(t, zn), f ? ((a.instructions & 4) === 0 && (a.instructions |= 4, _(t, Sl)), (a.instructions & 2) === 0 && (a.instructions |= 2, _(t, Or)), (a.instructions & 8) === 0 ? (a.instructions |= 8, _(t, Bc)) : _(t, Ya)) : ((a.instructions & 2) === 0 && (a.instructions |= 2, _(t, Or)), _(t, Ga)), a = G(o.toString(16)), _(t, n.boundaryPrefix), _(t, a), _(t, Qi), _(t, n.segmentPrefix), _(t, a), f ? (_(t, zc), fe(t, i)) : _(t, Lr), i = V(t, Xa), Ir(t, n) && i;
  }
  function na(n, t, i, a) {
    if (a.status === 2) return !0;
    var o = i.contentState, f = a.id;
    if (f === -1) {
      if ((a.id = i.rootSegmentID) === -1) throw Error(s(392));
      return Tt(n, t, a, o);
    }
    return f === i.rootSegmentID ? Tt(n, t, a, o) : (Tt(n, t, a, o), i = n.resumableState, n = n.renderState, _(t, n.startInlineScript), _(t, zn), (i.instructions & 1) === 0 ? (i.instructions |= 1, _(t, Lc)) : _(t, Nc), _(t, n.segmentPrefix), f = G(f.toString(16)), _(t, f), _(t, Dc), _(t, n.placeholderPrefix), _(t, f), t = V(t, mc), t);
  }
  var xt = !1;
  function wi(n, t) {
    In = new Uint8Array(2048), On = 0;
    try {
      if (!(0 < n.pendingRootTasks)) {
        var i, a = n.completedRootSegment;
        if (a !== null) {
          if (a.status === 5) return;
          var o = n.completedPreambleSegments;
          if (o === null) return;
          Et = n.byteSize;
          var f = n.resumableState, v = n.renderState, R = v.preamble, E = R.htmlChunks, w = R.headChunks, F;
          if (E) {
            for (F = 0; F < E.length; F++) _(t, E[F]);
            if (w) for (F = 0; F < w.length; F++) _(t, w[F]);
            else _(t, ie("head")), _(t, zn);
          } else if (w) for (F = 0; F < w.length; F++) _(t, w[F]);
          var P = v.charsetChunks;
          for (F = 0; F < P.length; F++) _(t, P[F]);
          P.length = 0, v.preconnects.forEach(Bn, t), v.preconnects.clear();
          var X = v.viewportChunks;
          for (F = 0; F < X.length; F++) _(t, X[F]);
          X.length = 0, v.fontPreloads.forEach(Bn, t), v.fontPreloads.clear(), v.highImagePreloads.forEach(Bn, t), v.highImagePreloads.clear(), lt = v, v.styles.forEach(qi, t), lt = null;
          var Q = v.importMapChunks;
          for (F = 0; F < Q.length; F++) _(t, Q[F]);
          Q.length = 0, v.bootstrapScripts.forEach(Bn, t), v.scripts.forEach(Bn, t), v.scripts.clear(), v.bulkPreloads.forEach(Bn, t), v.bulkPreloads.clear(), E || w || (f.instructions |= 32);
          var Cn = v.hoistableChunks;
          for (F = 0; F < Cn.length; F++) _(t, Cn[F]);
          for (f = Cn.length = 0; f < o.length; f++) {
            var vn = o[f];
            for (v = 0; v < vn.length; v++) Wl(n, t, vn[v], null);
          }
          var yn = n.renderState.preamble, Hn = yn.headChunks;
          (yn.htmlChunks || Hn) && _(t, Ot("head"));
          var Ln = yn.bodyChunks;
          if (Ln) for (o = 0; o < Ln.length; o++) _(t, Ln[o]);
          Wl(n, t, a, null), n.completedRootSegment = null;
          var ye = n.renderState;
          if (n.allPendingTasks !== 0 || n.clientRenderedBoundaries.length !== 0 || n.completedBoundaries.length !== 0 || n.trackedPostpones !== null && (n.trackedPostpones.rootNodes.length !== 0 || n.trackedPostpones.rootSlots !== null)) {
            var Oe = n.resumableState;
            if ((Oe.instructions & 64) === 0) {
              if (Oe.instructions |= 64, _(t, ye.startInlineScript), (Oe.instructions & 32) === 0) {
                Oe.instructions |= 32;
                var qe = "_" + Oe.idPrefix + "R_";
                _(t, ji), _(t, G(j(qe))), _(t, Jn);
              }
              _(t, zn), _(t, Lt), V(t, Tn);
            }
          }
          Ir(t, ye);
        }
        var an = n.renderState;
        a = 0;
        var Se = an.viewportChunks;
        for (a = 0; a < Se.length; a++) _(t, Se[a]);
        Se.length = 0, an.preconnects.forEach(Bn, t), an.preconnects.clear(), an.fontPreloads.forEach(Bn, t), an.fontPreloads.clear(), an.highImagePreloads.forEach(Bn, t), an.highImagePreloads.clear(), an.styles.forEach(zr, t), an.scripts.forEach(Bn, t), an.scripts.clear(), an.bulkPreloads.forEach(Bn, t), an.bulkPreloads.clear();
        var pn = an.hoistableChunks;
        for (a = 0; a < pn.length; a++) _(t, pn[a]);
        pn.length = 0;
        var _e = n.clientRenderedBoundaries;
        for (i = 0; i < _e.length; i++) {
          var Ct = _e[i];
          an = t;
          var qn = n.resumableState, Jt = n.renderState, ut = Ct.rootSegmentID, Ee = Ct.errorDigest;
          _(an, Jt.startInlineScript), _(an, zn), (qn.instructions & 4) === 0 ? (qn.instructions |= 4, _(an, Nr)) : _(an, Vi), _(an, Jt.boundaryPrefix), _(an, G(ut.toString(16))), _(an, Za), Ee && (_(an, Ml), _(an, G(Uc(Ee || ""))));
          var je = V(an, Hc);
          if (!je) {
            n.destination = null, i++, _e.splice(0, i);
            return;
          }
        }
        _e.splice(0, i);
        var Ci = n.completedBoundaries;
        for (i = 0; i < Ci.length; i++) if (!$r(n, t, Ci[i])) {
          n.destination = null, i++, Ci.splice(0, i);
          return;
        }
        Ci.splice(0, i), gn(t), In = new Uint8Array(2048), On = 0, xt = !0;
        var Ri = n.partialBoundaries;
        for (i = 0; i < Ri.length; i++) {
          var gl = Ri[i];
          n: {
            _e = n, Ct = t, Et = gl.byteSize;
            var Si = gl.completedSegments;
            for (je = 0; je < Si.length; je++) if (!na(_e, Ct, gl, Si[je])) {
              je++, Si.splice(0, je);
              var ta = !1;
              break n;
            }
            Si.splice(0, je);
            var Qt = gl.row;
            Qt !== null && Qt.together && gl.pendingTasks === 1 && (Qt.pendingTasks === 1 ? Vr(_e, Qt, Qt.hoistables) : Qt.pendingTasks--), ta = Il(Ct, gl.contentState, _e.renderState);
          }
          if (!ta) {
            n.destination = null, i++, Ri.splice(0, i);
            return;
          }
        }
        Ri.splice(0, i), xt = !1;
        var Gl = n.completedBoundaries;
        for (i = 0; i < Gl.length; i++) if (!$r(n, t, Gl[i])) {
          n.destination = null, i++, Gl.splice(0, i);
          return;
        }
        Gl.splice(0, i);
      }
    } finally {
      xt = !1, n.allPendingTasks === 0 && n.clientRenderedBoundaries.length === 0 && n.completedBoundaries.length === 0 ? (n.flushScheduled = !1, i = n.resumableState, i.hasBody && _(t, Ot("body")), i.hasHtml && _(t, Ot("html")), gn(t), n.status = 14, t.close(), n.destination = null) : gn(t);
    }
  }
  function dl(n) {
    n.flushScheduled = n.destination !== null, Kn(function() {
      return qr(n);
    }), An(function() {
      n.status === 10 && (n.status = 11), n.trackedPostpones === null && Ei(n, n.pendingRootTasks === 0);
    });
  }
  function wt(n) {
    n.flushScheduled === !1 && n.pingedTasks.length === 0 && n.destination !== null && (n.flushScheduled = !0, An(function() {
      var t = n.destination;
      t ? wi(n, t) : n.flushScheduled = !1;
    }));
  }
  function Zt(n, t) {
    if (n.status === 13) n.status = 14, ft(t, n.fatalError);
    else if (n.status !== 14 && n.destination === null) {
      n.destination = t;
      try {
        wi(n, t);
      } catch (i) {
        ve(n, i, {}), Dl(n, i);
      }
    }
  }
  function pe(n, t) {
    (n.status === 11 || n.status === 10) && (n.status = 12);
    try {
      var i = n.abortableTasks;
      if (0 < i.size) {
        var a = t === void 0 ? Error(s(432)) : typeof t == "object" && t !== null && typeof t.then == "function" ? Error(s(530)) : t;
        n.fatalError = a, i.forEach(function(o) {
          return Hl(o, n, a);
        }), i.clear();
      }
      n.destination !== null && wi(n, n.destination);
    } catch (o) {
      ve(n, o, {}), Dl(n, o);
    }
  }
  function gr(n, t, i) {
    if (t === null) i.rootNodes.push(n);
    else {
      var a = i.workingMap, o = a.get(t);
      o === void 0 && (o = [
        t[1],
        t[2],
        [],
        null
      ], a.set(t, o), gr(o, t[0], i)), o[2].push(n);
    }
  }
  function ea(n) {
    var t = n.trackedPostpones;
    if (t === null || t.rootNodes.length === 0 && t.rootSlots === null) return n.trackedPostpones = null;
    if (n.completedRootSegment === null || n.completedRootSegment.status !== 5 && n.completedPreambleSegments !== null) {
      var i = n.nextSegmentId, a = t.rootSlots, o = n.resumableState;
      o.bootstrapScriptContent = void 0, o.bootstrapScripts = void 0, o.bootstrapModules = void 0;
    } else {
      i = 0, a = -1, o = n.resumableState;
      var f = n.renderState;
      o.nextFormID = 0, o.hasBody = !1, o.hasHtml = !1, o.unknownResources = { font: f.resets.font }, o.dnsResources = f.resets.dns, o.connectResources = f.resets.connect, o.imageResources = f.resets.image, o.styleResources = f.resets.style, o.scriptResources = {}, o.moduleUnknownResources = {}, o.moduleScriptResources = {}, o.instructions = 0;
    }
    return {
      nextSegmentId: i,
      rootFormatContext: n.rootFormatContext,
      progressiveChunkSize: n.progressiveChunkSize,
      resumableState: n.resumableState,
      replayNodes: t.rootNodes,
      replaySlots: a
    };
  }
  function Ul() {
    var n = g.version;
    if (n !== "19.2.5") throw Error(s(527, n, "19.2.5"));
  }
  Ul(), Ul(), h.prerender = function(n, t) {
    return new Promise(function(i, a) {
      var o = t ? t.onHeaders : void 0, f;
      o && (f = function(F) {
        o(new Headers(F));
      });
      var v = Ql(t ? t.identifierPrefix : void 0, t ? t.unstable_externalRuntimeSrc : void 0, t ? t.bootstrapScriptContent : void 0, t ? t.bootstrapScripts : void 0, t ? t.bootstrapModules : void 0), R = vi(n, v, Kt(v, void 0, t ? t.unstable_externalRuntimeSrc : void 0, t ? t.importMap : void 0, f, t ? t.maxHeadersLength : void 0), Tl(t ? t.namespaceURI : void 0), t ? t.progressiveChunkSize : void 0, t ? t.onError : void 0, function() {
        var F = new ReadableStream({
          type: "bytes",
          pull: function(P) {
            Zt(R, P);
          },
          cancel: function(P) {
            R.destination = null, pe(R, P);
          }
        }, { highWaterMark: 0 });
        F = {
          postponed: ea(R),
          prelude: F
        }, i(F);
      }, void 0, void 0, a, t ? t.onPostpone : void 0);
      if (t && t.signal) {
        var E = t.signal;
        if (E.aborted) pe(R, E.reason);
        else {
          var w = function() {
            pe(R, E.reason), E.removeEventListener("abort", w);
          };
          E.addEventListener("abort", w);
        }
      }
      dl(R);
    });
  }, h.renderToReadableStream = function(n, t) {
    return new Promise(function(i, a) {
      var o, f, v = new Promise(function(Q, Cn) {
        f = Q, o = Cn;
      }), R = t ? t.onHeaders : void 0, E;
      R && (E = function(Q) {
        R(new Headers(Q));
      });
      var w = Ql(t ? t.identifierPrefix : void 0, t ? t.unstable_externalRuntimeSrc : void 0, t ? t.bootstrapScriptContent : void 0, t ? t.bootstrapScripts : void 0, t ? t.bootstrapModules : void 0), F = Ll(n, w, Kt(w, t ? t.nonce : void 0, t ? t.unstable_externalRuntimeSrc : void 0, t ? t.importMap : void 0, E, t ? t.maxHeadersLength : void 0), Tl(t ? t.namespaceURI : void 0), t ? t.progressiveChunkSize : void 0, t ? t.onError : void 0, f, function() {
        var Q = new ReadableStream({
          type: "bytes",
          pull: function(Cn) {
            Zt(F, Cn);
          },
          cancel: function(Cn) {
            F.destination = null, pe(F, Cn);
          }
        }, { highWaterMark: 0 });
        Q.allReady = v, i(Q);
      }, function(Q) {
        v.catch(function() {
        }), a(Q);
      }, o, t ? t.onPostpone : void 0, t ? t.formState : void 0);
      if (t && t.signal) {
        var P = t.signal;
        if (P.aborted) pe(F, P.reason);
        else {
          var X = function() {
            pe(F, P.reason), P.removeEventListener("abort", X);
          };
          P.addEventListener("abort", X);
        }
      }
      dl(F);
    });
  }, h.resume = function(n, t, i) {
    return new Promise(function(a, o) {
      var f, v, R = new Promise(function(P, X) {
        v = P, f = X;
      }), E = gt(n, t, Kt(t.resumableState, i ? i.nonce : void 0, void 0, void 0, void 0, void 0), i ? i.onError : void 0, v, function() {
        var P = new ReadableStream({
          type: "bytes",
          pull: function(X) {
            Zt(E, X);
          },
          cancel: function(X) {
            E.destination = null, pe(E, X);
          }
        }, { highWaterMark: 0 });
        P.allReady = R, a(P);
      }, function(P) {
        R.catch(function() {
        }), o(P);
      }, f, i ? i.onPostpone : void 0);
      if (i && i.signal) {
        var w = i.signal;
        if (w.aborted) pe(E, w.reason);
        else {
          var F = function() {
            pe(E, w.reason), w.removeEventListener("abort", F);
          };
          w.addEventListener("abort", F);
        }
      }
      dl(E);
    });
  }, h.resumeAndPrerender = function(n, t, i) {
    return new Promise(function(a, o) {
      var f = nc(n, t, Kt(t.resumableState, void 0, void 0, void 0, void 0, void 0), i ? i.onError : void 0, function() {
        var E = new ReadableStream({
          type: "bytes",
          pull: function(w) {
            Zt(f, w);
          },
          cancel: function(w) {
            f.destination = null, pe(f, w);
          }
        }, { highWaterMark: 0 });
        E = {
          postponed: ea(f),
          prelude: E
        }, a(E);
      }, void 0, void 0, o, i ? i.onPostpone : void 0);
      if (i && i.signal) {
        var v = i.signal;
        if (v.aborted) pe(f, v.reason);
        else {
          var R = function() {
            pe(f, v.reason), v.removeEventListener("abort", R);
          };
          v.addEventListener("abort", R);
        }
      }
      dl(f);
    });
  }, h.version = "19.2.5";
})), ws = /* @__PURE__ */ yo(((h) => {
  var g = Ts(), b = xs();
  h.version = g.version, h.renderToString = g.renderToString, h.renderToStaticMarkup = g.renderToStaticMarkup, h.renderToReadableStream = b.renderToReadableStream, h.resume = b.resume;
})), Cs = ws();
window.addEventListener("gorgias-widget-loaded", () => {
  const h = document.getElementById("gorgias-chat-container");
  if (!h || !window.GorgiasChat) return;
  const g = /* @__PURE__ */ (0, K.jsx)("button", {
    id: "close-btn",
    className: "georgias-chat-widget-close fixed bottom-[min(75vh,720px)] right-11 size-10 hidden md:flex items-center justify-center opacity-0 md:aria-[hidden=true]:opacity-100 data-[focus-on-hidden=true]:!pointer-events-auto cursor-pointer z-[2147483648] transition-opacity duration-200 aria-[hidden=true]:delay-250",
    children: /* @__PURE__ */ (0, K.jsx)(yc, { size: 24 })
  }), b = document.createElement("button");
  h.appendChild(b), h.addEventListener("click", (s) => {
    s.target.closest("button")?.id === "close-btn" && window.GorgiasChat.close();
  }), b.outerHTML = (0, Cs.renderToStaticMarkup)(g);
});
function Rs(h, { timeout: g = 5e3, interval: b = 50 } = {}) {
  return new Promise((s, x) => {
    if (window[h]) return s(window[h]);
    const C = Date.now(), S = setInterval(() => {
      window[h] ? (clearInterval(S), s(window[h])) : Date.now() - C > g && (clearInterval(S), x(/* @__PURE__ */ new Error(`${h} not available after ${g}ms`)));
    }, b);
  });
}
function cu() {
  const h = document.querySelector(".dg-consent-banner");
  if (!h?.shadowRoot) return !1;
  const g = h.shadowRoot.querySelector(".dg-app > .dg-main-content-explanation");
  return g ? (g.innerHTML = `
    Shop Houzz uses cookies and similar technologies to enhance your experiences, analyze site traffic, personalize content, and deliver targeted advertising. We need your consent to use non-essential cookies. You can customize your preferences below. <a href="https://shophouzz.com/policies/privacy-policy" rel="noopener noreferrer">Cookie Policy</a>
  `, !0) : !1;
}
async function Ss() {
  try {
    if (await Rs("DG_BANNER_API"), cu()) return;
    let h = 0;
    const g = 20, b = setInterval(() => {
      h++, (cu() || h >= g) && clearInterval(b);
    }, 100);
  } catch (h) {
    console.warn("Consent banner API not available:", h);
  }
}
document.addEventListener("DOMContentLoaded", Ss);
